var Y = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Hn(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var x = { exports: {} };
x.exports;
(function(i, r) {
  var o = 200, t = "__lodash_hash_undefined__", u = 800, M = 16, h = 9007199254740991, R = "[object Arguments]", xa = "[object Array]", _a = "[object AsyncFunction]", qa = "[object Boolean]", Qa = "[object Date]", Xa = "[object Error]", Ma = "[object Function]", $a = "[object GeneratorFunction]", ae = "[object Map]", ee = "[object Number]", ne = "[object Null]", La = "[object Object]", ie = "[object Proxy]", re = "[object RegExp]", oe = "[object Set]", se = "[object String]", te = "[object Undefined]", ue = "[object WeakMap]", le = "[object ArrayBuffer]", de = "[object DataView]", me = "[object Float32Array]", Se = "[object Float64Array]", ge = "[object Int8Array]", ce = "[object Int16Array]", Me = "[object Int32Array]", Le = "[object Uint8Array]", Ae = "[object Uint8ClampedArray]", Ce = "[object Uint16Array]", he = "[object Uint32Array]", Be = /[\\^$.*+?()[\]{}|]/g, Te = /^\[object .+?Constructor\]$/, pe = /^(?:0|[1-9]\d*)$/, S = {};
  S[me] = S[Se] = S[ge] = S[ce] = S[Me] = S[Le] = S[Ae] = S[Ce] = S[he] = !0, S[R] = S[xa] = S[le] = S[qa] = S[de] = S[Qa] = S[Xa] = S[Ma] = S[ae] = S[ee] = S[La] = S[re] = S[oe] = S[se] = S[ue] = !1;
  var Aa = typeof Y == "object" && Y && Y.Object === Object && Y, Ge = typeof self == "object" && self && self.Object === Object && self, D = Aa || Ge || Function("return this")(), Ca = r && !r.nodeType && r, f = Ca && !0 && i && !i.nodeType && i, ha = f && f.exports === Ca, Q = ha && Aa.process, Ba = function() {
    try {
      var a = f && f.require && f.require("util").types;
      return a || Q && Q.binding && Q.binding("util");
    } catch {
    }
  }(), Ta = Ba && Ba.isTypedArray;
  function Ne(a, e, n) {
    switch (n.length) {
      case 0:
        return a.call(e);
      case 1:
        return a.call(e, n[0]);
      case 2:
        return a.call(e, n[0], n[1]);
      case 3:
        return a.call(e, n[0], n[1], n[2]);
    }
    return a.apply(e, n);
  }
  function Ee(a, e) {
    for (var n = -1, s = Array(a); ++n < a; )
      s[n] = e(n);
    return s;
  }
  function be(a) {
    return function(e) {
      return a(e);
    };
  }
  function ke(a, e) {
    return a == null ? void 0 : a[e];
  }
  function Ke(a, e) {
    return function(n) {
      return a(e(n));
    };
  }
  var Ie = Array.prototype, Pe = Function.prototype, Z = Object.prototype, X = D["__core-js_shared__"], z = Pe.toString, B = Z.hasOwnProperty, pa = function() {
    var a = /[^.]+$/.exec(X && X.keys && X.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }(), Ga = Z.toString, Re = z.call(Object), De = RegExp(
    "^" + z.call(B).replace(Be, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), F = ha ? D.Buffer : void 0, Na = D.Symbol, Ea = D.Uint8Array, ba = F ? F.allocUnsafe : void 0, ka = Ke(Object.getPrototypeOf, Object), Ka = Object.create, fe = Z.propertyIsEnumerable, ve = Ie.splice, G = Na ? Na.toStringTag : void 0, V = function() {
    try {
      var a = ea(Object, "defineProperty");
      return a({}, "", {}), a;
    } catch {
    }
  }(), ye = F ? F.isBuffer : void 0, Ia = Math.max, Oe = Date.now, Pa = ea(D, "Map"), v = ea(Object, "create"), Ue = function() {
    function a() {
    }
    return function(e) {
      if (!E(e))
        return {};
      if (Ka)
        return Ka(e);
      a.prototype = e;
      var n = new a();
      return a.prototype = void 0, n;
    };
  }();
  function N(a) {
    var e = -1, n = a == null ? 0 : a.length;
    for (this.clear(); ++e < n; ) {
      var s = a[e];
      this.set(s[0], s[1]);
    }
  }
  function He() {
    this.__data__ = v ? v(null) : {}, this.size = 0;
  }
  function Ze(a) {
    var e = this.has(a) && delete this.__data__[a];
    return this.size -= e ? 1 : 0, e;
  }
  function ze(a) {
    var e = this.__data__;
    if (v) {
      var n = e[a];
      return n === t ? void 0 : n;
    }
    return B.call(e, a) ? e[a] : void 0;
  }
  function Fe(a) {
    var e = this.__data__;
    return v ? e[a] !== void 0 : B.call(e, a);
  }
  function Ve(a, e) {
    var n = this.__data__;
    return this.size += this.has(a) ? 0 : 1, n[a] = v && e === void 0 ? t : e, this;
  }
  N.prototype.clear = He, N.prototype.delete = Ze, N.prototype.get = ze, N.prototype.has = Fe, N.prototype.set = Ve;
  function T(a) {
    var e = -1, n = a == null ? 0 : a.length;
    for (this.clear(); ++e < n; ) {
      var s = a[e];
      this.set(s[0], s[1]);
    }
  }
  function je() {
    this.__data__ = [], this.size = 0;
  }
  function we(a) {
    var e = this.__data__, n = j(e, a);
    if (n < 0)
      return !1;
    var s = e.length - 1;
    return n == s ? e.pop() : ve.call(e, n, 1), --this.size, !0;
  }
  function Je(a) {
    var e = this.__data__, n = j(e, a);
    return n < 0 ? void 0 : e[n][1];
  }
  function We(a) {
    return j(this.__data__, a) > -1;
  }
  function Ye(a, e) {
    var n = this.__data__, s = j(n, a);
    return s < 0 ? (++this.size, n.push([a, e])) : n[s][1] = e, this;
  }
  T.prototype.clear = je, T.prototype.delete = we, T.prototype.get = Je, T.prototype.has = We, T.prototype.set = Ye;
  function k(a) {
    var e = -1, n = a == null ? 0 : a.length;
    for (this.clear(); ++e < n; ) {
      var s = a[e];
      this.set(s[0], s[1]);
    }
  }
  function xe() {
    this.size = 0, this.__data__ = {
      hash: new N(),
      map: new (Pa || T)(),
      string: new N()
    };
  }
  function _e(a) {
    var e = J(this, a).delete(a);
    return this.size -= e ? 1 : 0, e;
  }
  function qe(a) {
    return J(this, a).get(a);
  }
  function Qe(a) {
    return J(this, a).has(a);
  }
  function Xe(a, e) {
    var n = J(this, a), s = n.size;
    return n.set(a, e), this.size += n.size == s ? 0 : 1, this;
  }
  k.prototype.clear = xe, k.prototype.delete = _e, k.prototype.get = qe, k.prototype.has = Qe, k.prototype.set = Xe;
  function K(a) {
    var e = this.__data__ = new T(a);
    this.size = e.size;
  }
  function $e() {
    this.__data__ = new T(), this.size = 0;
  }
  function an(a) {
    var e = this.__data__, n = e.delete(a);
    return this.size = e.size, n;
  }
  function en(a) {
    return this.__data__.get(a);
  }
  function nn(a) {
    return this.__data__.has(a);
  }
  function rn(a, e) {
    var n = this.__data__;
    if (n instanceof T) {
      var s = n.__data__;
      if (!Pa || s.length < o - 1)
        return s.push([a, e]), this.size = ++n.size, this;
      n = this.__data__ = new k(s);
    }
    return n.set(a, e), this.size = n.size, this;
  }
  K.prototype.clear = $e, K.prototype.delete = an, K.prototype.get = en, K.prototype.has = nn, K.prototype.set = rn;
  function on(a, e) {
    var n = ra(a), s = !n && ia(a), d = !n && !s && ya(a), m = !n && !s && !d && Ua(a), g = n || s || d || m, l = g ? Ee(a.length, String) : [], c = l.length;
    for (var C in a)
      (e || B.call(a, C)) && !(g && // Safari 9 has enumerable `arguments.length` in strict mode.
      (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      d && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      m && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
      fa(C, c))) && l.push(C);
    return l;
  }
  function $(a, e, n) {
    (n !== void 0 && !W(a[e], n) || n === void 0 && !(e in a)) && aa(a, e, n);
  }
  function sn(a, e, n) {
    var s = a[e];
    (!(B.call(a, e) && W(s, n)) || n === void 0 && !(e in a)) && aa(a, e, n);
  }
  function j(a, e) {
    for (var n = a.length; n--; )
      if (W(a[n][0], e))
        return n;
    return -1;
  }
  function aa(a, e, n) {
    e == "__proto__" && V ? V(a, e, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : a[e] = n;
  }
  var tn = Bn();
  function w(a) {
    return a == null ? a === void 0 ? te : ne : G && G in Object(a) ? Tn(a) : kn(a);
  }
  function Ra(a) {
    return y(a) && w(a) == R;
  }
  function un(a) {
    if (!E(a) || En(a))
      return !1;
    var e = sa(a) ? De : Te;
    return e.test(Rn(a));
  }
  function ln(a) {
    return y(a) && Oa(a.length) && !!S[w(a)];
  }
  function dn(a) {
    if (!E(a))
      return bn(a);
    var e = va(a), n = [];
    for (var s in a)
      s == "constructor" && (e || !B.call(a, s)) || n.push(s);
    return n;
  }
  function Da(a, e, n, s, d) {
    a !== e && tn(e, function(m, g) {
      if (d || (d = new K()), E(m))
        mn(a, e, g, n, Da, s, d);
      else {
        var l = s ? s(na(a, g), m, g + "", a, e, d) : void 0;
        l === void 0 && (l = m), $(a, g, l);
      }
    }, Ha);
  }
  function mn(a, e, n, s, d, m, g) {
    var l = na(a, n), c = na(e, n), C = g.get(c);
    if (C) {
      $(a, n, C);
      return;
    }
    var A = m ? m(l, c, n + "", a, e, g) : void 0, O = A === void 0;
    if (O) {
      var ta = ra(c), ua = !ta && ya(c), za = !ta && !ua && Ua(c);
      A = c, ta || ua || za ? ra(l) ? A = l : Dn(l) ? A = An(l) : ua ? (O = !1, A = cn(c, !0)) : za ? (O = !1, A = Ln(c, !0)) : A = [] : fn(c) || ia(c) ? (A = l, ia(l) ? A = vn(l) : (!E(l) || sa(l)) && (A = pn(c))) : O = !1;
    }
    O && (g.set(c, A), d(A, c, s, m, g), g.delete(c)), $(a, n, A);
  }
  function Sn(a, e) {
    return In(Kn(a, e, Za), a + "");
  }
  var gn = V ? function(a, e) {
    return V(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: On(e),
      writable: !0
    });
  } : Za;
  function cn(a, e) {
    if (e)
      return a.slice();
    var n = a.length, s = ba ? ba(n) : new a.constructor(n);
    return a.copy(s), s;
  }
  function Mn(a) {
    var e = new a.constructor(a.byteLength);
    return new Ea(e).set(new Ea(a)), e;
  }
  function Ln(a, e) {
    var n = e ? Mn(a.buffer) : a.buffer;
    return new a.constructor(n, a.byteOffset, a.length);
  }
  function An(a, e) {
    var n = -1, s = a.length;
    for (e || (e = Array(s)); ++n < s; )
      e[n] = a[n];
    return e;
  }
  function Cn(a, e, n, s) {
    var d = !n;
    n || (n = {});
    for (var m = -1, g = e.length; ++m < g; ) {
      var l = e[m], c = s ? s(n[l], a[l], l, n, a) : void 0;
      c === void 0 && (c = a[l]), d ? aa(n, l, c) : sn(n, l, c);
    }
    return n;
  }
  function hn(a) {
    return Sn(function(e, n) {
      var s = -1, d = n.length, m = d > 1 ? n[d - 1] : void 0, g = d > 2 ? n[2] : void 0;
      for (m = a.length > 3 && typeof m == "function" ? (d--, m) : void 0, g && Gn(n[0], n[1], g) && (m = d < 3 ? void 0 : m, d = 1), e = Object(e); ++s < d; ) {
        var l = n[s];
        l && a(e, l, s, m);
      }
      return e;
    });
  }
  function Bn(a) {
    return function(e, n, s) {
      for (var d = -1, m = Object(e), g = s(e), l = g.length; l--; ) {
        var c = g[a ? l : ++d];
        if (n(m[c], c, m) === !1)
          break;
      }
      return e;
    };
  }
  function J(a, e) {
    var n = a.__data__;
    return Nn(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
  }
  function ea(a, e) {
    var n = ke(a, e);
    return un(n) ? n : void 0;
  }
  function Tn(a) {
    var e = B.call(a, G), n = a[G];
    try {
      a[G] = void 0;
      var s = !0;
    } catch {
    }
    var d = Ga.call(a);
    return s && (e ? a[G] = n : delete a[G]), d;
  }
  function pn(a) {
    return typeof a.constructor == "function" && !va(a) ? Ue(ka(a)) : {};
  }
  function fa(a, e) {
    var n = typeof a;
    return e = e ?? h, !!e && (n == "number" || n != "symbol" && pe.test(a)) && a > -1 && a % 1 == 0 && a < e;
  }
  function Gn(a, e, n) {
    if (!E(n))
      return !1;
    var s = typeof e;
    return (s == "number" ? oa(n) && fa(e, n.length) : s == "string" && e in n) ? W(n[e], a) : !1;
  }
  function Nn(a) {
    var e = typeof a;
    return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? a !== "__proto__" : a === null;
  }
  function En(a) {
    return !!pa && pa in a;
  }
  function va(a) {
    var e = a && a.constructor, n = typeof e == "function" && e.prototype || Z;
    return a === n;
  }
  function bn(a) {
    var e = [];
    if (a != null)
      for (var n in Object(a))
        e.push(n);
    return e;
  }
  function kn(a) {
    return Ga.call(a);
  }
  function Kn(a, e, n) {
    return e = Ia(e === void 0 ? a.length - 1 : e, 0), function() {
      for (var s = arguments, d = -1, m = Ia(s.length - e, 0), g = Array(m); ++d < m; )
        g[d] = s[e + d];
      d = -1;
      for (var l = Array(e + 1); ++d < e; )
        l[d] = s[d];
      return l[e] = n(g), Ne(a, this, l);
    };
  }
  function na(a, e) {
    if (!(e === "constructor" && typeof a[e] == "function") && e != "__proto__")
      return a[e];
  }
  var In = Pn(gn);
  function Pn(a) {
    var e = 0, n = 0;
    return function() {
      var s = Oe(), d = M - (s - n);
      if (n = s, d > 0) {
        if (++e >= u)
          return arguments[0];
      } else
        e = 0;
      return a.apply(void 0, arguments);
    };
  }
  function Rn(a) {
    if (a != null) {
      try {
        return z.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  function W(a, e) {
    return a === e || a !== a && e !== e;
  }
  var ia = Ra(function() {
    return arguments;
  }()) ? Ra : function(a) {
    return y(a) && B.call(a, "callee") && !fe.call(a, "callee");
  }, ra = Array.isArray;
  function oa(a) {
    return a != null && Oa(a.length) && !sa(a);
  }
  function Dn(a) {
    return y(a) && oa(a);
  }
  var ya = ye || Un;
  function sa(a) {
    if (!E(a))
      return !1;
    var e = w(a);
    return e == Ma || e == $a || e == _a || e == ie;
  }
  function Oa(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= h;
  }
  function E(a) {
    var e = typeof a;
    return a != null && (e == "object" || e == "function");
  }
  function y(a) {
    return a != null && typeof a == "object";
  }
  function fn(a) {
    if (!y(a) || w(a) != La)
      return !1;
    var e = ka(a);
    if (e === null)
      return !0;
    var n = B.call(e, "constructor") && e.constructor;
    return typeof n == "function" && n instanceof n && z.call(n) == Re;
  }
  var Ua = Ta ? be(Ta) : ln;
  function vn(a) {
    return Cn(a, Ha(a));
  }
  function Ha(a) {
    return oa(a) ? on(a, !0) : dn(a);
  }
  var yn = hn(function(a, e, n) {
    Da(a, e, n);
  });
  function On(a) {
    return function() {
      return a;
    };
  }
  function Za(a) {
    return a;
  }
  function Un() {
    return !1;
  }
  i.exports = yn;
})(x, x.exports);
var Zn = x.exports;
const zn = /* @__PURE__ */ Hn(Zn), Fn = {
  rules: {
    consumer: {
      phoneCode: "376"
    }
  }
}, Vn = {
  defaultLanguage: "en-AE",
  supportedLanguages: [
    "en-GB"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      line3: {
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        required: !1,
        regex: "^[a-zA-Z0-9]+$"
      }
    },
    consumer: {
      phoneCode: "971",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "## ### ####"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "800-0444-0043",
  showInLocaleSelector: !0
}, jn = {
  rules: {
    consumer: {
      phoneCode: "93"
    }
  }
}, wn = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Jn = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Wn = {
  rules: {
    consumer: {
      phoneCode: "355"
    }
  }
}, Yn = {
  rules: {
    consumer: {
      phoneCode: "374"
    }
  }
}, xn = {
  rules: {
    consumer: {
      phoneCode: "244"
    }
  }
}, _n = {
  defaultLanguage: "es-AR",
  supportedLanguages: [
    "es-AR"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        maximumLength: 8,
        minimumLength: 5,
        mask: [
          "A####",
          "A####AAA"
        ]
      }
    },
    consumer: {
      phoneCode: "54",
      phoneNumber: {
        maximumLength: 10,
        minimumLength: 10,
        mask: [
          "##########"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "0800-266-7550",
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, qn = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Qn = {
  defaultLanguage: "de-AT",
  supportedLanguages: [
    "de-AT"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        maximumLength: 4,
        minimumLength: 4,
        regex: "^\\d{4}$",
        mask: [
          "####"
        ]
      }
    },
    consumer: {
      phoneCode: "43",
      phoneNumber: {
        minimumLength: 10,
        maximumLength: 12,
        mask: [
          "### #########"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+43 (0800 909 569)",
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "lineFields",
    "zip",
    "city",
    "country"
  ],
  showInLocaleSelector: !0
}, Xn = {
  defaultLanguage: "en-AU",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        type: "enum",
        enum: [
          "ACT",
          "NSW",
          "NT",
          "QLD",
          "SA",
          "TAS",
          "VIC",
          "WA"
        ]
      },
      postalCode: {
        maximumLength: 4,
        minimumLength: 4,
        regex: "^\\d{4}$",
        mask: [
          "####"
        ]
      }
    },
    consumer: {
      phoneCode: "61",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "### ### ###"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1800-569-012",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, $n = {
  rules: {
    consumer: {
      phoneCode: "297"
    }
  }
}, ai = {
  rules: {
    consumer: {
      phoneCode: "994"
    }
  }
}, ei = {
  rules: {
    consumer: {
      phoneCode: "387"
    }
  }
}, ni = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, ii = {
  rules: {
    consumer: {
      phoneCode: "880"
    }
  }
}, ri = {
  defaultLanguage: "fr-BE",
  supportedLanguages: [
    "fr-BE",
    "nl-BE",
    "de-DE",
    "en-GB"
  ],
  rules: {
    address: {
      line1: {
        required: !0
      },
      line2: {
        required: !1,
        enabled: !0
      },
      line3: {
        enabled: !1
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        maximumLength: 4,
        minimumLength: 4,
        regex: "^\\d{4}$",
        mask: [
          "####"
        ]
      }
    },
    consumer: {
      phoneCode: "32",
      phoneNumber: {
        mask: [
          "### ## ## ##"
        ],
        maximumLength: 9,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "0800-8-9322",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, oi = {
  rules: {
    consumer: {
      phoneCode: "226"
    }
  }
}, si = {
  defaultLanguage: "bg-BG",
  supportedLanguages: [
    "bg-BG"
  ],
  rules: {
    address: {
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "359",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "### ### ###"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "800-110-01-92",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, ti = {
  defaultLanguage: "en-BH",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      line2: {
        required: !0
      },
      cityTown: {
        enabled: !1
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        required: !1,
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "973",
      phoneNumber: {
        mask: [
          "#### ####"
        ],
        minimumLength: 8,
        maximumLength: 8,
        noLeadingNumber: !1
      }
    }
  },
  customerSupportPhoneNumber: "00973-8008-0408",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  showInLocaleSelector: !0
}, ui = {
  rules: {
    consumer: {
      phoneCode: "257"
    }
  }
}, li = {
  rules: {
    consumer: {
      phoneCode: "229"
    }
  }
}, di = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, mi = {
  rules: {
    consumer: {
      phoneCode: "673"
    }
  }
}, Si = {
  rules: {
    consumer: {
      phoneCode: "591"
    }
  }
}, gi = {
  rules: {
    consumer: {
      phoneCode: "599"
    }
  }
}, ci = {
  defaultLanguage: "pt-BR",
  supportedLanguages: [
    "pt-BR"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      line3: {
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        type: "enum",
        enum: [
          "AC",
          "AL",
          "AM",
          "AP",
          "BA",
          "CE",
          "DF",
          "ES",
          "GO",
          "MA",
          "MG",
          "MS",
          "MT",
          "PA",
          "PB",
          "PE",
          "PI",
          "PR",
          "RJ",
          "RN",
          "RO",
          "RR",
          "RS",
          "SC",
          "SE",
          "SP",
          "TO"
        ]
      },
      postalCode: {
        maximumLength: 9,
        minimumLength: 8,
        regex: "^\\d{5}-?\\d{3}$",
        mask: [
          "#####-###"
        ]
      }
    },
    consumer: {
      nationalId: {
        type: "any",
        required: !0,
        supported: !0,
        updatable: !1,
        maximumLength: 11,
        minimumLength: 11,
        regex: "^\\d{11}$",
        mask: [
          "###.###.###-##"
        ],
        maskingPercentage: 70,
        checksumAlgo: "CPF",
        example: "23100299900"
      },
      phoneCode: "55",
      phoneNumber: {
        minimumLength: 11,
        mask: [
          "(##) #####-####"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "1-800-047-4775",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    [
      "complemento",
      "neighborhood"
    ],
    "city",
    [
      "state",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, Mi = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Li = {
  rules: {
    consumer: {
      phoneCode: "975"
    }
  }
}, Ai = {
  rules: {
    consumer: {
      phoneCode: "267"
    }
  }
}, Ci = {
  rules: {
    consumer: {
      phoneCode: "375"
    }
  }
}, hi = {
  rules: {
    consumer: {
      phoneCode: "501"
    }
  }
}, Bi = {
  defaultLanguage: "en-CA",
  supportedLanguages: [
    "en-US",
    "fr-CA"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        type: "enum",
        enum: [
          "AB",
          "BC",
          "MB",
          "NB",
          "NL",
          "NT",
          "NS",
          "NU",
          "ON",
          "PE",
          "QC",
          "SK",
          "YT"
        ]
      },
      postalCode: {
        maximumLength: 7,
        minimumLength: 6,
        regex: "^[A-Za-z]\\d[A-Za-z][\\s]?\\d[A-Za-z]\\d$",
        mask: [
          "A#A #A#"
        ]
      }
    },
    consumer: {
      phoneCode: "1",
      phoneNumber: {
        mask: [
          "### ###-####"
        ],
        minimumLength: 10,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-833-951-2474",
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT"
  ],
  showInLocaleSelector: !0
}, Ti = {
  rules: {
    consumer: {
      phoneCode: "243"
    }
  }
}, pi = {
  rules: {
    consumer: {
      phoneCode: "236"
    }
  }
}, Gi = {
  rules: {
    consumer: {
      phoneCode: "242"
    }
  }
}, Ni = {
  defaultLanguage: "de-CH",
  supportedLanguages: [
    "de-CH",
    "fr-FR",
    "en-GB",
    "it-IT"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      }
    },
    consumer: {
      phoneCode: "41",
      phoneNumber: {
        mask: [
          "## ### ## ##"
        ],
        maximumLength: 12,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "0800 005 644",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Ei = {
  rules: {
    consumer: {
      phoneCode: "225"
    }
  }
}, bi = {
  rules: {
    consumer: {
      phoneCode: "682"
    }
  }
}, ki = {
  defaultLanguage: "es-CL",
  supportedLanguages: [
    "es-CL"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      line3: {
        required: !0,
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        maximumLength: 30,
        required: !0
      },
      postalCode: {
        required: !1,
        minimumLength: 7,
        regex: "^\\d{7}$",
        mask: [
          "#######"
        ]
      }
    },
    consumer: {
      phoneCode: "56",
      phoneNumber: {
        mask: [
          "9 #### ####"
        ],
        minimumLength: 9,
        maximumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "800-392-321",
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, Ki = {
  rules: {
    consumer: {
      phoneCode: "237"
    }
  }
}, Ii = {
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        maximumLength: 6,
        minimumLength: 6,
        regex: "^\\d{6}$",
        mask: [
          "######"
        ]
      }
    },
    consumer: {
      phoneCode: "86"
    }
  }
}, Pi = {
  defaultLanguage: "es-CO",
  supportedLanguages: [
    "es-CO"
  ],
  rules: {
    address: {
      line3: {
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        required: !1,
        maximumLength: 6,
        minimumLength: 6,
        regex: "^\\d{6}$",
        mask: [
          "######"
        ]
      }
    },
    consumer: {
      phoneCode: "57",
      phoneNumber: {
        maximumLength: 10,
        minimumLength: 10,
        mask: [
          "##########"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "01-800-012-9216",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "state",
    "city",
    "zip"
  ],
  showInLocaleSelector: !0
}, Ri = {
  defaultLanguage: "es-CR",
  supportedLanguages: [
    "es-CR"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        maximumLength: 30
      },
      postalCode: {
        required: !1,
        maximumLength: 10
      }
    },
    consumer: {
      phoneCode: "506",
      phoneNumber: {
        mask: [
          "#### ####"
        ],
        minimumLength: 8,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(506)65743820",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, Di = {
  rules: {
    consumer: {
      phoneCode: "53"
    }
  }
}, fi = {
  rules: {
    consumer: {
      phoneCode: "238"
    }
  }
}, vi = {
  rules: {
    consumer: {
      phoneCode: "599"
    }
  }
}, yi = {
  rules: {
    consumer: {
      phoneCode: "357"
    }
  }
}, Oi = {
  defaultLanguage: "cs-CZ",
  supportedLanguages: [
    "cs-CZ",
    "en-GB"
  ],
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        required: !1,
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "420",
      phoneNumber: {
        mask: [
          "### ### ###"
        ],
        maximumLength: 11,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "800-050-822",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Ui = {
  genericSettings: {
    billingAddressFormat: "POSTAL_CODE"
  },
  defaultLanguage: "de-DE",
  supportedLanguages: [
    "de-DE",
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !1,
        enabled: !1
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "49",
      phoneNumber: {
        mask: [
          "### ########"
        ],
        maximumLength: 12,
        minimumLength: 9,
        noLeadingNumber: !1
      }
    }
  },
  customerSupportPhoneNumber: "0800-752-2593",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Hi = {
  rules: {
    consumer: {
      phoneCode: "253"
    }
  }
}, Zi = {
  defaultLanguage: "da-DK",
  supportedLanguages: [
    "da-DK"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "45",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "## ## ## ## ## ## ## ##*"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+45 80-81-07-05",
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  showInLocaleSelector: !0
}, zi = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Fi = {
  defaultLanguage: "es-DO",
  supportedLanguages: [
    "es-DO"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        maximumLength: 30
      },
      postalCode: {
        required: !1,
        maximumLength: 5,
        minimumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "1",
      phoneNumber: {
        minimumLength: 10,
        mask: [
          "###-###-####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-800-148-5602",
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, Vi = {
  rules: {
    consumer: {
      phoneCode: "213"
    }
  }
}, ji = {
  defaultLanguage: "es-EC",
  supportedLanguages: [
    "es-EC"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        maximumLength: 30
      },
      postalCode: {
        required: !1,
        maximumLength: 6,
        minimumLength: 6,
        regex: "^\\d{6}$",
        mask: [
          "######"
        ]
      }
    },
    consumer: {
      phoneCode: "593",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "## ### ####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-800-000-1558",
  beta: !0,
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, wi = {
  defaultLanguage: "et-EE",
  supportedLanguages: [
    "et-EE"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        maximumLength: 8
      }
    },
    consumer: {
      phoneCode: "372",
      phoneNumber: {
        mask: [
          "### ####*"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(372)8000044846",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Ji = {
  defaultLanguage: "en-EG",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      line1: {
        maximumLength: 50
      },
      line2: {
        maximumLength: 50
      },
      cityTown: {
        maximumLength: 30,
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        required: !1,
        minimumLength: 0,
        maximumLength: 7,
        regex: "^\\d*$",
        mask: [
          "#*"
        ]
      }
    },
    consumer: {
      phoneCode: "20",
      phoneNumber: {
        minimumLength: 10,
        maximumLength: 10,
        mask: [
          "##########"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(0800) 006-0540",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "zip"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Wi = {
  defaultLanguage: "es-ES",
  supportedLanguages: [
    "es-ES",
    "en-GB"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        maximumLength: 30
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 16,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "34",
      phoneNumber: {
        mask: [
          "### ### ###"
        ],
        maximumLength: 11,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "900-03-1012",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Yi = {
  rules: {
    consumer: {
      phoneCode: "251"
    }
  }
}, xi = {
  defaultLanguage: "fi-FI",
  supportedLanguages: [
    "fi-FI",
    "sv-FI"
  ],
  rules: {
    address: {
      subdivision: {
        maximumLength: 30
      }
    },
    consumer: {
      phoneCode: "358",
      phoneNumber: {
        mask: [
          "## ########"
        ],
        minimumLength: 5,
        maximumLength: 10,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "080-077-41-42",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, _i = {
  rules: {
    consumer: {
      phoneCode: "679"
    }
  }
}, qi = {
  defaultLanguage: "fr-FR",
  supportedLanguages: [
    "fr-FR"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "33",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "# ## ## ## ##"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(33)0805543089",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "EXPLICIT_TERMS_CONSENT"
  ],
  showInLocaleSelector: !0
}, Qi = {
  rules: {
    consumer: {
      phoneCode: "241"
    }
  }
}, Xi = {
  defaultLanguage: "en-GB",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !1,
        enabled: !1
      },
      postalCode: {
        maximumLength: 8,
        minimumLength: 5,
        mask: [
          "A# #AA",
          "AXX #AA",
          "AA#X #AA"
        ]
      }
    },
    consumer: {
      phoneCode: "44",
      phoneNumber: {
        minimumLength: 10,
        mask: [
          "#### ######"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "0800-145-6531",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  showInLocaleSelector: !0
}, $i = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, ar = {
  defaultLanguage: "ka-GE",
  supportedLanguages: [
    "ka-GE"
  ],
  rules: {
    consumer: {
      phoneCode: "995"
    }
  }
}, er = {
  rules: {
    consumer: {
      phoneCode: "233"
    }
  }
}, nr = {
  rules: {
    consumer: {
      phoneCode: "350"
    }
  }
}, ir = {
  rules: {
    consumer: {
      phoneCode: "220"
    }
  }
}, rr = {
  rules: {
    consumer: {
      phoneCode: "224"
    }
  }
}, or = {
  rules: {
    consumer: {
      phoneCode: "240"
    }
  }
}, sr = {
  defaultLanguage: "el-GR",
  supportedLanguages: [
    "el-GR"
  ],
  rules: {
    address: {
      line1: {
        maximumLength: 100,
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        maximumLength: 58,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "30",
      phoneNumber: {
        minimumLength: 10,
        mask: [
          "##########"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportEmail: "support.checkout@mastercard.com",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, tr = {
  defaultLanguage: "es-GT",
  supportedLanguages: [
    "es-GT"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        maximumLength: 5,
        minimumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "502",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "####-####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-800-375-0039",
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, ur = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, lr = {
  rules: {
    consumer: {
      phoneCode: "245"
    }
  }
}, dr = {
  rules: {
    consumer: {
      phoneCode: "592"
    }
  }
}, mr = {
  defaultLanguage: "en-HK",
  supportedLanguages: [
    "en-GB",
    "zh-HK"
  ],
  rules: {
    address: {
      fullName: {
        required: !0,
        regex: ".+"
      },
      line1: {
        enabled: !0,
        regex: ".+"
      },
      line2: {
        enabled: !0,
        regex: ".*"
      },
      line3: {
        enabled: !0,
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        required: !0,
        regex: ".+"
      },
      postalCode: {
        required: !1,
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "852",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "#### ####"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "800-905821",
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Sr = {
  defaultLanguage: "es-HN",
  supportedLanguages: [
    "es-HN"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        maximumLength: 5,
        minimumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "504",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "####-####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "800 2791-9400",
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, gr = {
  defaultLanguage: "hr-HR",
  supportedLanguages: [
    "hr-HR",
    "en-GB"
  ],
  rules: {
    address: {
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        minimumLength: 5,
        maximumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "385",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 10,
        noLeadingNumber: !0,
        regex: "^\\d{9,10}$",
        mask: [
          "## ### ####",
          "### ### ####"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "+385 0800 222667",
  beta: !0,
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, cr = {
  rules: {
    consumer: {
      phoneCode: "509"
    }
  }
}, Mr = {
  defaultLanguage: "hu-HU",
  supportedLanguages: [
    "hu-HU"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "36",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "## ### ####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "06-80-993-028",
  addressFieldsSortOrder: [
    "name",
    "city",
    "lineFields",
    "zip",
    "country"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Lr = {
  defaultLanguage: "id-ID",
  supportedLanguages: [
    "id-ID"
  ],
  rules: {
    consumer: {
      phoneCode: "62"
    }
  }
}, Ar = {
  defaultLanguage: "en-IE",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        maximumLength: 30,
        required: !1
      },
      postalCode: {
        maximumLength: 16,
        minimumLength: 7,
        regex: "^[A-Za-z]\\d[0-9A-Za-z] ?[0-9A-Za-z]{4}$",
        mask: [
          "A#X XXXX"
        ],
        required: !1
      }
    },
    consumer: {
      phoneCode: "353",
      phoneNumber: {
        mask: [
          "## ### ####"
        ],
        maximumLength: 11,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-800-94-6222",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, Cr = {
  defaultLanguage: "en-IL",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      line1: {},
      line2: {},
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        minimumLength: 7,
        maximumLength: 7,
        regex: "^\\d{7}$",
        mask: [
          "#######"
        ]
      }
    },
    consumer: {
      phoneCode: "972",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "## #######"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+972 1 809 418 526",
  beta: !0,
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, hr = {
  defaultLanguage: "en-IN",
  supportedLanguages: [
    "en-IN",
    "hi-IN"
  ],
  rules: {
    address: {
      line1: {
        required: !0
      },
      line2: {
        required: !1,
        enabled: !0
      },
      line3: {
        required: !1,
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        type: "enum",
        enum: [
          "Andaman and Nicobar Islands",
          "Andhra Pradesh",
          "Arunachal Pradesh",
          "Assam",
          "Bihar",
          "Chandigarh",
          "Chhattisgarh",
          "Dadra Nagar Haveli Daman Diu",
          "Delhi",
          "Goa",
          "Gujarat",
          "Haryana",
          "Himachal Pradesh",
          "Jammu and Kashmir",
          "Jharkhand",
          "Karnataka",
          "Kerala",
          "Ladakh",
          "Lakshadweep",
          "Madhya Pradesh",
          "Maharashtra",
          "Manipur",
          "Meghalaya",
          "Mizoram",
          "Nagaland",
          "Odisha",
          "Puducherry",
          "Punjab",
          "Rajasthan",
          "Sikkim",
          "Tamil Nadu",
          "Telangana",
          "Tripura",
          "Uttar Pradesh",
          "Uttarakhand",
          "West Bengal"
        ]
      },
      postalCode: {
        maximumLength: 6,
        minimumLength: 6,
        regex: "^\\d{6}$"
      }
    },
    consumer: {
      phoneCode: "91",
      phoneNumber: {
        mask: [
          "##### #####"
        ],
        maximumLength: 10,
        minimumLength: 10,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "800-000-0000",
  beta: !0,
  betaLanguages: [
    "hi-IN"
  ],
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Br = {
  rules: {
    consumer: {
      phoneCode: "964"
    }
  }
}, Tr = {
  rules: {
    consumer: {
      phoneCode: "354"
    }
  }
}, pr = {
  defaultLanguage: "it-IT",
  supportedLanguages: [
    "it-IT",
    "en-GB"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        type: "enum",
        enum: [
          "AG",
          "AL",
          "AN",
          "AO",
          "AP",
          "AQ",
          "AR",
          "AT",
          "AV",
          "BA",
          "BG",
          "BI",
          "BL",
          "BN",
          "BO",
          "BR",
          "BS",
          "BT",
          "BZ",
          "CA",
          "CB",
          "CE",
          "CH",
          "CI",
          "CL",
          "CN",
          "CO",
          "CR",
          "CS",
          "CT",
          "CZ",
          "EN",
          "FC",
          "FE",
          "FG",
          "FI",
          "FM",
          "FR",
          "GE",
          "GO",
          "GR",
          "IM",
          "IS",
          "KR",
          "LC",
          "LE",
          "LI",
          "LO",
          "LT",
          "LU",
          "MB",
          "MC",
          "ME",
          "MI",
          "MN",
          "MO",
          "MS",
          "MT",
          "NA",
          "NO",
          "NU",
          "OG",
          "OR",
          "OT",
          "PA",
          "PC",
          "PD",
          "PE",
          "PG",
          "PI",
          "PN",
          "PO",
          "PR",
          "PT",
          "PU",
          "PV",
          "PZ",
          "RA",
          "RC",
          "RE",
          "RG",
          "RI",
          "RM",
          "RN",
          "RO",
          "SA",
          "SI",
          "SO",
          "SP",
          "SR",
          "SS",
          "SV",
          "TA",
          "TE",
          "TN",
          "TO",
          "TP",
          "TR",
          "TS",
          "TV",
          "UD",
          "VA",
          "VB",
          "VC",
          "VE",
          "VI",
          "VR",
          "VS",
          "VT",
          "VV"
        ]
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "39",
      phoneNumber: {
        mask: [
          "##########"
        ],
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "800-928-001",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "zip",
    "state"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Gr = {
  rules: {
    consumer: {
      phoneCode: "44-1534"
    }
  }
}, Nr = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Er = {
  defaultLanguage: "en-JO",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      line1: {
        maximumLength: 50
      },
      line2: {
        maximumLength: 50,
        required: !0
      },
      cityTown: {
        maximumLength: 20,
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        maximumLength: 12,
        required: !1
      }
    },
    consumer: {
      phoneCode: "962",
      phoneNumber: {
        mask: [
          "7########"
        ],
        maximumLength: 9,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(962)80023141",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "zip"
  ],
  showInLocaleSelector: !0
}, br = {
  defaultLanguage: "en-JP",
  supportedLanguages: [
    "en-JP"
  ],
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        enabled: !1
      },
      subdivision: {
        required: !0,
        regex: ".+"
      },
      postalCode: {
        regex: "^\\d{3}-?\\d{4}",
        maximumLength: 8,
        minimumLength: 7,
        mask: [
          "###-####"
        ]
      }
    },
    consumer: {
      phoneCode: "81"
    }
  }
}, kr = {
  defaultLanguage: "en-KE",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      line1: {
        maximumLength: 50
      },
      line2: {
        maximumLength: 50
      },
      cityTown: {
        required: !0,
        maximumLength: 20
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        required: !1,
        maximumLength: 12
      }
    },
    consumer: {
      phoneCode: "254",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "#########"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(254)203893554",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "zip"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Kr = {
  rules: {
    consumer: {
      phoneCode: "996"
    }
  }
}, Ir = {
  defaultLanguage: "en-KH",
  supportedLanguages: [
    "en-KH"
  ],
  rules: {
    consumer: {
      phoneCode: "855"
    }
  }
}, Pr = {
  rules: {
    consumer: {
      phoneCode: "686"
    }
  }
}, Rr = {
  rules: {
    consumer: {
      phoneCode: "269"
    }
  }
}, Dr = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, fr = {
  rules: {
    consumer: {
      phoneCode: "82"
    }
  }
}, vr = {
  defaultLanguage: "en-KW",
  supportedLanguages: [
    "en-GB"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      line2: {
        required: !0
      },
      line3: {
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !1,
        enabled: !1
      },
      postalCode: {
        required: !1
      }
    },
    consumer: {
      phoneCode: "965",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "########"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "+965 2207 0893",
  showInLocaleSelector: !0
}, yr = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Or = {
  rules: {
    consumer: {
      phoneCode: "7"
    }
  }
}, Ur = {
  rules: {
    consumer: {
      phoneCode: "856"
    }
  }
}, Hr = {
  rules: {
    consumer: {
      phoneCode: "961"
    }
  }
}, Zr = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, zr = {
  rules: {
    consumer: {
      phoneCode: "423"
    }
  }
}, Fr = {
  rules: {
    consumer: {
      phoneCode: "94"
    }
  }
}, Vr = {
  rules: {
    consumer: {
      phoneCode: "231"
    }
  }
}, jr = {
  rules: {
    consumer: {
      phoneCode: "266"
    }
  }
}, wr = {
  defaultLanguage: "lt-LT",
  supportedLanguages: [
    "lt-LT"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        maximumLength: 8
      }
    },
    consumer: {
      phoneCode: "370",
      phoneNumber: {
        mask: [
          "#######*"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(370)880030138",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Jr = {
  rules: {
    consumer: {
      phoneCode: "352"
    }
  }
}, Wr = {
  defaultLanguage: "lv-LV",
  supportedLanguages: [
    "lv-LV"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        maximumLength: 8
      }
    },
    consumer: {
      phoneCode: "371",
      phoneNumber: {
        mask: [
          "#######*"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "(371)80000061",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Yr = {
  rules: {
    consumer: {
      phoneCode: "218"
    }
  }
}, xr = {
  defaultLanguage: "en-MA",
  supportedLanguages: [
    "en-TH",
    "th-MA"
  ],
  rules: {
    consumer: {
      phoneCode: "212"
    }
  }
}, _r = {
  rules: {
    consumer: {
      phoneCode: "373"
    }
  }
}, qr = {
  rules: {
    consumer: {
      phoneCode: "382"
    }
  }
}, Qr = {
  rules: {
    consumer: {
      phoneCode: "261"
    }
  }
}, Xr = {
  defaultLanguage: "en-HK",
  supportedLanguages: [
    "en-GB",
    "zh-HK"
  ],
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      line3: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        required: !0,
        regex: ".+"
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      email: {
        regex: "^((?!\\.\\.)[^@\\s])+@([^@.\\s]+\\.)+[^@.\\s]{2,}$"
      },
      phoneCode: "692"
    }
  },
  beta: !0,
  showInLocaleSelector: !0
}, $r = {
  rules: {
    consumer: {
      phoneCode: "389"
    }
  }
}, ao = {
  rules: {
    consumer: {
      phoneCode: "223"
    }
  }
}, eo = {
  rules: {
    consumer: {
      phoneCode: "95"
    }
  }
}, no = {
  rules: {
    consumer: {
      phoneCode: "976"
    }
  }
}, io = {
  rules: {
    consumer: {
      phoneCode: "853"
    }
  }
}, ro = {
  rules: {
    consumer: {
      phoneCode: "222"
    }
  }
}, oo = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, so = {
  rules: {
    consumer: {
      phoneCode: "356"
    }
  }
}, to = {
  rules: {
    consumer: {
      phoneCode: "230"
    }
  }
}, uo = {
  rules: {
    consumer: {
      phoneCode: "960"
    }
  }
}, lo = {
  rules: {
    consumer: {
      phoneCode: "265"
    }
  }
}, mo = {
  defaultLanguage: "es-MX",
  supportedLanguages: [
    "es-MX"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        type: "enum",
        enum: [
          "Aguascalientes",
          "Baja California",
          "Baja California Sur",
          "Campeche",
          "Chiapas",
          "Chihuahua",
          "Ciudad de México",
          "Coahuila",
          "Colima",
          "Durango",
          "Guanajuato",
          "Guerrero",
          "Hidalgo",
          "Jalisco",
          "México",
          "Michoacán",
          "Morelos",
          "Nayarit",
          "Nuevo León",
          "Oaxaca",
          "Puebla",
          "Querétaro",
          "Quintana Roo",
          "San Luis Potosí",
          "Sinaloa",
          "Sonora",
          "Tabasco",
          "Tamaulipas",
          "Tlaxcala",
          "Veracruz",
          "Yucatán",
          "Zacatecas"
        ]
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "52",
      phoneNumber: {
        minimumLength: 10,
        mask: [
          "##########"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "800-288-9873",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, So = {
  defaultLanguage: "ms-MY",
  supportedLanguages: [
    "ms-MY",
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        maximumLength: 5,
        minimumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "60",
      phoneNumber: {
        mask: [
          "## ### ####",
          "## #### ####"
        ],
        maximumLength: 12,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-800-889-037",
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT"
  ],
  showInLocaleSelector: !0
}, go = {
  rules: {
    consumer: {
      phoneCode: "258"
    }
  }
}, co = {
  rules: {
    consumer: {
      phoneCode: "264"
    }
  }
}, Mo = {
  rules: {
    consumer: {
      phoneCode: "227"
    }
  }
}, Lo = {
  defaultLanguage: "en-NG",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      line1: {
        maximumLength: 50
      },
      line2: {
        maximumLength: 50
      },
      cityTown: {
        required: !0,
        maximumLength: 20
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        required: !1,
        maximumLength: 12
      }
    },
    consumer: {
      phoneCode: "234",
      phoneNumber: {
        minimumLength: 10,
        maximumLength: 10,
        mask: [
          "### #######"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+234 (708) 060-1534",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "zip"
  ],
  showInLocaleSelector: !0
}, Ao = {
  defaultLanguage: "es-NI",
  supportedLanguages: [
    "es-NI"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        maximumLength: 5,
        minimumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "505",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "#### ####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-800-220-2580",
  beta: !0,
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, Co = {
  defaultLanguage: "nl-NL",
  supportedLanguages: [
    "nl-NL"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        regex: "^\\d{4} ?[A-Za-z]{2}$",
        maximumLength: 7,
        minimumLength: 6,
        mask: [
          "#### AA"
        ]
      }
    },
    consumer: {
      phoneCode: "31",
      phoneNumber: {
        mask: [
          "# #### ####"
        ],
        maximumLength: 11,
        minimumLength: 9
      }
    }
  },
  customerSupportPhoneNumber: "0800-928-001",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, ho = {
  defaultLanguage: "nb-NO",
  supportedLanguages: [
    "nb-NO",
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !1,
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "47",
      phoneNumber: {
        mask: [
          "### #####"
        ],
        maximumLength: 9,
        minimumLength: 8
      }
    }
  },
  customerSupportPhoneNumber: "800-40-381",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Bo = {
  rules: {
    consumer: {
      phoneCode: "977"
    }
  }
}, To = {
  defaultLanguage: "en-NZ",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        regex: "^\\d{4}$",
        maximumLength: 4,
        minimumLength: 4,
        mask: [
          "####"
        ]
      }
    },
    consumer: {
      phoneCode: "64",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "##########"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "0508-63-3253",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE",
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "zip"
  ],
  showInLocaleSelector: !0
}, po = {
  rules: {
    consumer: {
      phoneCode: "968"
    }
  }
}, Go = {
  defaultLanguage: "es-PA",
  supportedLanguages: [
    "es-PA"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        required: !1,
        maximumLength: 5,
        minimumLength: 4,
        regex: "^\\d{4,5}$",
        mask: [
          "####",
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "507",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "#### ####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "308 4481",
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, No = {
  defaultLanguage: "es-PE",
  supportedLanguages: [
    "es-PE"
  ],
  rules: {
    address: {
      line3: {
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        regex: "^\\d{2,5}$",
        maximumLength: 5,
        minimumLength: 2,
        mask: [
          "##*"
        ]
      }
    },
    consumer: {
      phoneCode: "51"
    }
  },
  customerSupportPhoneNumber: "800 77040",
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, Eo = {
  rules: {
    consumer: {
      phoneCode: "675"
    }
  }
}, bo = {
  defaultLanguage: "en-PH",
  supportedLanguages: [
    "en-US"
  ],
  rules: {
    address: {
      subdivision: {
        maximumLength: 30
      }
    },
    consumer: {
      phoneCode: "63",
      phoneNumber: {
        mask: [
          "(###) ### ####"
        ],
        minimumLength: 10,
        maximumLength: 10,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+63 (1800) 1-441-1187",
  features: [
    "EXPLICIT_PRIVACY_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, ko = {
  rules: {
    consumer: {
      phoneCode: "92"
    }
  }
}, Ko = {
  defaultLanguage: "pl-PL",
  supportedLanguages: [
    "pl-PL",
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !1,
        enabled: !1
      },
      postalCode: {
        maximumLength: 16
      }
    },
    consumer: {
      phoneCode: "48",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "### ### ###"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+48 800-012-977",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  showInLocaleSelector: !0
}, Io = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Po = {
  rules: {
    consumer: {
      phoneCode: "970"
    }
  }
}, Ro = {
  defaultLanguage: "pt-PT",
  supportedLanguages: [
    "pt-PT"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        maximumLength: 8
      }
    },
    consumer: {
      phoneCode: "351",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "### ### ###"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+351 800-210-153",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  showInLocaleSelector: !0
}, Do = {
  defaultLanguage: "es-PY",
  supportedLanguages: [
    "es-PY"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        maximumLength: 6,
        minimumLength: 6,
        regex: "^\\d{6}$",
        mask: [
          "######"
        ]
      }
    },
    consumer: {
      phoneCode: "595",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "### ######"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "98004410245",
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, fo = {
  defaultLanguage: "en-QA",
  supportedLanguages: [
    "en-GB"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      line2: {
        required: !0
      },
      line3: {
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !1,
        enabled: !1
      },
      postalCode: {
        required: !1
      }
    },
    consumer: {
      phoneCode: "974",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "#### ####"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "+800-101053",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, vo = {
  defaultLanguage: "ro-RO",
  supportedLanguages: [
    "ro-RO"
  ],
  rules: {
    address: {
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "40",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "### ### ###"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "0800-400-672",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, yo = {
  defaultLanguage: "sr-RS",
  supportedLanguages: [
    "sr-RS",
    "en-GB"
  ],
  rules: {
    address: {
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        minimumLength: 5,
        maximumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "381",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "## #### ###"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "0800301138",
  beta: !0,
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city"
  ],
  features: [
    "DISABLE_FEEDBACK",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Oo = {
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        regex: "^\\d{6}$",
        maximumLength: 6,
        minimumLength: 6,
        mask: [
          "######"
        ]
      }
    },
    consumer: {
      phoneCode: "7"
    }
  }
}, Uo = {
  rules: {
    consumer: {
      phoneCode: "250"
    }
  }
}, Ho = {
  defaultLanguage: "en-SA",
  supportedLanguages: [
    "en-GB"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      line3: {
        enabled: !0
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !1,
        enabled: !0
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "966",
      phoneNumber: {
        minimumLength: 9,
        mask: [
          "## ### ####"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "800-850-1271",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, Zo = {
  rules: {
    consumer: {
      phoneCode: "677"
    }
  }
}, zo = {
  rules: {
    consumer: {
      phoneCode: "248"
    }
  }
}, Fo = {
  defaultLanguage: "sv-SE",
  supportedLanguages: [
    "sv-SE",
    "en-GB"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        enabled: !1,
        maximumLength: 30
      },
      postalCode: {
        regex: "^\\d{3} ?\\d{2}$",
        maximumLength: 16,
        minimumLength: 5,
        mask: [
          "### ##"
        ]
      }
    },
    consumer: {
      phoneCode: "46",
      phoneNumber: {
        mask: [
          "## ### ## ##"
        ],
        maximumLength: 12,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "020-160-4335",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Vo = {
  defaultLanguage: "en-SG",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        regex: "^\\d{6}$",
        maximumLength: 6,
        minimumLength: 6,
        mask: [
          "######"
        ]
      }
    },
    consumer: {
      phoneCode: "65",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "#### ####"
        ]
      }
    }
  },
  customerSupportPhoneNumber: "1800-6709-501",
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, jo = {
  rules: {
    consumer: {
      phoneCode: "386"
    }
  }
}, wo = {
  defaultLanguage: "sk-SK",
  supportedLanguages: [
    "sk-SK"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        maximumLength: 30
      }
    },
    consumer: {
      phoneCode: "421",
      phoneNumber: {
        mask: [
          "### ### ###"
        ],
        minimumLength: 9,
        maximumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "800-194-591",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  showInLocaleSelector: !0
}, Jo = {
  rules: {
    consumer: {
      phoneCode: "232"
    }
  }
}, Wo = {
  rules: {
    consumer: {
      phoneCode: "378"
    }
  }
}, Yo = {
  rules: {
    consumer: {
      phoneCode: "221"
    }
  }
}, xo = {
  rules: {
    consumer: {
      phoneCode: "252"
    }
  }
}, _o = {
  rules: {
    consumer: {
      phoneCode: "597"
    }
  }
}, qo = {
  rules: {
    consumer: {
      phoneCode: "211"
    }
  }
}, Qo = {
  defaultLanguage: "es-SV",
  supportedLanguages: [
    "es-SV"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        maximumLength: 5,
        minimumLength: 4,
        regex: "^\\d{4,5}$",
        mask: [
          "####",
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "503",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "#### ####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "2136 6337",
  beta: !0,
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    "state",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, Xo = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, $o = {
  rules: {
    consumer: {
      phoneCode: "963"
    }
  }
}, as = {
  rules: {
    consumer: {
      phoneCode: "268"
    }
  }
}, es = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, ns = {
  rules: {
    consumer: {
      phoneCode: "235"
    }
  }
}, is = {
  rules: {
    consumer: {
      phoneCode: "228"
    }
  }
}, rs = {
  defaultLanguage: "en-TH",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      line3: {
        enabled: !0,
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "66"
    }
  },
  customerSupportPhoneNumber: "01-800-01-9318",
  beta: !0,
  features: [
    "EXPLICIT_TERMS_CONSENT",
    "EXPLICIT_PRIVACY_CONSENT",
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "state",
    "zip"
  ],
  showInLocaleSelector: !0
}, os = {
  rules: {
    consumer: {
      phoneCode: "992"
    }
  }
}, ss = {
  rules: {
    consumer: {
      phoneCode: "993"
    }
  }
}, ts = {
  rules: {
    consumer: {
      phoneCode: "216"
    }
  }
}, us = {
  rules: {
    consumer: {
      phoneCode: "676"
    }
  }
}, ls = {
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "90"
    }
  }
}, ds = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, ms = {
  defaultLanguage: "zh-TW",
  supportedLanguages: [
    "zh-TW"
  ],
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      cityTown: {
        regex: ".*"
      },
      subdivision: {
        regex: ".*"
      },
      postalCode: {
        regex: ".+"
      }
    },
    consumer: {
      phoneCode: "886"
    }
  }
}, Ss = {
  defaultLanguage: "en-TZ",
  supportedLanguages: [
    "en-TZ"
  ],
  rules: {
    address: {
      line1: {
        maximumLength: 50
      },
      line2: {
        maximumLength: 50
      },
      cityTown: {
        required: !0,
        maximumLength: 20
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        required: !1,
        maximumLength: 12
      }
    },
    consumer: {
      phoneCode: "255",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "### ######"
        ],
        noLeadingNumber: !1
      }
    }
  },
  customerSupportEmail: "support.checkout@mastercard.com",
  features: [
    "ENABLE_ADDRESS_AUTOCOMPLETE"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city",
    "zip"
  ],
  showInLocaleSelector: !0
}, gs = {
  defaultLanguage: "uk-UA",
  supportedLanguages: [
    "uk-UA",
    "en-UA"
  ],
  genericSettings: {
    billingAddressFormat: "NONE"
  },
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        regex: ".+"
      },
      line2: {
        regex: ".*"
      },
      line3: {
        enabled: !0,
        regex: ".*"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        maximumLength: 30,
        regex: ".*"
      },
      postalCode: {
        regex: "^\\d{5}$",
        minimumLength: 5
      }
    },
    consumer: {
      phoneCode: "380",
      phoneNumber: {
        mask: [
          "## ### ####"
        ],
        minimumLength: 9,
        maximumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "80-050-9880",
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "zip",
    "city",
    "state"
  ],
  showInLocaleSelector: !0
}, cs = {
  rules: {
    consumer: {
      phoneCode: "256"
    }
  }
}, Ms = {
  defaultLanguage: "en-US",
  supportedLanguages: [
    "en-US"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0,
        type: "enum",
        enum: [
          "AA",
          "AE",
          "AK",
          "AL",
          "AP",
          "AR",
          "AS",
          "AZ",
          "CA",
          "CO",
          "CT",
          "DE",
          "DC",
          "FM",
          "FL",
          "GA",
          "GU",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MH",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MP",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "OH",
          "OK",
          "OR",
          "PW",
          "PA",
          "PR",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UM",
          "UT",
          "VT",
          "VI",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY"
        ]
      },
      postalCode: {
        regex: "^\\d{5}$",
        maximumLength: 5,
        minimumLength: 5,
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "1",
      phoneNumber: {
        minimumLength: 10,
        mask: [
          "(###) ###-####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "1-833-271-9871",
  features: [
    "PRECHECK_REMEMBER_ME",
    "ENABLE_ADDRESS_AUTOCOMPLETE",
    "ENABLE_SUPPORT_PAGE"
  ],
  promotionalMerchants: [
    {
      name: "bass-pro",
      url: "https://www.basspro.com/shop/en"
    },
    {
      name: "saks",
      url: "https://www.saksfifthavenue.com/Entry.jsp"
    },
    {
      name: "staples",
      url: "https://www.staples.com/"
    },
    {
      name: "expedia",
      url: "https://www.expedia.com/?pwaLob=wizard-hotel-pwa-v2"
    },
    {
      name: "barnes-and-noble",
      url: "https://www.barnesandnoble.com/"
    },
    {
      name: "priceless-planet",
      url: "https://www.mastercard.us/en-us/vision/corp-responsibility/priceless-planet.html"
    }
  ],
  showInLocaleSelector: !0
}, Ls = {
  defaultLanguage: "es-UY",
  supportedLanguages: [
    "es-UY"
  ],
  rules: {
    address: {
      cityTown: {
        required: !0
      },
      postalCode: {
        maximumLength: 5,
        minimumLength: 5,
        regex: "^\\d{5}$",
        mask: [
          "#####"
        ]
      }
    },
    consumer: {
      phoneCode: "598",
      phoneNumber: {
        minimumLength: 8,
        mask: [
          "#### ####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "413 598 5217",
  beta: !0,
  features: [
    "DISABLE_FEEDBACK"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    [
      "streetName",
      "streetNumber"
    ],
    "lineFields",
    [
      "city",
      "zip"
    ]
  ],
  showInLocaleSelector: !0
}, As = {
  rules: {
    consumer: {
      phoneCode: "998"
    }
  }
}, Cs = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, hs = {
  rules: {
    consumer: {
      phoneCode: "58"
    }
  }
}, Bs = {
  rules: {
    consumer: {
      phoneCode: "1"
    }
  }
}, Ts = {
  defaultLanguage: "vi-VN",
  supportedLanguages: [
    "vi-VN",
    "en-VN"
  ],
  rules: {
    address: {
      fullName: {
        regex: ".+"
      },
      line1: {
        maximumLength: 50,
        regex: ".+"
      },
      line2: {
        required: !0,
        maximumLength: 50,
        regex: ".+"
      },
      line3: {
        required: !0,
        enabled: !0,
        maximumLength: 50,
        regex: ".+"
      },
      cityTown: {
        required: !0,
        regex: ".+"
      },
      subdivision: {
        enabled: !1
      },
      postalCode: {
        enabled: !1
      }
    },
    consumer: {
      phoneCode: "84",
      phoneNumber: {
        minimumLength: 9,
        maximumLength: 9,
        mask: [
          "(##)-###-####"
        ],
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "+84 (121) 0 20014",
  beta: !0,
  features: [
    "PRECHECK_REMEMBER_ME",
    "ENABLE_ADDRESS_AUTOCOMPLETE",
    "EXPLICIT_FRAUD_PROTECTION_CONSENT"
  ],
  addressFieldsSortOrder: [
    "name",
    "country",
    "lineFields",
    "city"
  ],
  showInLocaleSelector: !0
}, ps = {
  rules: {
    consumer: {
      phoneCode: "678"
    }
  }
}, Gs = {
  rules: {
    consumer: {
      phoneCode: "685"
    }
  }
}, Ns = {
  rules: {
    consumer: {
      phoneCode: "383"
    }
  }
}, Es = {
  rules: {
    consumer: {
      phoneCode: "967"
    }
  }
}, bs = {
  defaultLanguage: "en-ZA",
  supportedLanguages: [
    "en-GB"
  ],
  rules: {
    address: {
      line2: {
        required: !1
      },
      line3: {
        enabled: !1
      },
      cityTown: {
        required: !0
      },
      subdivision: {
        required: !0
      },
      postalCode: {
        regex: "^\\d{4}$",
        maximumLength: 4,
        minimumLength: 4,
        mask: [
          "####"
        ]
      }
    },
    consumer: {
      phoneCode: "27",
      phoneNumber: {
        mask: [
          "#########"
        ],
        maximumLength: 9,
        minimumLength: 9,
        noLeadingNumber: !0
      }
    }
  },
  customerSupportPhoneNumber: "0800-333-882",
  showInLocaleSelector: !0
}, ks = {
  rules: {
    consumer: {
      phoneCode: "260"
    }
  }
}, Ks = {
  rules: {
    consumer: {
      phoneCode: "263"
    }
  }
}, Is = {
  genericSettings: {
    billingAddressFormat: "FULL"
  },
  rules: {
    address: {
      fullName: {
        required: !0,
        enabled: !0,
        type: "any",
        maximumLength: 60,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ž–]+$"
      },
      line1: {
        type: "any",
        required: !0,
        enabled: !0,
        maximumLength: 75,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ž–]+$"
      },
      line2: {
        type: "any",
        enabled: !0,
        required: !1,
        maximumLength: 75,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ž–]+$"
      },
      line3: {
        type: "any",
        required: !1,
        enabled: !1,
        maximumLength: 75,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ž–]+$"
      },
      cityTown: {
        type: "any",
        required: !1,
        enabled: !0,
        maximumLength: 50,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ž–]+$"
      },
      subdivision: {
        type: "any",
        required: !1,
        enabled: !0,
        maximumLength: 50,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ž–]+$"
      },
      postalCode: {
        type: "any",
        required: !0,
        enabled: !0,
        maximumLength: 16,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ž–]+$"
      }
    },
    consumer: {
      email: {
        supported: !0,
        updatable: !1,
        required: !1,
        minimumLength: 6,
        maximumLength: 255,
        type: "any",
        regex: "^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$"
      },
      phoneNumber: {
        type: "any",
        required: !1,
        enabled: !0,
        maximumLength: 20,
        minimumLength: 1,
        noLeadingNumber: !1,
        regex: "^\\d+$"
      }
    },
    postalCodeAddress: {
      postalCode: {
        type: "any",
        required: !0,
        enabled: !0,
        maximumLength: 20,
        minimumLength: 1,
        regex: "^[a-zA-Z\\s#-:À-ÿ–]+$"
      }
    }
  },
  defaultLanguage: "en"
}, Ps = {
  AD: Fn,
  AE: Vn,
  AF: jn,
  AG: wn,
  AI: Jn,
  AL: Wn,
  AM: Yn,
  AO: xn,
  AR: _n,
  AS: qn,
  AT: Qn,
  AU: Xn,
  AW: $n,
  AZ: ai,
  BA: ei,
  BB: ni,
  BD: ii,
  BE: ri,
  BF: oi,
  BG: si,
  BH: ti,
  BI: ui,
  BJ: li,
  BM: di,
  BN: mi,
  BO: Si,
  BQ: gi,
  BR: ci,
  BS: Mi,
  BT: Li,
  BW: Ai,
  BY: Ci,
  BZ: hi,
  CA: Bi,
  CD: Ti,
  CF: pi,
  CG: Gi,
  CH: Ni,
  CI: Ei,
  CK: bi,
  CL: ki,
  CM: Ki,
  CN: Ii,
  CO: Pi,
  CR: Ri,
  CU: Di,
  CV: fi,
  CW: vi,
  CY: yi,
  CZ: Oi,
  DE: Ui,
  DJ: Hi,
  DK: Zi,
  DM: zi,
  DO: Fi,
  DZ: Vi,
  EC: ji,
  EE: wi,
  EG: Ji,
  ES: Wi,
  ET: Yi,
  FI: xi,
  FJ: _i,
  FR: qi,
  GA: Qi,
  GB: Xi,
  GD: $i,
  GE: ar,
  GH: er,
  GI: nr,
  GM: ir,
  GN: rr,
  GQ: or,
  GR: sr,
  GT: tr,
  GU: ur,
  GW: lr,
  GY: dr,
  HK: mr,
  HN: Sr,
  HR: gr,
  HT: cr,
  HU: Mr,
  ID: Lr,
  IE: Ar,
  IL: Cr,
  IN: hr,
  IQ: Br,
  IS: Tr,
  IT: pr,
  JE: Gr,
  JM: Nr,
  JO: Er,
  JP: br,
  KE: kr,
  KG: Kr,
  KH: Ir,
  KI: Pr,
  KM: Rr,
  KN: Dr,
  KR: fr,
  KW: vr,
  KY: yr,
  KZ: Or,
  LA: Ur,
  LB: Hr,
  LC: Zr,
  LI: zr,
  LK: Fr,
  LR: Vr,
  LS: jr,
  LT: wr,
  LU: Jr,
  LV: Wr,
  LY: Yr,
  MA: xr,
  MD: _r,
  ME: qr,
  MG: Qr,
  MH: Xr,
  MK: $r,
  ML: ao,
  MM: eo,
  MN: no,
  MO: io,
  MR: ro,
  MS: oo,
  MT: so,
  MU: to,
  MV: uo,
  MW: lo,
  MX: mo,
  MY: So,
  MZ: go,
  NA: co,
  NE: Mo,
  NG: Lo,
  NI: Ao,
  NL: Co,
  NO: ho,
  NP: Bo,
  NZ: To,
  OM: po,
  PA: Go,
  PE: No,
  PG: Eo,
  PH: bo,
  PK: ko,
  PL: Ko,
  PR: Io,
  PS: Po,
  PT: Ro,
  PY: Do,
  QA: fo,
  RO: vo,
  RS: yo,
  RU: Oo,
  RW: Uo,
  SA: Ho,
  SB: Zo,
  SC: zo,
  SE: Fo,
  SG: Vo,
  SI: jo,
  SK: wo,
  SL: Jo,
  SM: Wo,
  SN: Yo,
  SO: xo,
  SR: _o,
  SS: qo,
  SV: Qo,
  SX: Xo,
  SY: $o,
  SZ: as,
  TC: es,
  TD: ns,
  TG: is,
  TH: rs,
  TJ: os,
  TM: ss,
  TN: ts,
  TO: us,
  TR: ls,
  TT: ds,
  TW: ms,
  TZ: Ss,
  UA: gs,
  UG: cs,
  US: Ms,
  UY: Ls,
  UZ: As,
  VC: Cs,
  VE: hs,
  VI: Bs,
  VN: Ts,
  VU: ps,
  WS: Gs,
  XK: Ns,
  YE: Es,
  ZA: bs,
  ZM: ks,
  ZW: Ks,
  DEFAULT: Is
}, Rs = "Ukraine", Ds = {
  UA: Rs
}, fs = "Cuba", vs = "Iran", ys = "North Korea", Os = "Russia", Us = "Sudan", Hs = "Syria", Zs = {
  CU: fs,
  IR: vs,
  KP: ys,
  RU: Os,
  SD: Us,
  SY: Hs
}, zs = {
  104: "MMK",
  108: "BIF",
  116: "KHR",
  124: "CAD",
  132: "CVE",
  136: "KYD",
  144: "LKR",
  152: "CLP",
  156: "CNY",
  170: "COP",
  174: "KMF",
  188: "CRC",
  192: "CUP",
  203: "CZK",
  208: "DKK",
  214: "DOP",
  222: "SVC",
  230: "ETB",
  232: "ERN",
  238: "FKP",
  242: "FJD",
  262: "DJF",
  270: "GMD",
  292: "GIP",
  320: "GTQ",
  324: "GNF",
  328: "GYD",
  332: "HTG",
  340: "HNL",
  344: "HKD",
  348: "HUF",
  352: "ISK",
  356: "INR",
  360: "IDR",
  364: "IRR",
  368: "IQD",
  376: "ILS",
  388: "JMD",
  392: "JPY",
  398: "KZT",
  400: "JOD",
  404: "KES",
  408: "KPW",
  410: "KRW",
  414: "KWD",
  417: "KGS",
  418: "LAK",
  422: "LBP",
  426: "LSL",
  430: "LRD",
  434: "LYD",
  446: "MOP",
  454: "MWK",
  458: "MYR",
  462: "MVR",
  480: "MUR",
  484: "MXN",
  496: "MNT",
  498: "MDL",
  504: "MAD",
  512: "OMR",
  516: "NAD",
  524: "NPR",
  532: "ANG",
  533: "AWG",
  548: "VUV",
  554: "NZD",
  558: "NIO",
  566: "NGN",
  578: "NOK",
  586: "PKR",
  590: "PAB",
  598: "PGK",
  600: "PYG",
  604: "PEN",
  608: "PHP",
  634: "QAR",
  643: "RUB",
  646: "RWF",
  654: "SHP",
  682: "SAR",
  690: "SCR",
  694: "SLL",
  702: "SGD",
  704: "VND",
  706: "SOS",
  710: "ZAR",
  728: "SSP",
  748: "SZL",
  752: "SEK",
  756: "CHF",
  760: "SYP",
  764: "THB",
  776: "TOP",
  780: "TTD",
  784: "AED",
  788: "TND",
  800: "UGX",
  807: "MKD",
  818: "EGP",
  826: "GBP",
  834: "TZS",
  840: "USD",
  858: "UYU",
  860: "UZS",
  882: "WST",
  886: "YER",
  901: "TWD",
  925: "SLE",
  926: "VED",
  927: "UYW",
  928: "VES",
  929: "MRU",
  930: "STN",
  932: "ZWL",
  933: "BYN",
  934: "TMT",
  936: "GHS",
  938: "SDG",
  940: "UYI",
  941: "RSD",
  943: "MZN",
  944: "AZN",
  946: "RON",
  947: "CHE",
  948: "CHW",
  949: "TRY",
  950: "XAF",
  951: "XCD",
  952: "XOF",
  953: "XPF",
  955: "XBA",
  956: "XBB",
  957: "XBC",
  958: "XBD",
  959: "XAU",
  960: "XDR",
  961: "XAG",
  962: "XPT",
  963: "XTS",
  964: "XPD",
  965: "XUA",
  967: "ZMW",
  968: "SRD",
  969: "MGA",
  970: "COU",
  971: "AFN",
  972: "TJS",
  973: "AOA",
  975: "BGN",
  976: "CDF",
  977: "BAM",
  978: "EUR",
  979: "MXV",
  980: "UAH",
  981: "GEL",
  984: "BOV",
  985: "PLN",
  986: "BRL",
  990: "CLF",
  994: "XSU",
  997: "USN",
  999: "XXX",
  "008": "ALL",
  "051": "AMD",
  "032": "ARS",
  "036": "AUD",
  "052": "BBD",
  "050": "BDT",
  "048": "BHD",
  "060": "BMD",
  "096": "BND",
  "068": "BOB",
  "044": "BSD",
  "064": "BTN",
  "072": "BWP",
  "084": "BZD",
  "012": "DZD",
  "090": "SBD"
}, Fs = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua & Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Caribbean Netherlands",
  BA: "Bosnia & Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo - Brazzaville",
  CD: "Congo - Kinshasa",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Croatia",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czechia",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  EE: "Estonia",
  ET: "Ethiopia",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hong Kong SAR China",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao SAR China",
  MK: "North Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Mexico",
  MD: "Moldova",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Netherlands",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestinian Territories",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RW: "Rwanda",
  KN: "St. Kitts & Nevis",
  LC: "St. Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  KR: "South Korea",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  VC: "St. Vincent & Grenadines",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Switzerland",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad & Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks & Caicos Islands",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "U.S. Virgin Islands",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, Vs = {
  AF: "Afganistán",
  AL: "Albania",
  DZ: "Argelia",
  AS: "Samoa Americana",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AG: "Antigua y Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaiyán",
  BS: "Bahamas",
  BH: "Baréin",
  BD: "Bangladés",
  BB: "Barbados",
  BY: "Bielorrusia",
  BE: "Bélgica",
  BZ: "Belice",
  BJ: "Benín",
  BM: "Bermudas",
  BT: "Bután",
  BO: "Bolivia",
  BQ: "Caribe neerlandés",
  BA: "Bosnia y Herzegovina",
  BW: "Botsuana",
  BR: "Brasil",
  BN: "Brunéi",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Camboya",
  CM: "Camerún",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Islas Caimán",
  CF: "República Centroafricana",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  KM: "Comoras",
  CG: "Congo",
  CD: "República Democrática del Congo",
  CK: "Islas Cook",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Croacia",
  CW: "Curazao",
  CY: "Chipre",
  CZ: "Chequia",
  DK: "Dinamarca",
  DJ: "Yibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Egipto",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  EE: "Estonia",
  ET: "Etiopía",
  FJ: "Fiyi",
  FI: "Finlandia",
  FR: "Francia",
  GA: "Gabón",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Alemania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GD: "Granada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bisáu",
  GY: "Guyana",
  HT: "Haití",
  HN: "Honduras",
  HK: "RAE de Hong Kong (China)",
  HU: "Hungría",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irlanda",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japón",
  JE: "Jersey",
  JO: "Jordania",
  KZ: "Kazajistán",
  KE: "Kenia",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirguistán",
  LA: "Laos",
  LV: "Letonia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  MO: "RAE de Macao (China)",
  MK: "Macedonia del Norte",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malasia",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MH: "Islas Marshall",
  MR: "Mauritania",
  MU: "Mauricio",
  MX: "México",
  MD: "Moldavia",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marruecos",
  MZ: "Mozambique",
  MM: "Myanmar (Birmania)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Países Bajos",
  NZ: "Nueva Zelanda",
  NI: "Nicaragua",
  NE: "Níger",
  NG: "Nigeria",
  NO: "Noruega",
  OM: "Omán",
  PK: "Pakistán",
  PS: "Territorios Palestinos",
  PA: "Panamá",
  PG: "Papúa Nueva Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Filipinas",
  PL: "Polonia",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Catar",
  RO: "Rumanía",
  RW: "Ruanda",
  KN: "San Cristóbal y Nieves",
  LC: "Santa Lucía",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Arabia Saudí",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leona",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  SB: "Islas Salomón",
  SO: "Somalia",
  ZA: "Sudáfrica",
  KR: "Corea del Sur",
  SS: "Sudán del Sur",
  ES: "España",
  LK: "Sri Lanka",
  VC: "San Vicente y las Granadinas",
  SR: "Surinam",
  SZ: "Esuatini",
  SE: "Suecia",
  CH: "Suiza",
  TW: "Taiwán",
  TJ: "Tayikistán",
  TZ: "Tanzania",
  TH: "Tailandia",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad y Tobago",
  TN: "Túnez",
  TR: "Turquía",
  TM: "Turkmenistán",
  TC: "Islas Turcas y Caicos",
  UG: "Uganda",
  UA: "Ucrania",
  AE: "Emiratos Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Islas Vírgenes de EE. UU.",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabue"
}, js = {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algerien",
  AS: "Amerikanisch-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua und Barbuda",
  AR: "Argentinien",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Österreich",
  AZ: "Aserbaidschan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivien",
  BQ: "Karibische Niederlande",
  BA: "Bosnien und Herzegowina",
  BW: "Botsuana",
  BR: "Brasilien",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Cabo Verde",
  KY: "Kaimaninseln",
  CF: "Zentralafrikanische Republik",
  TD: "Tschad",
  CL: "Chile",
  CN: "China",
  CO: "Kolumbien",
  KM: "Komoren",
  CG: "Kongo-Brazzaville",
  CD: "Kongo-Kinshasa",
  CK: "Cookinseln",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Kroatien",
  CW: "Curaçao",
  CY: "Zypern",
  CZ: "Tschechien",
  DK: "Dänemark",
  DJ: "Dschibuti",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  EC: "Ecuador",
  EG: "Ägypten",
  SV: "El Salvador",
  GQ: "Äquatorialguinea",
  EE: "Estland",
  ET: "Äthiopien",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Deutschland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griechenland",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Sonderverwaltungsregion Hongkong",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanien",
  KZ: "Kasachstan",
  KE: "Kenia",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Lettland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Sonderverwaltungsregion Macau",
  MK: "Nordmazedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallinseln",
  MR: "Mauretanien",
  MU: "Mauritius",
  MX: "Mexiko",
  MD: "Republik Moldau",
  MN: "Mongolei",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Niederlande",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norwegen",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palästinensische Autonomiegebiete",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Katar",
  RO: "Rumänien",
  RW: "Ruanda",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slowakei",
  SI: "Slowenien",
  SB: "Salomonen",
  SO: "Somalia",
  ZA: "Südafrika",
  KR: "Südkorea",
  SS: "Südsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  VC: "St. Vincent und die Grenadinen",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Schweden",
  CH: "Schweiz",
  TW: "Taiwan",
  TJ: "Tadschikistan",
  TZ: "Tansania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TC: "Turks- und Caicosinseln",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Vereinigte Arabische Emirate",
  GB: "Vereinigtes Königreich",
  US: "Vereinigte Staaten",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Amerikanische Jungferninseln",
  YE: "Jemen",
  ZM: "Sambia",
  ZW: "Simbabwe"
}, ws = {
  AF: "Afghanistan",
  AL: "Albanie",
  DZ: "Algérie",
  AS: "Samoa américaines",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua-et-Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie",
  BQ: "Pays-Bas caribéens",
  BA: "Bosnie-Herzégovine",
  BW: "Botswana",
  BR: "Brésil",
  BN: "Brunei",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cap-Vert",
  KY: "Îles Caïmans",
  CF: "République centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CO: "Colombie",
  KM: "Comores",
  CG: "Congo-Brazzaville",
  CD: "Congo-Kinshasa",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Croatie",
  CW: "Curaçao",
  CY: "Chypre",
  CZ: "Tchéquie",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "Salvador",
  GQ: "Guinée équatoriale",
  EE: "Estonie",
  ET: "Éthiopie",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GD: "Grenade",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HN: "Honduras",
  HK: "R.A.S. chinoise de Hong Kong",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IQ: "Irak",
  IE: "Irlande",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JE: "Jersey",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Koweït",
  KG: "Kirghizstan",
  LA: "Laos",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "R.A.S. chinoise de Macao",
  MK: "Macédoine du Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MH: "Îles Marshall",
  MR: "Mauritanie",
  MU: "Maurice",
  MX: "Mexique",
  MD: "Moldavie",
  MN: "Mongolie",
  ME: "Monténégro",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Myanmar (Birmanie)",
  NA: "Namibie",
  NP: "Népal",
  NL: "Pays-Bas",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Territoires palestiniens",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PL: "Pologne",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Qatar",
  RO: "Roumanie",
  RW: "Rwanda",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  WS: "Samoa",
  SM: "Saint-Marin",
  SA: "Arabie saoudite",
  SN: "Sénégal",
  RS: "Serbie",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SX: "Saint-Martin (partie néerlandaise)",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  KR: "Corée du Sud",
  SS: "Soudan du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  VC: "Saint-Vincent-et-les Grenadines",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Suède",
  CH: "Suisse",
  TW: "Taïwan",
  TJ: "Tadjikistan",
  TZ: "Tanzanie",
  TH: "Thaïlande",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats arabes unis",
  GB: "Royaume-Uni",
  US: "États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viêt Nam",
  VI: "Îles Vierges des États-Unis",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe"
}, Js = {
  AF: "Afghanistan",
  AL: "Albanië",
  DZ: "Algerije",
  AS: "Amerikaans-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahama’s",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "België",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Caribisch Nederland",
  BA: "Bosnië en Herzegovina",
  BW: "Botswana",
  BR: "Brazilië",
  BN: "Brunei",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  CV: "Kaapverdië",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CO: "Colombia",
  KM: "Comoren",
  CG: "Congo-Brazzaville",
  CD: "Congo-Kinshasa",
  CK: "Cookeilanden",
  CR: "Costa Rica",
  CI: "Ivoorkust",
  HR: "Kroatië",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinea",
  EE: "Estland",
  ET: "Ethiopië",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinee",
  GW: "Guinee-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HN: "Honduras",
  HK: "Hongkong SAR van China",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IQ: "Irak",
  IE: "Ierland",
  IL: "Israël",
  IT: "Italië",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanië",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Koeweit",
  KG: "Kirgizië",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macau SAR van China",
  MK: "Noord-Macedonië",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: "Maldiven",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalleilanden",
  MR: "Mauritanië",
  MU: "Mauritius",
  MX: "Mexico",
  MD: "Moldavië",
  MN: "Mongolië",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar (Birma)",
  NA: "Namibië",
  NP: "Nepal",
  NL: "Nederland",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestijnse gebieden",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipijnen",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Roemenië",
  RW: "Rwanda",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saoedi-Arabië",
  SN: "Senegal",
  RS: "Servië",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint-Maarten",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  KR: "Zuid-Korea",
  SS: "Zuid-Soedan",
  ES: "Spanje",
  LK: "Sri Lanka",
  VC: "Saint Vincent en de Grenadines",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Zweden",
  CH: "Zwitserland",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  UG: "Oeganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: "Verenigd Koninkrijk",
  US: "Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Amerikaanse Maagdeneilanden",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, Ws = {
  AF: "Афганистан",
  AL: "Албания",
  DZ: "Алжир",
  AS: "Американска Самоа",
  AD: "Андора",
  AO: "Ангола",
  AI: "Ангуила",
  AG: "Антигуа и Барбуда",
  AR: "Аржентина",
  AM: "Армения",
  AW: "Аруба",
  AU: "Австралия",
  AT: "Австрия",
  AZ: "Азербайджан",
  BS: "Бахамски острови",
  BH: "Бахрейн",
  BD: "Бангладеш",
  BB: "Барбадос",
  BY: "Беларус",
  BE: "Белгия",
  BZ: "Белиз",
  BJ: "Бенин",
  BM: "Бермудски острови",
  BT: "Бутан",
  BO: "Боливия",
  BQ: "Карибска Нидерландия",
  BA: "Босна и Херцеговина",
  BW: "Ботсвана",
  BR: "Бразилия",
  BN: "Бруней Даруссалам",
  BG: "България",
  BF: "Буркина Фасо",
  BI: "Бурунди",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  CV: "Кабо Верде",
  KY: "Кайманови острови",
  CF: "Централноафриканска република",
  TD: "Чад",
  CL: "Чили",
  CN: "Китай",
  CO: "Колумбия",
  KM: "Коморски острови",
  CG: "Конго (Бразавил)",
  CD: "Конго (Киншаса)",
  CK: "острови Кук",
  CR: "Коста Рика",
  CI: "Кот д’Ивоар",
  HR: "Хърватия",
  CW: "Кюрасао",
  CY: "Кипър",
  CZ: "Чехия",
  DK: "Дания",
  DJ: "Джибути",
  DM: "Доминика",
  DO: "Доминиканска република",
  EC: "Еквадор",
  EG: "Египет",
  SV: "Салвадор",
  GQ: "Екваториална Гвинея",
  EE: "Естония",
  ET: "Етиопия",
  FJ: "Фиджи",
  FI: "Финландия",
  FR: "Франция",
  GA: "Габон",
  GM: "Гамбия",
  GE: "Грузия",
  DE: "Германия",
  GH: "Гана",
  GI: "Гибралтар",
  GR: "Гърция",
  GD: "Гренада",
  GU: "Гуам",
  GT: "Гватемала",
  GN: "Гвинея",
  GW: "Гвинея-Бисау",
  GY: "Гаяна",
  HT: "Хаити",
  HN: "Хондурас",
  HK: "Хонконг, САР на Китай",
  HU: "Унгария",
  IS: "Исландия",
  IN: "Индия",
  ID: "Индонезия",
  IQ: "Ирак",
  IE: "Ирландия",
  IL: "Израел",
  IT: "Италия",
  JM: "Ямайка",
  JP: "Япония",
  JE: "Джърси",
  JO: "Йордания",
  KZ: "Казахстан",
  KE: "Кения",
  KI: "Кирибати",
  XK: "Косово",
  KW: "Кувейт",
  KG: "Киргизстан",
  LA: "Лаос",
  LV: "Латвия",
  LB: "Ливан",
  LS: "Лесото",
  LR: "Либерия",
  LY: "Либия",
  LI: "Лихтенщайн",
  LT: "Литва",
  LU: "Люксембург",
  MO: "Макао, САР на Китай",
  MK: "Северна Македония",
  MG: "Мадагаскар",
  MW: "Малави",
  MY: "Малайзия",
  MV: "Малдиви",
  ML: "Мали",
  MT: "Малта",
  MH: "Маршалови острови",
  MR: "Мавритания",
  MU: "Мавриций",
  MX: "Мексико",
  MD: "Молдова",
  MN: "Монголия",
  ME: "Черна гора",
  MS: "Монтсерат",
  MA: "Мароко",
  MZ: "Мозамбик",
  MM: "Мианмар (Бирма)",
  NA: "Намибия",
  NP: "Непал",
  NL: "Нидерландия",
  NZ: "Нова Зеландия",
  NI: "Никарагуа",
  NE: "Нигер",
  NG: "Нигерия",
  NO: "Норвегия",
  OM: "Оман",
  PK: "Пакистан",
  PS: "Палестински територии",
  PA: "Панама",
  PG: "Папуа-Нова Гвинея",
  PY: "Парагвай",
  PE: "Перу",
  PH: "Филипини",
  PL: "Полша",
  PT: "Португалия",
  PR: "Пуерто Рико",
  QA: "Катар",
  RO: "Румъния",
  RW: "Руанда",
  KN: "Сейнт Китс и Невис",
  LC: "Сейнт Лусия",
  WS: "Самоа",
  SM: "Сан Марино",
  SA: "Саудитска Арабия",
  SN: "Сенегал",
  RS: "Сърбия",
  SC: "Сейшели",
  SL: "Сиера Леоне",
  SG: "Сингапур",
  SX: "Синт Мартен",
  SK: "Словакия",
  SI: "Словения",
  SB: "Соломонови острови",
  SO: "Сомалия",
  ZA: "Южна Африка",
  KR: "Южна Корея",
  SS: "Южен Судан",
  ES: "Испания",
  LK: "Шри Ланка",
  VC: "Сейнт Винсънт и Гренадини",
  SR: "Суринам",
  SZ: "Есватини",
  SE: "Швеция",
  CH: "Швейцария",
  TW: "Тайван",
  TJ: "Таджикистан",
  TZ: "Танзания",
  TH: "Тайланд",
  TG: "Того",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TN: "Тунис",
  TR: "Турция",
  TM: "Туркменистан",
  TC: "острови Търкс и Кайкос",
  UG: "Уганда",
  UA: "Украйна",
  AE: "Обединени арабски емирства",
  GB: "Обединеното кралство",
  US: "Съединени щати",
  UY: "Уругвай",
  UZ: "Узбекистан",
  VU: "Вануату",
  VE: "Венецуела",
  VN: "Виетнам",
  VI: "Американски Вирджински острови",
  YE: "Йемен",
  ZM: "Замбия",
  ZW: "Зимбабве"
}, Ys = {
  AF: "Afeganistão",
  AL: "Albânia",
  DZ: "Argélia",
  AS: "Samoa Americana",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AG: "Antígua e Barbuda",
  AR: "Argentina",
  AM: "Armênia",
  AW: "Aruba",
  AU: "Austrália",
  AT: "Áustria",
  AZ: "Azerbaijão",
  BS: "Bahamas",
  BH: "Barein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielorrússia",
  BE: "Bélgica",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudas",
  BT: "Butão",
  BO: "Bolívia",
  BQ: "Países Baixos Caribenhos",
  BA: "Bósnia e Herzegovina",
  BW: "Botsuana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burquina Faso",
  BI: "Burundi",
  KH: "Camboja",
  CM: "Camarões",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Ilhas Cayman",
  CF: "República Centro-Africana",
  TD: "Chade",
  CL: "Chile",
  CN: "China",
  CO: "Colômbia",
  KM: "Comores",
  CG: "República do Congo",
  CD: "Congo - Kinshasa",
  CK: "Ilhas Cook",
  CR: "Costa Rica",
  CI: "Costa do Marfim",
  HR: "Croácia",
  CW: "Curaçao",
  CY: "Chipre",
  CZ: "Tchéquia",
  DK: "Dinamarca",
  DJ: "Djibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Equador",
  EG: "Egito",
  SV: "El Salvador",
  GQ: "Guiné Equatorial",
  EE: "Estônia",
  ET: "Etiópia",
  FJ: "Fiji",
  FI: "Finlândia",
  FR: "França",
  GA: "Gabão",
  GM: "Gâmbia",
  GE: "Geórgia",
  DE: "Alemanha",
  GH: "Gana",
  GI: "Gibraltar",
  GR: "Grécia",
  GD: "Granada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guiné",
  GW: "Guiné-Bissau",
  GY: "Guiana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hong Kong, RAE da China",
  HU: "Hungria",
  IS: "Islândia",
  IN: "Índia",
  ID: "Indonésia",
  IQ: "Iraque",
  IE: "Irlanda",
  IL: "Israel",
  IT: "Itália",
  JM: "Jamaica",
  JP: "Japão",
  JE: "Jersey",
  JO: "Jordânia",
  KZ: "Cazaquistão",
  KE: "Quênia",
  KI: "Quiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Quirguistão",
  LA: "Laos",
  LV: "Letônia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Lituânia",
  LU: "Luxemburgo",
  MO: "Macau, RAE da China",
  MK: "Macedônia do Norte",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malásia",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MH: "Ilhas Marshall",
  MR: "Mauritânia",
  MU: "Maurício",
  MX: "México",
  MD: "Moldávia",
  MN: "Mongólia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marrocos",
  MZ: "Moçambique",
  MM: "Mianmar (Birmânia)",
  NA: "Namíbia",
  NP: "Nepal",
  NL: "Países Baixos",
  NZ: "Nova Zelândia",
  NI: "Nicarágua",
  NE: "Níger",
  NG: "Nigéria",
  NO: "Noruega",
  OM: "Omã",
  PK: "Paquistão",
  PS: "Territórios palestinos",
  PA: "Panamá",
  PG: "Papua-Nova Guiné",
  PY: "Paraguai",
  PE: "Peru",
  PH: "Filipinas",
  PL: "Polônia",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Catar",
  RO: "Romênia",
  RW: "Ruanda",
  KN: "São Cristóvão e Névis",
  LC: "Santa Lúcia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Arábia Saudita",
  SN: "Senegal",
  RS: "Sérvia",
  SC: "Seicheles",
  SL: "Serra Leoa",
  SG: "Singapura",
  SX: "Sint Maarten",
  SK: "Eslováquia",
  SI: "Eslovênia",
  SB: "Ilhas Salomão",
  SO: "Somália",
  ZA: "África do Sul",
  KR: "Coreia do Sul",
  SS: "Sudão do Sul",
  ES: "Espanha",
  LK: "Sri Lanka",
  VC: "São Vicente e Granadinas",
  SR: "Suriname",
  SZ: "Essuatíni",
  SE: "Suécia",
  CH: "Suíça",
  TW: "Taiwan",
  TJ: "Tadjiquistão",
  TZ: "Tanzânia",
  TH: "Tailândia",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad e Tobago",
  TN: "Tunísia",
  TR: "Turquia",
  TM: "Turcomenistão",
  TC: "Ilhas Turcas e Caicos",
  UG: "Uganda",
  UA: "Ucrânia",
  AE: "Emirados Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UY: "Uruguai",
  UZ: "Uzbequistão",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnã",
  VI: "Ilhas Virgens Americanas",
  YE: "Iêmen",
  ZM: "Zâmbia",
  ZW: "Zimbábue"
}, xs = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa americane",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua e Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaigian",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielorussia",
  BE: "Belgio",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Caraibi olandesi",
  BA: "Bosnia ed Erzegovina",
  BW: "Botswana",
  BR: "Brasile",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambogia",
  CM: "Camerun",
  CA: "Canada",
  CV: "Capo Verde",
  KY: "Isole Cayman",
  CF: "Repubblica Centrafricana",
  TD: "Ciad",
  CL: "Cile",
  CN: "Cina",
  CO: "Colombia",
  KM: "Comore",
  CG: "Congo-Brazzaville",
  CD: "Congo - Kinshasa",
  CK: "Isole Cook",
  CR: "Costa Rica",
  CI: "Costa d’Avorio",
  HR: "Croazia",
  CW: "Curaçao",
  CY: "Cipro",
  CZ: "Cechia",
  DK: "Danimarca",
  DJ: "Gibuti",
  DM: "Dominica",
  DO: "Repubblica Dominicana",
  EC: "Ecuador",
  EG: "Egitto",
  SV: "El Salvador",
  GQ: "Guinea Equatoriale",
  EE: "Estonia",
  ET: "Etiopia",
  FJ: "Figi",
  FI: "Finlandia",
  FR: "Francia",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germania",
  GH: "Ghana",
  GI: "Gibilterra",
  GR: "Grecia",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "RAS di Hong Kong",
  HU: "Ungheria",
  IS: "Islanda",
  IN: "India",
  ID: "Indonesia",
  IQ: "Iraq",
  IE: "Irlanda",
  IL: "Israele",
  IT: "Italia",
  JM: "Giamaica",
  JP: "Giappone",
  JE: "Jersey",
  JO: "Giordania",
  KZ: "Kazakistan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirghizistan",
  LA: "Laos",
  LV: "Lettonia",
  LB: "Libano",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Lussemburgo",
  MO: "RAS di Macao",
  MK: "Macedonia del Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldive",
  ML: "Mali",
  MT: "Malta",
  MH: "Isole Marshall",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Messico",
  MD: "Moldavia",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marocco",
  MZ: "Mozambico",
  MM: "Myanmar (Birmania)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Paesi Bassi",
  NZ: "Nuova Zelanda",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norvegia",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Territori palestinesi",
  PA: "Panama",
  PG: "Papua Nuova Guinea",
  PY: "Paraguay",
  PE: "Perù",
  PH: "Filippine",
  PL: "Polonia",
  PT: "Portogallo",
  PR: "Portorico",
  QA: "Qatar",
  RO: "Romania",
  RW: "Ruanda",
  KN: "Saint Kitts e Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Arabia Saudita",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovacchia",
  SI: "Slovenia",
  SB: "Isole Salomone",
  SO: "Somalia",
  ZA: "Sudafrica",
  KR: "Corea del Sud",
  SS: "Sud Sudan",
  ES: "Spagna",
  LK: "Sri Lanka",
  VC: "Saint Vincent e Grenadine",
  SR: "Suriname",
  SZ: "eSwatini",
  SE: "Svezia",
  CH: "Svizzera",
  TW: "Taiwan",
  TJ: "Tagikistan",
  TZ: "Tanzania",
  TH: "Thailandia",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad e Tobago",
  TN: "Tunisia",
  TR: "Turchia",
  TM: "Turkmenistan",
  TC: "Isole Turks e Caicos",
  UG: "Uganda",
  UA: "Ucraina",
  AE: "Emirati Arabi Uniti",
  GB: "Regno Unito",
  US: "Stati Uniti",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Isole Vergini Americane",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, _s = {
  AF: "Afghánistán",
  AL: "Albánie",
  DZ: "Alžírsko",
  AS: "Americká Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua a Barbuda",
  AR: "Argentina",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Austrálie",
  AT: "Rakousko",
  AZ: "Ázerbájdžán",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladéš",
  BB: "Barbados",
  BY: "Bělorusko",
  BE: "Belgie",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhútán",
  BO: "Bolívie",
  BQ: "Karibské Nizozemsko",
  BA: "Bosna a Hercegovina",
  BW: "Botswana",
  BR: "Brazílie",
  BN: "Brunej",
  BG: "Bulharsko",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kapverdy",
  KY: "Kajmanské ostrovy",
  CF: "Středoafrická republika",
  TD: "Čad",
  CL: "Chile",
  CN: "Čína",
  CO: "Kolumbie",
  KM: "Komory",
  CG: "Kongo – Brazzaville",
  CD: "Kongo – Kinshasa",
  CK: "Cookovy ostrovy",
  CR: "Kostarika",
  CI: "Pobřeží slonoviny",
  HR: "Chorvatsko",
  CW: "Curaçao",
  CY: "Kypr",
  CZ: "Česko",
  DK: "Dánsko",
  DJ: "Džibutsko",
  DM: "Dominika",
  DO: "Dominikánská republika",
  EC: "Ekvádor",
  EG: "Egypt",
  SV: "Salvador",
  GQ: "Rovníková Guinea",
  EE: "Estonsko",
  ET: "Etiopie",
  FJ: "Fidži",
  FI: "Finsko",
  FR: "Francie",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Gruzie",
  DE: "Německo",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Řecko",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkong – ZAO Číny",
  HU: "Maďarsko",
  IS: "Island",
  IN: "Indie",
  ID: "Indonésie",
  IQ: "Irák",
  IE: "Irsko",
  IL: "Izrael",
  IT: "Itálie",
  JM: "Jamajka",
  JP: "Japonsko",
  JE: "Jersey",
  JO: "Jordánsko",
  KZ: "Kazachstán",
  KE: "Keňa",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuvajt",
  KG: "Kyrgyzstán",
  LA: "Laos",
  LV: "Lotyšsko",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Libérie",
  LY: "Libye",
  LI: "Lichtenštejnsko",
  LT: "Litva",
  LU: "Lucembursko",
  MO: "Macao – ZAO Číny",
  MK: "Severní Makedonie",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malajsie",
  MV: "Maledivy",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallovy ostrovy",
  MR: "Mauritánie",
  MU: "Mauricius",
  MX: "Mexiko",
  MD: "Moldavsko",
  MN: "Mongolsko",
  ME: "Černá Hora",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mosambik",
  MM: "Myanmar (Barma)",
  NA: "Namibie",
  NP: "Nepál",
  NL: "Nizozemsko",
  NZ: "Nový Zéland",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigérie",
  NO: "Norsko",
  OM: "Omán",
  PK: "Pákistán",
  PS: "Palestinská území",
  PA: "Panama",
  PG: "Papua-Nová Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipíny",
  PL: "Polsko",
  PT: "Portugalsko",
  PR: "Portoriko",
  QA: "Katar",
  RO: "Rumunsko",
  RW: "Rwanda",
  KN: "Svatý Kryštof a Nevis",
  LC: "Svatá Lucie",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saúdská Arábie",
  SN: "Senegal",
  RS: "Srbsko",
  SC: "Seychely",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Svatý Martin (Nizozemsko)",
  SK: "Slovensko",
  SI: "Slovinsko",
  SB: "Šalamounovy ostrovy",
  SO: "Somálsko",
  ZA: "Jihoafrická republika",
  KR: "Jižní Korea",
  SS: "Jižní Súdán",
  ES: "Španělsko",
  LK: "Srí Lanka",
  VC: "Svatý Vincenc a Grenadiny",
  SR: "Surinam",
  SZ: "Eswatini",
  SE: "Švédsko",
  CH: "Švýcarsko",
  TW: "Tchaj-wan",
  TJ: "Tádžikistán",
  TZ: "Tanzanie",
  TH: "Thajsko",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad a Tobago",
  TN: "Tunisko",
  TR: "Turecko",
  TM: "Turkmenistán",
  TC: "Turks a Caicos",
  UG: "Uganda",
  UA: "Ukrajina",
  AE: "Spojené arabské emiráty",
  GB: "Spojené království",
  US: "Spojené státy",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Americké Panenské ostrovy",
  YE: "Jemen",
  ZM: "Zambie",
  ZW: "Zimbabwe"
}, qs = {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algeriet",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Østrig",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "De tidligere Nederlandske Antiller",
  BA: "Bosnien-Hercegovina",
  BW: "Botswana",
  BR: "Brasilien",
  BN: "Brunei",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Kap Verde",
  KY: "Caymanøerne",
  CF: "Den Centralafrikanske Republik",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CO: "Colombia",
  KM: "Comorerne",
  CG: "Congo-Brazzaville",
  CD: "Congo-Kinshasa",
  CK: "Cookøerne",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatien",
  CW: "Curaçao",
  CY: "Cypern",
  CZ: "Tjekkiet",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den Dominikanske Republik",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ækvatorialguinea",
  EE: "Estland",
  ET: "Etiopien",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrig",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grækenland",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "SAR Hongkong",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kasakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "SAR Macao",
  MK: "Nordmakedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverne",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløerne",
  MR: "Mauretanien",
  MU: "Mauritius",
  MX: "Mexico",
  MD: "Moldova",
  MN: "Mongoliet",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Nederlandene",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PS: "De palæstinensiske områder",
  PA: "Panama",
  PG: "Papua Ny Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerne",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Rumænien",
  RW: "Rwanda",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellerne",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakiet",
  SI: "Slovenien",
  SB: "Salomonøerne",
  SO: "Somalia",
  ZA: "Sydafrika",
  KR: "Sydkorea",
  SS: "Sydsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  VC: "Saint Vincent og Grenadinerne",
  SR: "Surinam",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Schweiz",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunesien",
  TR: "Tyrkiet",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøerne",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "De Forenede Arabiske Emirater",
  GB: "Storbritannien",
  US: "USA",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "De Amerikanske Jomfruøer",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, Qs = {
  AF: "Afganistan",
  AL: "Albaania",
  DZ: "Alžeeria",
  AS: "Ameerika Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua ja Barbuda",
  AR: "Argentina",
  AM: "Armeenia",
  AW: "Aruba",
  AU: "Austraalia",
  AT: "Austria",
  AZ: "Aserbaidžaan",
  BS: "Bahama",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Valgevene",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Boliivia",
  BQ: "Hollandi Kariibi mere saared",
  BA: "Bosnia ja Hertsegoviina",
  BW: "Botswana",
  BR: "Brasiilia",
  BN: "Brunei",
  BG: "Bulgaaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Roheneemesaared",
  KY: "Kaimanisaared",
  CF: "Kesk-Aafrika Vabariik",
  TD: "Tšaad",
  CL: "Tšiili",
  CN: "Hiina",
  CO: "Colombia",
  KM: "Komoorid",
  CG: "Kongo Vabariik",
  CD: "Kongo DV",
  CK: "Cooki saared",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Horvaatia",
  CW: "Curaçao",
  CY: "Küpros",
  CZ: "Tšehhi",
  DK: "Taani",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikaani Vabariik",
  EC: "Ecuador",
  EG: "Egiptus",
  SV: "El Salvador",
  GQ: "Ekvatoriaal-Guinea",
  EE: "Eesti",
  ET: "Etioopia",
  FJ: "Fidži",
  FI: "Soome",
  FR: "Prantsusmaa",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gruusia",
  DE: "Saksamaa",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Kreeka",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkongi erihalduspiirkond",
  HU: "Ungari",
  IS: "Island",
  IN: "India",
  ID: "Indoneesia",
  IQ: "Iraak",
  IE: "Iirimaa",
  IL: "Iisrael",
  IT: "Itaalia",
  JM: "Jamaica",
  JP: "Jaapan",
  JE: "Jersey",
  JO: "Jordaania",
  KZ: "Kasahstan",
  KE: "Keenia",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuveit",
  KG: "Kõrgõzstan",
  LA: "Laos",
  LV: "Läti",
  LB: "Liibanon",
  LS: "Lesotho",
  LR: "Libeeria",
  LY: "Liibüa",
  LI: "Liechtenstein",
  LT: "Leedu",
  LU: "Luksemburg",
  MO: "Macau erihalduspiirkond",
  MK: "Põhja-Makedoonia",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaisia",
  MV: "Maldiivid",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalli Saared",
  MR: "Mauritaania",
  MU: "Mauritius",
  MX: "Mehhiko",
  MD: "Moldova",
  MN: "Mongoolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mosambiik",
  MM: "Myanmar (Birma)",
  NA: "Namiibia",
  NP: "Nepal",
  NL: "Holland",
  NZ: "Uus-Meremaa",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeeria",
  NO: "Norra",
  OM: "Omaan",
  PK: "Pakistan",
  PS: "Palestiina alad",
  PA: "Panama",
  PG: "Paapua Uus-Guinea",
  PY: "Paraguay",
  PE: "Peruu",
  PH: "Filipiinid",
  PL: "Poola",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Katar",
  RO: "Rumeenia",
  RW: "Rwanda",
  KN: "Saint Kitts ja Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudi Araabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seišellid",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slovakkia",
  SI: "Sloveenia",
  SB: "Saalomoni Saared",
  SO: "Somaalia",
  ZA: "Lõuna-Aafrika Vabariik",
  KR: "Lõuna-Korea",
  SS: "Lõuna-Sudaan",
  ES: "Hispaania",
  LK: "Sri Lanka",
  VC: "Saint Vincent ja Grenadiinid",
  SR: "Suriname",
  SZ: "Svaasimaa",
  SE: "Rootsi",
  CH: "Šveits",
  TW: "Taiwan",
  TJ: "Tadžikistan",
  TZ: "Tansaania",
  TH: "Tai",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad ja Tobago",
  TN: "Tuneesia",
  TR: "Türgi",
  TM: "Türkmenistan",
  TC: "Turks ja Caicos",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Araabia Ühendemiraadid",
  GB: "Ühendkuningriik",
  US: "Ameerika Ühendriigid",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "USA Neitsisaared",
  YE: "Jeemen",
  ZM: "Sambia",
  ZW: "Zimbabwe"
}, Xs = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Amerikan Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua ja Barbuda",
  AR: "Argentiina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Itävalta",
  AZ: "Azerbaidžan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Valko-Venäjä",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Karibian Alankomaat",
  BA: "Bosnia ja Hertsegovina",
  BW: "Botswana",
  BR: "Brasilia",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KY: "Caymansaaret",
  CF: "Keski-Afrikan tasavalta",
  TD: "Tšad",
  CL: "Chile",
  CN: "Kiina",
  CO: "Kolumbia",
  KM: "Komorit",
  CG: "Kongon tasavalta",
  CD: "Kongon demokraattinen tasavalta",
  CK: "Cookinsaaret",
  CR: "Costa Rica",
  CI: "Norsunluurannikko",
  HR: "Kroatia",
  CW: "Curaçao",
  CY: "Kypros",
  CZ: "Tšekki",
  DK: "Tanska",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikaaninen tasavalta",
  EC: "Ecuador",
  EG: "Egypti",
  SV: "El Salvador",
  GQ: "Päiväntasaajan Guinea",
  EE: "Viro",
  ET: "Etiopia",
  FJ: "Fidži",
  FI: "Suomi",
  FR: "Ranska",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Saksa",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Kreikka",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkong – Kiinan erityishallintoalue",
  HU: "Unkari",
  IS: "Islanti",
  IN: "Intia",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irlanti",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Japani",
  JE: "Jersey",
  JO: "Jordania",
  KZ: "Kazakstan",
  KE: "Kenia",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirgisia",
  LA: "Laos",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Liettua",
  LU: "Luxemburg",
  MO: "Macao – Kiinan erityishallintoalue",
  MK: "Pohjois-Makedonia",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malesia",
  MV: "Malediivit",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallinsaaret",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Meksiko",
  MD: "Moldova",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Alankomaat",
  NZ: "Uusi-Seelanti",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norja",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestiinalaisalue",
  PA: "Panama",
  PG: "Papua-Uusi-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippiinit",
  PL: "Puola",
  PT: "Portugali",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RW: "Ruanda",
  KN: "Saint Kitts ja Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychellit",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonsaaret",
  SO: "Somalia",
  ZA: "Etelä-Afrikka",
  KR: "Etelä-Korea",
  SS: "Etelä-Sudan",
  ES: "Espanja",
  LK: "Sri Lanka",
  VC: "Saint Vincent ja Grenadiinit",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Ruotsi",
  CH: "Sveitsi",
  TW: "Taiwan",
  TJ: "Tadžikistan",
  TZ: "Tansania",
  TH: "Thaimaa",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad ja Tobago",
  TN: "Tunisia",
  TR: "Turkki",
  TM: "Turkmenistan",
  TC: "Turks- ja Caicossaaret",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Arabiemiirikunnat",
  GB: "Iso-Britannia",
  US: "Yhdysvallat",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Yhdysvaltain Neitsytsaaret",
  YE: "Jemen",
  ZM: "Sambia",
  ZW: "Zimbabwe"
}, $s = {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algeriet",
  AS: "Amerikanska Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua och Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Österrike",
  AZ: "Azerbajdzjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Vitryssland",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Karibiska Nederländerna",
  BA: "Bosnien och Hercegovina",
  BW: "Botswana",
  BR: "Brasilien",
  BN: "Brunei",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodja",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KY: "Caymanöarna",
  CF: "Centralafrikanska republiken",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CO: "Colombia",
  KM: "Komorerna",
  CG: "Kongo-Brazzaville",
  CD: "Kongo-Kinshasa",
  CK: "Cooköarna",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Kroatien",
  CW: "Curaçao",
  CY: "Cypern",
  CZ: "Tjeckien",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikanska republiken",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ekvatorialguinea",
  EE: "Estland",
  ET: "Etiopien",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grekland",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkong SAR",
  HU: "Ungern",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanien",
  KZ: "Kazakstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirgizistan",
  LA: "Laos",
  LV: "Lettland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao SAR",
  MK: "Nordmakedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverna",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallöarna",
  MR: "Mauretanien",
  MU: "Mauritius",
  MX: "Mexiko",
  MD: "Moldavien",
  MN: "Mongoliet",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marocko",
  MZ: "Moçambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Nederländerna",
  NZ: "Nya Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestinska territorierna",
  PA: "Panama",
  PG: "Papua Nya Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerna",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Rumänien",
  RW: "Rwanda",
  KN: "S:t Kitts och Nevis",
  LC: "S:t Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudiarabien",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellerna",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakien",
  SI: "Slovenien",
  SB: "Salomonöarna",
  SO: "Somalia",
  ZA: "Sydafrika",
  KR: "Sydkorea",
  SS: "Sydsudan",
  ES: "Spanien",
  LK: "Sri Lanka",
  VC: "S:t Vincent och Grenadinerna",
  SR: "Surinam",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Schweiz",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad och Tobago",
  TN: "Tunisien",
  TR: "Turkiet",
  TM: "Turkmenistan",
  TC: "Turks- och Caicosöarna",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Förenade Arabemiraten",
  GB: "Storbritannien",
  US: "USA",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Amerikanska Jungfruöarna",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, at = {
  AF: "ავღანეთი",
  AL: "ალბანეთი",
  DZ: "ალჟირი",
  AS: "ამერიკის სამოა",
  AD: "ანდორა",
  AO: "ანგოლა",
  AI: "ანგილია",
  AG: "ანტიგუა და ბარბუდა",
  AR: "არგენტინა",
  AM: "სომხეთი",
  AW: "არუბა",
  AU: "ავსტრალია",
  AT: "ავსტრია",
  AZ: "აზერბაიჯანი",
  BS: "ბაჰამის კუნძულები",
  BH: "ბაჰრეინი",
  BD: "ბანგლადეში",
  BB: "ბარბადოსი",
  BY: "ბელარუსი",
  BE: "ბელგია",
  BZ: "ბელიზი",
  BJ: "ბენინი",
  BM: "ბერმუდა",
  BT: "ბუტანი",
  BO: "ბოლივია",
  BQ: "კარიბის ნიდერლანდები",
  BA: "ბოსნია და ჰერცეგოვინა",
  BW: "ბოტსვანა",
  BR: "ბრაზილია",
  BN: "ბრუნეი",
  BG: "ბულგარეთი",
  BF: "ბურკინა-ფასო",
  BI: "ბურუნდი",
  KH: "კამბოჯა",
  CM: "კამერუნი",
  CA: "კანადა",
  CV: "კაბო-ვერდე",
  KY: "კაიმანის კუნძულები",
  CF: "ცენტრალური აფრიკის რესპუბლიკა",
  TD: "ჩადი",
  CL: "ჩილე",
  CN: "ჩინეთი",
  CO: "კოლუმბია",
  KM: "კომორის კუნძულები",
  CG: "კონგო - ბრაზავილი",
  CD: "კონგო - კინშასა",
  CK: "კუკის კუნძულები",
  CR: "კოსტა-რიკა",
  CI: "კოტ-დივუარი",
  HR: "ხორვატია",
  CW: "კიურასაო",
  CY: "კვიპროსი",
  CZ: "ჩეხეთი",
  DK: "დანია",
  DJ: "ჯიბუტი",
  DM: "დომინიკა",
  DO: "დომინიკელთა რესპუბლიკა",
  EC: "ეკვადორი",
  EG: "ეგვიპტე",
  SV: "სალვადორი",
  GQ: "ეკვატორული გვინეა",
  EE: "ესტონეთი",
  ET: "ეთიოპია",
  FJ: "ფიჯი",
  FI: "ფინეთი",
  FR: "საფრანგეთი",
  GA: "გაბონი",
  GM: "გამბია",
  GE: "საქართველო",
  DE: "გერმანია",
  GH: "განა",
  GI: "გიბრალტარი",
  GR: "საბერძნეთი",
  GD: "გრენადა",
  GU: "გუამი",
  GT: "გვატემალა",
  GN: "გვინეა",
  GW: "გვინეა-ბისაუ",
  GY: "გაიანა",
  HT: "ჰაიტი",
  HN: "ჰონდურასი",
  HK: "ჰონკონგის სპეციალური ადმინისტრაციული რეგიონი, ჩინეთი",
  HU: "უნგრეთი",
  IS: "ისლანდია",
  IN: "ინდოეთი",
  ID: "ინდონეზია",
  IQ: "ერაყი",
  IE: "ირლანდია",
  IL: "ისრაელი",
  IT: "იტალია",
  JM: "იამაიკა",
  JP: "იაპონია",
  JE: "ჯერსი",
  JO: "იორდანია",
  KZ: "ყაზახეთი",
  KE: "კენია",
  KI: "კირიბატი",
  XK: "კოსოვო",
  KW: "ქუვეითი",
  KG: "ყირგიზეთი",
  LA: "ლაოსი",
  LV: "ლატვია",
  LB: "ლიბანი",
  LS: "ლესოთო",
  LR: "ლიბერია",
  LY: "ლიბია",
  LI: "ლიხტენშტაინი",
  LT: "ლიეტუვა",
  LU: "ლუქსემბურგი",
  MO: "მაკაოს სპეციალური ადმინისტრაციული რეგიონი, ჩინეთი",
  MK: "ჩრდილოეთ მაკედონია",
  MG: "მადაგასკარი",
  MW: "მალავი",
  MY: "მალაიზია",
  MV: "მალდივები",
  ML: "მალი",
  MT: "მალტა",
  MH: "მარშალის კუნძულები",
  MR: "მავრიტანია",
  MU: "მავრიკი",
  MX: "მექსიკა",
  MD: "მოლდოვა",
  MN: "მონღოლეთი",
  ME: "მონტენეგრო",
  MS: "მონსერატი",
  MA: "მაროკო",
  MZ: "მოზამბიკი",
  MM: "მიანმარი (ბირმა)",
  NA: "ნამიბია",
  NP: "ნეპალი",
  NL: "ნიდერლანდები",
  NZ: "ახალი ზელანდია",
  NI: "ნიკარაგუა",
  NE: "ნიგერი",
  NG: "ნიგერია",
  NO: "ნორვეგია",
  OM: "ომანი",
  PK: "პაკისტანი",
  PS: "პალესტინის ტერიტორიები",
  PA: "პანამა",
  PG: "პაპუა-ახალი გვინეა",
  PY: "პარაგვაი",
  PE: "პერუ",
  PH: "ფილიპინები",
  PL: "პოლონეთი",
  PT: "პორტუგალია",
  PR: "პუერტო-რიკო",
  QA: "კატარი",
  RO: "რუმინეთი",
  RW: "რუანდა",
  KN: "სენტ-კიტსი და ნევისი",
  LC: "სენტ-ლუსია",
  WS: "სამოა",
  SM: "სან-მარინო",
  SA: "საუდის არაბეთი",
  SN: "სენეგალი",
  RS: "სერბეთი",
  SC: "სეიშელის კუნძულები",
  SL: "სიერა-ლეონე",
  SG: "სინგაპური",
  SX: "სინტ-მარტენი",
  SK: "სლოვაკეთი",
  SI: "სლოვენია",
  SB: "სოლომონის კუნძულები",
  SO: "სომალი",
  ZA: "სამხრეთ აფრიკის რესპუბლიკა",
  KR: "სამხრეთ კორეა",
  SS: "სამხრეთ სუდანი",
  ES: "ესპანეთი",
  LK: "შრი-ლანკა",
  VC: "სენტ-ვინსენტი და გრენადინები",
  SR: "სურინამი",
  SZ: "სვაზილენდი",
  SE: "შვედეთი",
  CH: "შვეიცარია",
  TW: "ტაივანი",
  TJ: "ტაჯიკეთი",
  TZ: "ტანზანია",
  TH: "ტაილანდი",
  TG: "ტოგო",
  TO: "ტონგა",
  TT: "ტრინიდადი და ტობაგო",
  TN: "ტუნისი",
  TR: "თურქეთი",
  TM: "თურქმენეთი",
  TC: "თერქს-ქაიქოსის კუნძულები",
  UG: "უგანდა",
  UA: "უკრაინა",
  AE: "არაბთა გაერთიანებული საამიროები",
  GB: "გაერთიანებული სამეფო",
  US: "ამერიკის შეერთებული შტატები",
  UY: "ურუგვაი",
  UZ: "უზბეკეთი",
  VU: "ვანუატუ",
  VE: "ვენესუელა",
  VN: "ვიეტნამი",
  VI: "აშშ-ის ვირჯინის კუნძულები",
  YE: "იემენი",
  ZM: "ზამბია",
  ZW: "ზიმბაბვე"
}, et = {
  AF: "Αφγανιστάν",
  AL: "Αλβανία",
  DZ: "Αλγερία",
  AS: "Αμερικανική Σαμόα",
  AD: "Ανδόρα",
  AO: "Αγκόλα",
  AI: "Ανγκουίλα",
  AG: "Αντίγκουα και Μπαρμπούντα",
  AR: "Αργεντινή",
  AM: "Αρμενία",
  AW: "Αρούμπα",
  AU: "Αυστραλία",
  AT: "Αυστρία",
  AZ: "Αζερμπαϊτζάν",
  BS: "Μπαχάμες",
  BH: "Μπαχρέιν",
  BD: "Μπανγκλαντές",
  BB: "Μπαρμπέιντος",
  BY: "Λευκορωσία",
  BE: "Βέλγιο",
  BZ: "Μπελίζ",
  BJ: "Μπενίν",
  BM: "Βερμούδες",
  BT: "Μπουτάν",
  BO: "Βολιβία",
  BQ: "Ολλανδία Καραϊβικής",
  BA: "Βοσνία - Ερζεγοβίνη",
  BW: "Μποτσουάνα",
  BR: "Βραζιλία",
  BN: "Μπρουνέι",
  BG: "Βουλγαρία",
  BF: "Μπουρκίνα Φάσο",
  BI: "Μπουρούντι",
  KH: "Καμπότζη",
  CM: "Καμερούν",
  CA: "Καναδάς",
  CV: "Πράσινο Ακρωτήριο",
  KY: "Νήσοι Κέιμαν",
  CF: "Κεντροαφρικανική Δημοκρατία",
  TD: "Τσαντ",
  CL: "Χιλή",
  CN: "Κίνα",
  CO: "Κολομβία",
  KM: "Κομόρες",
  CG: "Κονγκό - Μπραζαβίλ",
  CD: "Κονγκό - Κινσάσα",
  CK: "Νήσοι Κουκ",
  CR: "Κόστα Ρίκα",
  CI: "Ακτή Ελεφαντοστού",
  HR: "Κροατία",
  CW: "Κουρασάο",
  CY: "Κύπρος",
  CZ: "Τσεχία",
  DK: "Δανία",
  DJ: "Τζιμπουτί",
  DM: "Ντομίνικα",
  DO: "Δομινικανή Δημοκρατία",
  EC: "Ισημερινός",
  EG: "Αίγυπτος",
  SV: "Ελ Σαλβαδόρ",
  GQ: "Ισημερινή Γουινέα",
  EE: "Εσθονία",
  ET: "Αιθιοπία",
  FJ: "Φίτζι",
  FI: "Φινλανδία",
  FR: "Γαλλία",
  GA: "Γκαμπόν",
  GM: "Γκάμπια",
  GE: "Γεωργία",
  DE: "Γερμανία",
  GH: "Γκάνα",
  GI: "Γιβραλτάρ",
  GR: "Ελλάδα",
  GD: "Γρενάδα",
  GU: "Γκουάμ",
  GT: "Γουατεμάλα",
  GN: "Γουινέα",
  GW: "Γουινέα Μπισάου",
  GY: "Γουιάνα",
  HT: "Αϊτή",
  HN: "Ονδούρα",
  HK: "Χονγκ Κονγκ ΕΔΠ Κίνας",
  HU: "Ουγγαρία",
  IS: "Ισλανδία",
  IN: "Ινδία",
  ID: "Ινδονησία",
  IQ: "Ιράκ",
  IE: "Ιρλανδία",
  IL: "Ισραήλ",
  IT: "Ιταλία",
  JM: "Τζαμάικα",
  JP: "Ιαπωνία",
  JE: "Τζέρζι",
  JO: "Ιορδανία",
  KZ: "Καζακστάν",
  KE: "Κένυα",
  KI: "Κιριμπάτι",
  XK: "Κοσσυφοπέδιο",
  KW: "Κουβέιτ",
  KG: "Κιργιστάν",
  LA: "Λάος",
  LV: "Λετονία",
  LB: "Λίβανος",
  LS: "Λεσότο",
  LR: "Λιβερία",
  LY: "Λιβύη",
  LI: "Λιχτενστάιν",
  LT: "Λιθουανία",
  LU: "Λουξεμβούργο",
  MO: "Μακάο ΕΔΠ Κίνας",
  MK: "Βόρεια Μακεδονία",
  MG: "Μαδαγασκάρη",
  MW: "Μαλάουι",
  MY: "Μαλαισία",
  MV: "Μαλδίβες",
  ML: "Μάλι",
  MT: "Μάλτα",
  MH: "Νήσοι Μάρσαλ",
  MR: "Μαυριτανία",
  MU: "Μαυρίκιος",
  MX: "Μεξικό",
  MD: "Μολδαβία",
  MN: "Μογγολία",
  ME: "Μαυροβούνιο",
  MS: "Μονσεράτ",
  MA: "Μαρόκο",
  MZ: "Μοζαμβίκη",
  MM: "Μιανμάρ (Βιρμανία)",
  NA: "Ναμίμπια",
  NP: "Νεπάλ",
  NL: "Κάτω Χώρες",
  NZ: "Νέα Ζηλανδία",
  NI: "Νικαράγουα",
  NE: "Νίγηρας",
  NG: "Νιγηρία",
  NO: "Νορβηγία",
  OM: "Ομάν",
  PK: "Πακιστάν",
  PS: "Παλαιστινιακά Εδάφη",
  PA: "Παναμάς",
  PG: "Παπούα Νέα Γουινέα",
  PY: "Παραγουάη",
  PE: "Περού",
  PH: "Φιλιππίνες",
  PL: "Πολωνία",
  PT: "Πορτογαλία",
  PR: "Πουέρτο Ρίκο",
  QA: "Κατάρ",
  RO: "Ρουμανία",
  RW: "Ρουάντα",
  KN: "Σεν Κιτς και Νέβις",
  LC: "Αγία Λουκία",
  WS: "Σαμόα",
  SM: "Άγιος Μαρίνος",
  SA: "Σαουδική Αραβία",
  SN: "Σενεγάλη",
  RS: "Σερβία",
  SC: "Σεϋχέλλες",
  SL: "Σιέρα Λεόνε",
  SG: "Σιγκαπούρη",
  SX: "Άγιος Μαρτίνος (Ολλανδικό τμήμα)",
  SK: "Σλοβακία",
  SI: "Σλοβενία",
  SB: "Νήσοι Σολομώντος",
  SO: "Σομαλία",
  ZA: "Νότια Αφρική",
  KR: "Νότια Κορέα",
  SS: "Νότιο Σουδάν",
  ES: "Ισπανία",
  LK: "Σρι Λάνκα",
  VC: "Άγιος Βικέντιος και Γρεναδίνες",
  SR: "Σουρινάμ",
  SZ: "Εσουατίνι",
  SE: "Σουηδία",
  CH: "Ελβετία",
  TW: "Ταϊβάν",
  TJ: "Τατζικιστάν",
  TZ: "Τανζανία",
  TH: "Ταϊλάνδη",
  TG: "Τόγκο",
  TO: "Τόνγκα",
  TT: "Τρινιντάντ και Τομπάγκο",
  TN: "Τυνησία",
  TR: "Τουρκία",
  TM: "Τουρκμενιστάν",
  TC: "Νήσοι Τερκς και Κάικος",
  UG: "Ουγκάντα",
  UA: "Ουκρανία",
  AE: "Ηνωμένα Αραβικά Εμιράτα",
  GB: "Ηνωμένο Βασίλειο",
  US: "Ηνωμένες Πολιτείες",
  UY: "Ουρουγουάη",
  UZ: "Ουζμπεκιστάν",
  VU: "Βανουάτου",
  VE: "Βενεζουέλα",
  VN: "Βιετνάμ",
  VI: "Αμερικανικές Παρθένες Νήσοι",
  YE: "Υεμένη",
  ZM: "Ζάμπια",
  ZW: "Ζιμπάμπουε"
}, nt = {
  AF: "阿富汗",
  AL: "阿尔巴尼亚",
  DZ: "阿尔及利亚",
  AS: "美属萨摩亚",
  AD: "安道尔",
  AO: "安哥拉",
  AI: "安圭拉",
  AG: "安提瓜和巴布达",
  AR: "阿根廷",
  AM: "亚美尼亚",
  AW: "阿鲁巴",
  AU: "澳大利亚",
  AT: "奥地利",
  AZ: "阿塞拜疆",
  BS: "巴哈马",
  BH: "巴林",
  BD: "孟加拉国",
  BB: "巴巴多斯",
  BY: "白俄罗斯",
  BE: "比利时",
  BZ: "伯利兹",
  BJ: "贝宁",
  BM: "百慕大",
  BT: "不丹",
  BO: "玻利维亚",
  BQ: "荷属加勒比区",
  BA: "波斯尼亚和黑塞哥维那",
  BW: "博茨瓦纳",
  BR: "巴西",
  BN: "文莱",
  BG: "保加利亚",
  BF: "布基纳法索",
  BI: "布隆迪",
  KH: "柬埔寨",
  CM: "喀麦隆",
  CA: "加拿大",
  CV: "佛得角",
  KY: "开曼群岛",
  CF: "中非共和国",
  TD: "乍得",
  CL: "智利",
  CN: "中国",
  CO: "哥伦比亚",
  KM: "科摩罗",
  CG: "刚果（布）",
  CD: "刚果（金）",
  CK: "库克群岛",
  CR: "哥斯达黎加",
  CI: "科特迪瓦",
  HR: "克罗地亚",
  CW: "库拉索",
  CY: "塞浦路斯",
  CZ: "捷克",
  DK: "丹麦",
  DJ: "吉布提",
  DM: "多米尼克",
  DO: "多米尼加共和国",
  EC: "厄瓜多尔",
  EG: "埃及",
  SV: "萨尔瓦多",
  GQ: "赤道几内亚",
  EE: "爱沙尼亚",
  ET: "埃塞俄比亚",
  FJ: "斐济",
  FI: "芬兰",
  FR: "法国",
  GA: "加蓬",
  GM: "冈比亚",
  GE: "格鲁吉亚",
  DE: "德国",
  GH: "加纳",
  GI: "直布罗陀",
  GR: "希腊",
  GD: "格林纳达",
  GU: "关岛",
  GT: "危地马拉",
  GN: "几内亚",
  GW: "几内亚比绍",
  GY: "圭亚那",
  HT: "海地",
  HN: "洪都拉斯",
  HK: "中国香港特别行政区",
  HU: "匈牙利",
  IS: "冰岛",
  IN: "印度",
  ID: "印度尼西亚",
  IQ: "伊拉克",
  IE: "爱尔兰",
  IL: "以色列",
  IT: "意大利",
  JM: "牙买加",
  JP: "日本",
  JE: "泽西岛",
  JO: "约旦",
  KZ: "哈萨克斯坦",
  KE: "肯尼亚",
  KI: "基里巴斯",
  XK: "科索沃",
  KW: "科威特",
  KG: "吉尔吉斯斯坦",
  LA: "老挝",
  LV: "拉脱维亚",
  LB: "黎巴嫩",
  LS: "莱索托",
  LR: "利比里亚",
  LY: "利比亚",
  LI: "列支敦士登",
  LT: "立陶宛",
  LU: "卢森堡",
  MO: "中国澳门特别行政区",
  MK: "北马其顿",
  MG: "马达加斯加",
  MW: "马拉维",
  MY: "马来西亚",
  MV: "马尔代夫",
  ML: "马里",
  MT: "马耳他",
  MH: "马绍尔群岛",
  MR: "毛里塔尼亚",
  MU: "毛里求斯",
  MX: "墨西哥",
  MD: "摩尔多瓦",
  MN: "蒙古",
  ME: "黑山",
  MS: "蒙特塞拉特",
  MA: "摩洛哥",
  MZ: "莫桑比克",
  MM: "缅甸",
  NA: "纳米比亚",
  NP: "尼泊尔",
  NL: "荷兰",
  NZ: "新西兰",
  NI: "尼加拉瓜",
  NE: "尼日尔",
  NG: "尼日利亚",
  NO: "挪威",
  OM: "阿曼",
  PK: "巴基斯坦",
  PS: "巴勒斯坦领土",
  PA: "巴拿马",
  PG: "巴布亚新几内亚",
  PY: "巴拉圭",
  PE: "秘鲁",
  PH: "菲律宾",
  PL: "波兰",
  PT: "葡萄牙",
  PR: "波多黎各",
  QA: "卡塔尔",
  RO: "罗马尼亚",
  RW: "卢旺达",
  KN: "圣基茨和尼维斯",
  LC: "圣卢西亚",
  WS: "萨摩亚",
  SM: "圣马力诺",
  SA: "沙特阿拉伯",
  SN: "塞内加尔",
  RS: "塞尔维亚",
  SC: "塞舌尔",
  SL: "塞拉利昂",
  SG: "新加坡",
  SX: "荷属圣马丁",
  SK: "斯洛伐克",
  SI: "斯洛文尼亚",
  SB: "所罗门群岛",
  SO: "索马里",
  ZA: "南非",
  KR: "韩国",
  SS: "南苏丹",
  ES: "西班牙",
  LK: "斯里兰卡",
  VC: "圣文森特和格林纳丁斯",
  SR: "苏里南",
  SZ: "斯威士兰",
  SE: "瑞典",
  CH: "瑞士",
  TW: "台湾",
  TJ: "塔吉克斯坦",
  TZ: "坦桑尼亚",
  TH: "泰国",
  TG: "多哥",
  TO: "汤加",
  TT: "特立尼达和多巴哥",
  TN: "突尼斯",
  TR: "土耳其",
  TM: "土库曼斯坦",
  TC: "特克斯和凯科斯群岛",
  UG: "乌干达",
  UA: "乌克兰",
  AE: "阿拉伯联合酋长国",
  GB: "英国",
  US: "美国",
  UY: "乌拉圭",
  UZ: "乌兹别克斯坦",
  VU: "瓦努阿图",
  VE: "委内瑞拉",
  VN: "越南",
  VI: "美属维尔京群岛",
  YE: "也门",
  ZM: "赞比亚",
  ZW: "津巴布韦"
}, it = {
  AF: "Afganistan",
  AL: "Albanija",
  DZ: "Alžir",
  AS: "Američka Samoa",
  AD: "Andora",
  AO: "Angola",
  AI: "Angvila",
  AG: "Antigva i Barbuda",
  AR: "Argentina",
  AM: "Armenija",
  AW: "Aruba",
  AU: "Australija",
  AT: "Austrija",
  AZ: "Azerbajdžan",
  BS: "Bahami",
  BH: "Bahrein",
  BD: "Bangladeš",
  BB: "Barbados",
  BY: "Bjelorusija",
  BE: "Belgija",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudi",
  BT: "Butan",
  BO: "Bolivija",
  BQ: "Karipski otoci Nizozemske",
  BA: "Bosna i Hercegovina",
  BW: "Bocvana",
  BR: "Brazil",
  BN: "Brunej",
  BG: "Bugarska",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Zelenortska Republika",
  KY: "Kajmanski otoci",
  CF: "Srednjoafrička Republika",
  TD: "Čad",
  CL: "Čile",
  CN: "Kina",
  CO: "Kolumbija",
  KM: "Komori",
  CG: "Kongo - Brazzaville",
  CD: "Kongo - Kinshasa",
  CK: "Cookovi otoci",
  CR: "Kostarika",
  CI: "Obala Bjelokosti",
  HR: "Hrvatska",
  CW: "Curaçao",
  CY: "Cipar",
  CZ: "Češka",
  DK: "Danska",
  DJ: "Džibuti",
  DM: "Dominika",
  DO: "Dominikanska Republika",
  EC: "Ekvador",
  EG: "Egipat",
  SV: "Salvador",
  GQ: "Ekvatorska Gvineja",
  EE: "Estonija",
  ET: "Etiopija",
  FJ: "Fidži",
  FI: "Finska",
  FR: "Francuska",
  GA: "Gabon",
  GM: "Gambija",
  GE: "Gruzija",
  DE: "Njemačka",
  GH: "Gana",
  GI: "Gibraltar",
  GR: "Grčka",
  GD: "Grenada",
  GU: "Guam",
  GT: "Gvatemala",
  GN: "Gvineja",
  GW: "Gvineja Bisau",
  GY: "Gvajana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "PUP Hong Kong Kina",
  HU: "Mađarska",
  IS: "Island",
  IN: "Indija",
  ID: "Indonezija",
  IQ: "Irak",
  IE: "Irska",
  IL: "Izrael",
  IT: "Italija",
  JM: "Jamajka",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazahstan",
  KE: "Kenija",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuvajt",
  KG: "Kirgistan",
  LA: "Laos",
  LV: "Latvija",
  LB: "Libanon",
  LS: "Lesoto",
  LR: "Liberija",
  LY: "Libija",
  LI: "Lihtenštajn",
  LT: "Litva",
  LU: "Luksemburg",
  MO: "PUP Makao Kina",
  MK: "Sjeverna Makedonija",
  MG: "Madagaskar",
  MW: "Malavi",
  MY: "Malezija",
  MV: "Maldivi",
  ML: "Mali",
  MT: "Malta",
  MH: "Maršalovi Otoci",
  MR: "Mauretanija",
  MU: "Mauricijus",
  MX: "Meksiko",
  MD: "Moldavija",
  MN: "Mongolija",
  ME: "Crna Gora",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Mjanmar (Burma)",
  NA: "Namibija",
  NP: "Nepal",
  NL: "Nizozemska",
  NZ: "Novi Zeland",
  NI: "Nikaragva",
  NE: "Niger",
  NG: "Nigerija",
  NO: "Norveška",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestinsko područje",
  PA: "Panama",
  PG: "Papua Nova Gvineja",
  PY: "Paragvaj",
  PE: "Peru",
  PH: "Filipini",
  PL: "Poljska",
  PT: "Portugal",
  PR: "Portoriko",
  QA: "Katar",
  RO: "Rumunjska",
  RW: "Ruanda",
  KN: "Sveti Kristofor i Nevis",
  LC: "Sveta Lucija",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudijska Arabija",
  SN: "Senegal",
  RS: "Srbija",
  SC: "Sejšeli",
  SL: "Sijera Leone",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slovačka",
  SI: "Slovenija",
  SB: "Salomonski Otoci",
  SO: "Somalija",
  ZA: "Južnoafrička Republika",
  KR: "Južna Koreja",
  SS: "Južni Sudan",
  ES: "Španjolska",
  LK: "Šri Lanka",
  VC: "Sveti Vincent i Grenadini",
  SR: "Surinam",
  SZ: "Esvatini",
  SE: "Švedska",
  CH: "Švicarska",
  TW: "Tajvan",
  TJ: "Tadžikistan",
  TZ: "Tanzanija",
  TH: "Tajland",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad i Tobago",
  TN: "Tunis",
  TR: "Turska",
  TM: "Turkmenistan",
  TC: "Otoci Turks i Caicos",
  UG: "Uganda",
  UA: "Ukrajina",
  AE: "Ujedinjeni Arapski Emirati",
  GB: "Ujedinjeno Kraljevstvo",
  US: "Sjedinjene Američke Države",
  UY: "Urugvaj",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vijetnam",
  VI: "Američki Djevičanski otoci",
  YE: "Jemen",
  ZM: "Zambija",
  ZW: "Zimbabve"
}, rt = {
  AF: "Afganisztán",
  AL: "Albánia",
  DZ: "Algéria",
  AS: "Amerikai Szamoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua és Barbuda",
  AR: "Argentína",
  AM: "Örményország",
  AW: "Aruba",
  AU: "Ausztrália",
  AT: "Ausztria",
  AZ: "Azerbajdzsán",
  BS: "Bahama-szigetek",
  BH: "Bahrein",
  BD: "Banglades",
  BB: "Barbados",
  BY: "Belarusz",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhután",
  BO: "Bolívia",
  BQ: "Holland Karib-térség",
  BA: "Bosznia-Hercegovina",
  BW: "Botswana",
  BR: "Brazília",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodzsa",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Zöld-foki Köztársaság",
  KY: "Kajmán-szigetek",
  CF: "Közép-afrikai Köztársaság",
  TD: "Csád",
  CL: "Chile",
  CN: "Kína",
  CO: "Kolumbia",
  KM: "Comore-szigetek",
  CG: "Kongó – Brazzaville",
  CD: "Kongó – Kinshasa",
  CK: "Cook-szigetek",
  CR: "Costa Rica",
  CI: "Elefántcsontpart",
  HR: "Horvátország",
  CW: "Curaçao",
  CY: "Ciprus",
  CZ: "Csehország",
  DK: "Dánia",
  DJ: "Dzsibuti",
  DM: "Dominika",
  DO: "Dominikai Köztársaság",
  EC: "Ecuador",
  EG: "Egyiptom",
  SV: "Salvador",
  GQ: "Egyenlítői-Guinea",
  EE: "Észtország",
  ET: "Etiópia",
  FJ: "Fidzsi",
  FI: "Finnország",
  FR: "Franciaország",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Grúzia",
  DE: "Németország",
  GH: "Ghána",
  GI: "Gibraltár",
  GR: "Görögország",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Bissau-Guinea",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkong KKT",
  HU: "Magyarország",
  IS: "Izland",
  IN: "India",
  ID: "Indonézia",
  IQ: "Irak",
  IE: "Írország",
  IL: "Izrael",
  IT: "Olaszország",
  JM: "Jamaica",
  JP: "Japán",
  JE: "Jersey",
  JO: "Jordánia",
  KZ: "Kazahsztán",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Koszovó",
  KW: "Kuvait",
  KG: "Kirgizisztán",
  LA: "Laosz",
  LV: "Lettország",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Litvánia",
  LU: "Luxemburg",
  MO: "Makaó KKT",
  MK: "Észak-Macedónia",
  MG: "Madagaszkár",
  MW: "Malawi",
  MY: "Malajzia",
  MV: "Maldív-szigetek",
  ML: "Mali",
  MT: "Málta",
  MH: "Marshall-szigetek",
  MR: "Mauritánia",
  MU: "Mauritius",
  MX: "Mexikó",
  MD: "Moldova",
  MN: "Mongólia",
  ME: "Montenegró",
  MS: "Montserrat",
  MA: "Marokkó",
  MZ: "Mozambik",
  MM: "Mianmar",
  NA: "Namíbia",
  NP: "Nepál",
  NL: "Hollandia",
  NZ: "Új-Zéland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NO: "Norvégia",
  OM: "Omán",
  PK: "Pakisztán",
  PS: "Palesztin Autonómia",
  PA: "Panama",
  PG: "Pápua Új-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Fülöp-szigetek",
  PL: "Lengyelország",
  PT: "Portugália",
  PR: "Puerto Rico",
  QA: "Katar",
  RO: "Románia",
  RW: "Ruanda",
  KN: "Saint Kitts és Nevis",
  LC: "Saint Lucia",
  WS: "Szamoa",
  SM: "San Marino",
  SA: "Szaúd-Arábia",
  SN: "Szenegál",
  RS: "Szerbia",
  SC: "Seychelle-szigetek",
  SL: "Sierra Leone",
  SG: "Szingapúr",
  SX: "Sint Maarten",
  SK: "Szlovákia",
  SI: "Szlovénia",
  SB: "Salamon-szigetek",
  SO: "Szomália",
  ZA: "Dél-afrikai Köztársaság",
  KR: "Dél-Korea",
  SS: "Dél-Szudán",
  ES: "Spanyolország",
  LK: "Srí Lanka",
  VC: "Saint Vincent és a Grenadine-szigetek",
  SR: "Suriname",
  SZ: "Szváziföld",
  SE: "Svédország",
  CH: "Svájc",
  TW: "Tajvan",
  TJ: "Tádzsikisztán",
  TZ: "Tanzánia",
  TH: "Thaiföld",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad és Tobago",
  TN: "Tunézia",
  TR: "Törökország",
  TM: "Türkmenisztán",
  TC: "Turks- és Caicos-szigetek",
  UG: "Uganda",
  UA: "Ukrajna",
  AE: "Egyesült Arab Emírségek",
  GB: "Egyesült Királyság",
  US: "Egyesült Államok",
  UY: "Uruguay",
  UZ: "Üzbegisztán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnám",
  VI: "Amerikai Virgin-szigetek",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, ot = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Aljazair",
  AS: "Samoa Amerika",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua dan Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Belanda Karibia",
  BA: "Bosnia dan Herzegovina",
  BW: "Botswana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kamboja",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Tanjung Verde",
  KY: "Kepulauan Cayman",
  CF: "Republik Afrika Tengah",
  TD: "Chad",
  CL: "Cile",
  CN: "Tiongkok",
  CO: "Kolombia",
  KM: "Komoro",
  CG: "Kongo - Brazzaville",
  CD: "Kongo - Kinshasa",
  CK: "Kepulauan Cook",
  CR: "Kosta Rika",
  CI: "Côte d’Ivoire",
  HR: "Kroasia",
  CW: "Curaçao",
  CY: "Siprus",
  CZ: "Ceko",
  DK: "Denmark",
  DJ: "Jibuti",
  DM: "Dominika",
  DO: "Republik Dominika",
  EC: "Ekuador",
  EG: "Mesir",
  SV: "El Salvador",
  GQ: "Guinea Ekuatorial",
  EE: "Estonia",
  ET: "Etiopia",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Prancis",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Jerman",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Yunani",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hong Kong DAK Tiongkok",
  HU: "Hungaria",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Jepang",
  JE: "Jersey",
  JO: "Yordania",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luksemburg",
  MO: "Makau DAK Tiongkok",
  MK: "Makedonia Utara",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maladewa",
  ML: "Mali",
  MT: "Malta",
  MH: "Kepulauan Marshall",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Meksiko",
  MD: "Moldova",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Belanda",
  NZ: "Selandia Baru",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Wilayah Palestina",
  PA: "Panama",
  PG: "Papua Nugini",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipina",
  PL: "Polandia",
  PT: "Portugal",
  PR: "Puerto Riko",
  QA: "Qatar",
  RO: "Rumania",
  RW: "Rwanda",
  KN: "Saint Kitts dan Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Arab Saudi",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapura",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Kepulauan Solomon",
  SO: "Somalia",
  ZA: "Afrika Selatan",
  KR: "Korea Selatan",
  SS: "Sudan Selatan",
  ES: "Spanyol",
  LK: "Sri Lanka",
  VC: "Saint Vincent dan Grenadine",
  SR: "Suriname",
  SZ: "eSwatini",
  SE: "Swedia",
  CH: "Swiss",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad dan Tobago",
  TN: "Tunisia",
  TR: "Turki",
  TM: "Turkmenistan",
  TC: "Kepulauan Turks dan Caicos",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Uni Emirat Arab",
  GB: "Inggris Raya",
  US: "Amerika Serikat",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Kepulauan Virgin Amerika Serikat",
  YE: "Yaman",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, st = {
  AF: "अफ़गानिस्तान",
  AL: "अल्बानिया",
  DZ: "अल्जीरिया",
  AS: "अमेरिकी समोआ",
  AD: "एंडोरा",
  AO: "अंगोला",
  AI: "एंग्विला",
  AG: "एंटिगुआ और बरबुडा",
  AR: "अर्जेंटीना",
  AM: "आर्मेनिया",
  AW: "अरूबा",
  AU: "ऑस्ट्रेलिया",
  AT: "ऑस्ट्रिया",
  AZ: "अज़रबैजान",
  BS: "बहामास",
  BH: "बहरीन",
  BD: "बांग्लादेश",
  BB: "बारबाडोस",
  BY: "बेलारूस",
  BE: "बेल्जियम",
  BZ: "बेलीज़",
  BJ: "बेनिन",
  BM: "बरमूडा",
  BT: "भूटान",
  BO: "बोलीविया",
  BQ: "कैरिबियन नीदरलैंड",
  BA: "बोस्निया और हर्ज़ेगोविना",
  BW: "बोत्स्वाना",
  BR: "ब्राज़ील",
  BN: "ब्रूनेई",
  BG: "बुल्गारिया",
  BF: "बुर्किना फ़ासो",
  BI: "बुरुंडी",
  KH: "कंबोडिया",
  CM: "कैमरून",
  CA: "कनाडा",
  CV: "केप वर्ड",
  KY: "कैमेन द्वीपसमूह",
  CF: "मध्य अफ़्रीकी गणराज्य",
  TD: "चाड",
  CL: "चिली",
  CN: "चीन",
  CO: "कोलंबिया",
  KM: "कोमोरोस",
  CG: "कांगो – ब्राज़ाविल",
  CD: "कांगो - किंशासा",
  CK: "कुक द्वीपसमूह",
  CR: "कोस्टारिका",
  CI: "कोत दिवुआर",
  HR: "क्रोएशिया",
  CW: "कुरासाओ",
  CY: "साइप्रस",
  CZ: "चेकिया",
  DK: "डेनमार्क",
  DJ: "जिबूती",
  DM: "डोमिनिका",
  DO: "डोमिनिकन गणराज्य",
  EC: "इक्वाडोर",
  EG: "मिस्र",
  SV: "अल सल्वाडोर",
  GQ: "इक्वेटोरियल गिनी",
  EE: "एस्टोनिया",
  ET: "इथियोपिया",
  FJ: "फ़िजी",
  FI: "फ़िनलैंड",
  FR: "फ़्रांस",
  GA: "गैबॉन",
  GM: "गाम्बिया",
  GE: "जॉर्जिया",
  DE: "जर्मनी",
  GH: "घाना",
  GI: "जिब्राल्टर",
  GR: "यूनान",
  GD: "ग्रेनाडा",
  GU: "गुआम",
  GT: "ग्वाटेमाला",
  GN: "गिनी",
  GW: "गिनी-बिसाउ",
  GY: "गुयाना",
  HT: "हैती",
  HN: "होंडूरास",
  HK: "हाँग काँग (चीन विशेष प्रशासनिक क्षेत्र)",
  HU: "हंगरी",
  IS: "आइसलैंड",
  IN: "भारत",
  ID: "इंडोनेशिया",
  IQ: "इराक",
  IE: "आयरलैंड",
  IL: "इज़राइल",
  IT: "इटली",
  JM: "जमैका",
  JP: "जापान",
  JE: "जर्सी",
  JO: "जॉर्डन",
  KZ: "कज़ाखस्तान",
  KE: "केन्या",
  KI: "किरिबाती",
  XK: "कोसोवो",
  KW: "कुवैत",
  KG: "किर्गिज़स्तान",
  LA: "लाओस",
  LV: "लातविया",
  LB: "लेबनान",
  LS: "लेसोथो",
  LR: "लाइबेरिया",
  LY: "लीबिया",
  LI: "लिचेंस्टीन",
  LT: "लिथुआनिया",
  LU: "लग्ज़मबर्ग",
  MO: "मकाऊ (विशेष प्रशासनिक क्षेत्र चीन)",
  MK: "उत्तरी मकदूनिया",
  MG: "मेडागास्कर",
  MW: "मलावी",
  MY: "मलेशिया",
  MV: "मालदीव",
  ML: "माली",
  MT: "माल्टा",
  MH: "मार्शल द्वीपसमूह",
  MR: "मॉरिटानिया",
  MU: "मॉरीशस",
  MX: "मैक्सिको",
  MD: "मॉल्डोवा",
  MN: "मंगोलिया",
  ME: "मोंटेनेग्रो",
  MS: "मोंटसेरात",
  MA: "मोरक्को",
  MZ: "मोज़ांबिक",
  MM: "म्यांमार (बर्मा)",
  NA: "नामीबिया",
  NP: "नेपाल",
  NL: "नीदरलैंड",
  NZ: "न्यूज़ीलैंड",
  NI: "निकारागुआ",
  NE: "नाइजर",
  NG: "नाइजीरिया",
  NO: "नॉर्वे",
  OM: "ओमान",
  PK: "पाकिस्तान",
  PS: "फ़िलिस्तीनी क्षेत्र",
  PA: "पनामा",
  PG: "पापुआ न्यू गिनी",
  PY: "पराग्वे",
  PE: "पेरू",
  PH: "फ़िलिपींस",
  PL: "पोलैंड",
  PT: "पुर्तगाल",
  PR: "पोर्टो रिको",
  QA: "क़तर",
  RO: "रोमानिया",
  RW: "रवांडा",
  KN: "सेंट किट्स और नेविस",
  LC: "सेंट लूसिया",
  WS: "समोआ",
  SM: "सैन मेरीनो",
  SA: "सऊदी अरब",
  SN: "सेनेगल",
  RS: "सर्बिया",
  SC: "सेशेल्स",
  SL: "सिएरा लियोन",
  SG: "सिंगापुर",
  SX: "सिंट मार्टिन",
  SK: "स्लोवाकिया",
  SI: "स्लोवेनिया",
  SB: "सोलोमन द्वीपसमूह",
  SO: "सोमालिया",
  ZA: "दक्षिण अफ़्रीका",
  KR: "दक्षिण कोरिया",
  SS: "दक्षिण सूडान",
  ES: "स्पेन",
  LK: "श्रीलंका",
  VC: "सेंट विंसेंट और ग्रेनाडाइंस",
  SR: "सूरीनाम",
  SZ: "एस्वाटिनी",
  SE: "स्वीडन",
  CH: "स्विट्ज़रलैंड",
  TW: "ताइवान",
  TJ: "ताजिकिस्तान",
  TZ: "तंज़ानिया",
  TH: "थाईलैंड",
  TG: "टोगो",
  TO: "टोंगा",
  TT: "त्रिनिदाद और टोबैगो",
  TN: "ट्यूनीशिया",
  TR: "तुर्की",
  TM: "तुर्कमेनिस्तान",
  TC: "तुर्क और कैकोज़ द्वीपसमूह",
  UG: "युगांडा",
  UA: "यूक्रेन",
  AE: "संयुक्त अरब अमीरात",
  GB: "यूनाइटेड किंगडम",
  US: "संयुक्त राज्य",
  UY: "उरूग्वे",
  UZ: "उज़्बेकिस्तान",
  VU: "वनुआतू",
  VE: "वेनेज़ुएला",
  VN: "वियतनाम",
  VI: "यू॰एस॰ वर्जिन द्वीपसमूह",
  YE: "यमन",
  ZM: "ज़ाम्बिया",
  ZW: "ज़िम्बाब्वे"
}, tt = {
  AF: "Afganistanas",
  AL: "Albanija",
  DZ: "Alžyras",
  AS: "Amerikos Samoa",
  AD: "Andora",
  AO: "Angola",
  AI: "Angilija",
  AG: "Antigva ir Barbuda",
  AR: "Argentina",
  AM: "Armėnija",
  AW: "Aruba",
  AU: "Australija",
  AT: "Austrija",
  AZ: "Azerbaidžanas",
  BS: "Bahamos",
  BH: "Bahreinas",
  BD: "Bangladešas",
  BB: "Barbadosas",
  BY: "Baltarusija",
  BE: "Belgija",
  BZ: "Belizas",
  BJ: "Beninas",
  BM: "Bermuda",
  BT: "Butanas",
  BO: "Bolivija",
  BQ: "Karibų Nyderlandai",
  BA: "Bosnija ir Hercegovina",
  BW: "Botsvana",
  BR: "Brazilija",
  BN: "Brunėjus",
  BG: "Bulgarija",
  BF: "Burkina Fasas",
  BI: "Burundis",
  KH: "Kambodža",
  CM: "Kamerūnas",
  CA: "Kanada",
  CV: "Žaliasis Kyšulys",
  KY: "Kaimanų Salos",
  CF: "Centrinės Afrikos Respublika",
  TD: "Čadas",
  CL: "Čilė",
  CN: "Kinija",
  CO: "Kolumbija",
  KM: "Komorai",
  CG: "Kongas-Brazavilis",
  CD: "Kongas-Kinšasa",
  CK: "Kuko Salos",
  CR: "Kosta Rika",
  CI: "Dramblio Kaulo Krantas",
  HR: "Kroatija",
  CW: "Kiurasao",
  CY: "Kipras",
  CZ: "Čekija",
  DK: "Danija",
  DJ: "Džibutis",
  DM: "Dominika",
  DO: "Dominikos Respublika",
  EC: "Ekvadoras",
  EG: "Egiptas",
  SV: "Salvadoras",
  GQ: "Pusiaujo Gvinėja",
  EE: "Estija",
  ET: "Etiopija",
  FJ: "Fidžis",
  FI: "Suomija",
  FR: "Prancūzija",
  GA: "Gabonas",
  GM: "Gambija",
  GE: "Gruzija",
  DE: "Vokietija",
  GH: "Gana",
  GI: "Gibraltaras",
  GR: "Graikija",
  GD: "Grenada",
  GU: "Guamas",
  GT: "Gvatemala",
  GN: "Gvinėja",
  GW: "Bisau Gvinėja",
  GY: "Gajana",
  HT: "Haitis",
  HN: "Hondūras",
  HK: "Ypatingasis Administracinis Kinijos Regionas Honkongas",
  HU: "Vengrija",
  IS: "Islandija",
  IN: "Indija",
  ID: "Indonezija",
  IQ: "Irakas",
  IE: "Airija",
  IL: "Izraelis",
  IT: "Italija",
  JM: "Jamaika",
  JP: "Japonija",
  JE: "Džersis",
  JO: "Jordanija",
  KZ: "Kazachstanas",
  KE: "Kenija",
  KI: "Kiribatis",
  XK: "Kosovas",
  KW: "Kuveitas",
  KG: "Kirgizija",
  LA: "Laosas",
  LV: "Latvija",
  LB: "Libanas",
  LS: "Lesotas",
  LR: "Liberija",
  LY: "Libija",
  LI: "Lichtenšteinas",
  LT: "Lietuva",
  LU: "Liuksemburgas",
  MO: "Ypatingasis Administracinis Kinijos Regionas Makao",
  MK: "Šiaurės Makedonija",
  MG: "Madagaskaras",
  MW: "Malavis",
  MY: "Malaizija",
  MV: "Maldyvai",
  ML: "Malis",
  MT: "Malta",
  MH: "Maršalo Salos",
  MR: "Mauritanija",
  MU: "Mauricijus",
  MX: "Meksika",
  MD: "Moldova",
  MN: "Mongolija",
  ME: "Juodkalnija",
  MS: "Montseratas",
  MA: "Marokas",
  MZ: "Mozambikas",
  MM: "Mianmaras (Birma)",
  NA: "Namibija",
  NP: "Nepalas",
  NL: "Nyderlandai",
  NZ: "Naujoji Zelandija",
  NI: "Nikaragva",
  NE: "Nigeris",
  NG: "Nigerija",
  NO: "Norvegija",
  OM: "Omanas",
  PK: "Pakistanas",
  PS: "Palestinos teritorija",
  PA: "Panama",
  PG: "Papua Naujoji Gvinėja",
  PY: "Paragvajus",
  PE: "Peru",
  PH: "Filipinai",
  PL: "Lenkija",
  PT: "Portugalija",
  PR: "Puerto Rikas",
  QA: "Kataras",
  RO: "Rumunija",
  RW: "Ruanda",
  KN: "Sent Kitsas ir Nevis",
  LC: "Sent Lusija",
  WS: "Samoa",
  SM: "San Marinas",
  SA: "Saudo Arabija",
  SN: "Senegalas",
  RS: "Serbija",
  SC: "Seišeliai",
  SL: "Siera Leonė",
  SG: "Singapūras",
  SX: "Sint Martenas",
  SK: "Slovakija",
  SI: "Slovėnija",
  SB: "Saliamono Salos",
  SO: "Somalis",
  ZA: "Pietų Afrika",
  KR: "Pietų Korėja",
  SS: "Pietų Sudanas",
  ES: "Ispanija",
  LK: "Šri Lanka",
  VC: "Šventasis Vincentas ir Grenadinai",
  SR: "Surinamas",
  SZ: "Svazilandas",
  SE: "Švedija",
  CH: "Šveicarija",
  TW: "Taivanas",
  TJ: "Tadžikija",
  TZ: "Tanzanija",
  TH: "Tailandas",
  TG: "Togas",
  TO: "Tonga",
  TT: "Trinidadas ir Tobagas",
  TN: "Tunisas",
  TR: "Turkija",
  TM: "Turkmėnistanas",
  TC: "Terkso ir Kaikoso Salos",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Jungtiniai Arabų Emyratai",
  GB: "Jungtinė Karalystė",
  US: "Jungtinės Valstijos",
  UY: "Urugvajus",
  UZ: "Uzbekistanas",
  VU: "Vanuatu",
  VE: "Venesuela",
  VN: "Vietnamas",
  VI: "Jungtinių Valstijų Mergelių Salos",
  YE: "Jemenas",
  ZM: "Zambija",
  ZW: "Zimbabvė"
}, ut = {
  AF: "Afganistāna",
  AL: "Albānija",
  DZ: "Alžīrija",
  AS: "ASV Samoa",
  AD: "Andora",
  AO: "Angola",
  AI: "Angilja",
  AG: "Antigva un Barbuda",
  AR: "Argentīna",
  AM: "Armēnija",
  AW: "Aruba",
  AU: "Austrālija",
  AT: "Austrija",
  AZ: "Azerbaidžāna",
  BS: "Bahamu salas",
  BH: "Bahreina",
  BD: "Bangladeša",
  BB: "Barbadosa",
  BY: "Baltkrievija",
  BE: "Beļģija",
  BZ: "Beliza",
  BJ: "Benina",
  BM: "Bermudu salas",
  BT: "Butāna",
  BO: "Bolīvija",
  BQ: "Nīderlandes Karību salas",
  BA: "Bosnija un Hercegovina",
  BW: "Botsvāna",
  BR: "Brazīlija",
  BN: "Bruneja",
  BG: "Bulgārija",
  BF: "Burkinafaso",
  BI: "Burundija",
  KH: "Kambodža",
  CM: "Kamerūna",
  CA: "Kanāda",
  CV: "Kaboverde",
  KY: "Kaimanu salas",
  CF: "Centrālāfrikas Republika",
  TD: "Čada",
  CL: "Čīle",
  CN: "Ķīna",
  CO: "Kolumbija",
  KM: "Komoru salas",
  CG: "Kongo (Brazavila)",
  CD: "Kongo (Kinšasa)",
  CK: "Kuka salas",
  CR: "Kostarika",
  CI: "Kotdivuāra",
  HR: "Horvātija",
  CW: "Kirasao",
  CY: "Kipra",
  CZ: "Čehija",
  DK: "Dānija",
  DJ: "Džibutija",
  DM: "Dominika",
  DO: "Dominikāna",
  EC: "Ekvadora",
  EG: "Ēģipte",
  SV: "Salvadora",
  GQ: "Ekvatoriālā Gvineja",
  EE: "Igaunija",
  ET: "Etiopija",
  FJ: "Fidži",
  FI: "Somija",
  FR: "Francija",
  GA: "Gabona",
  GM: "Gambija",
  GE: "Gruzija",
  DE: "Vācija",
  GH: "Gana",
  GI: "Gibraltārs",
  GR: "Grieķija",
  GD: "Grenāda",
  GU: "Guama",
  GT: "Gvatemala",
  GN: "Gvineja",
  GW: "Gvineja-Bisava",
  GY: "Gajāna",
  HT: "Haiti",
  HN: "Hondurasa",
  HK: "Ķīnas īpašās pārvaldes apgabals Honkonga",
  HU: "Ungārija",
  IS: "Islande",
  IN: "Indija",
  ID: "Indonēzija",
  IQ: "Irāka",
  IE: "Īrija",
  IL: "Izraēla",
  IT: "Itālija",
  JM: "Jamaika",
  JP: "Japāna",
  JE: "Džērsija",
  JO: "Jordānija",
  KZ: "Kazahstāna",
  KE: "Kenija",
  KI: "Kiribati",
  XK: "Kosova",
  KW: "Kuveita",
  KG: "Kirgizstāna",
  LA: "Laosa",
  LV: "Latvija",
  LB: "Libāna",
  LS: "Lesoto",
  LR: "Libērija",
  LY: "Lībija",
  LI: "Lihtenšteina",
  LT: "Lietuva",
  LU: "Luksemburga",
  MO: "ĶTR īpašais administratīvais reģions Makao",
  MK: "Ziemeļmaķedonija",
  MG: "Madagaskara",
  MW: "Malāvija",
  MY: "Malaizija",
  MV: "Maldīvija",
  ML: "Mali",
  MT: "Malta",
  MH: "Māršala salas",
  MR: "Mauritānija",
  MU: "Maurīcija",
  MX: "Meksika",
  MD: "Moldova",
  MN: "Mongolija",
  ME: "Melnkalne",
  MS: "Montserrata",
  MA: "Maroka",
  MZ: "Mozambika",
  MM: "Mjanma (Birma)",
  NA: "Namībija",
  NP: "Nepāla",
  NL: "Nīderlande",
  NZ: "Jaunzēlande",
  NI: "Nikaragva",
  NE: "Nigēra",
  NG: "Nigērija",
  NO: "Norvēģija",
  OM: "Omāna",
  PK: "Pakistāna",
  PS: "Palestīnas teritorijas",
  PA: "Panama",
  PG: "Papua-Jaungvineja",
  PY: "Paragvaja",
  PE: "Peru",
  PH: "Filipīnas",
  PL: "Polija",
  PT: "Portugāle",
  PR: "Puertoriko",
  QA: "Katara",
  RO: "Rumānija",
  RW: "Ruanda",
  KN: "Sentkitsa un Nevisa",
  LC: "Sentlūsija",
  WS: "Samoa",
  SM: "Sanmarīno",
  SA: "Saūda Arābija",
  SN: "Senegāla",
  RS: "Serbija",
  SC: "Seišelu salas",
  SL: "Sjerraleone",
  SG: "Singapūra",
  SX: "Sintmārtena",
  SK: "Slovākija",
  SI: "Slovēnija",
  SB: "Zālamana salas",
  SO: "Somālija",
  ZA: "Dienvidāfrikas Republika",
  KR: "Dienvidkoreja",
  SS: "Dienvidsudāna",
  ES: "Spānija",
  LK: "Šrilanka",
  VC: "Sentvinsenta un Grenadīnas",
  SR: "Surinama",
  SZ: "Svatini",
  SE: "Zviedrija",
  CH: "Šveice",
  TW: "Taivāna",
  TJ: "Tadžikistāna",
  TZ: "Tanzānija",
  TH: "Taizeme",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidāda un Tobāgo",
  TN: "Tunisija",
  TR: "Turcija",
  TM: "Turkmenistāna",
  TC: "Tērksas un Kaikosas salas",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Apvienotie Arābu Emirāti",
  GB: "Apvienotā Karaliste",
  US: "Amerikas Savienotās Valstis",
  UY: "Urugvaja",
  UZ: "Uzbekistāna",
  VU: "Vanuatu",
  VE: "Venecuēla",
  VN: "Vjetnama",
  VI: "ASV Virdžīnas",
  YE: "Jemena",
  ZM: "Zambija",
  ZW: "Zimbabve"
}, lt = {
  AF: "อัฟกานิสถาน",
  AL: "แอลเบเนีย",
  DZ: "แอลจีเรีย",
  AS: "อเมริกันซามัว",
  AD: "อันดอร์รา",
  AO: "แองโกลา",
  AI: "แองกวิลลา",
  AG: "แอนติกาและบาร์บูดา",
  AR: "อาร์เจนตินา",
  AM: "อาร์เมเนีย",
  AW: "อารูบา",
  AU: "ออสเตรเลีย",
  AT: "ออสเตรีย",
  AZ: "อาเซอร์ไบจาน",
  BS: "บาฮามาส",
  BH: "บาห์เรน",
  BD: "บังกลาเทศ",
  BB: "บาร์เบโดส",
  BY: "เบลารุส",
  BE: "เบลเยียม",
  BZ: "เบลีซ",
  BJ: "เบนิน",
  BM: "เบอร์มิวดา",
  BT: "ภูฏาน",
  BO: "โบลิเวีย",
  BQ: "เนเธอร์แลนด์แคริบเบียน",
  BA: "บอสเนียและเฮอร์เซโกวีนา",
  BW: "บอตสวานา",
  BR: "บราซิล",
  BN: "บรูไน",
  BG: "บัลแกเรีย",
  BF: "บูร์กินาฟาโซ",
  BI: "บุรุนดี",
  KH: "กัมพูชา",
  CM: "แคเมอรูน",
  CA: "แคนาดา",
  CV: "เคปเวิร์ด",
  KY: "หมู่เกาะเคย์แมน",
  CF: "สาธารณรัฐแอฟริกากลาง",
  TD: "ชาด",
  CL: "ชิลี",
  CN: "จีน",
  CO: "โคลอมเบีย",
  KM: "คอโมโรส",
  CG: "คองโก - บราซซาวิล",
  CD: "คองโก - กินชาซา",
  CK: "หมู่เกาะคุก",
  CR: "คอสตาริกา",
  CI: "โกตดิวัวร์",
  HR: "โครเอเชีย",
  CW: "คูราเซา",
  CY: "ไซปรัส",
  CZ: "เช็ก",
  DK: "เดนมาร์ก",
  DJ: "จิบูตี",
  DM: "โดมินิกา",
  DO: "สาธารณรัฐโดมินิกัน",
  EC: "เอกวาดอร์",
  EG: "อียิปต์",
  SV: "เอลซัลวาดอร์",
  GQ: "อิเควทอเรียลกินี",
  EE: "เอสโตเนีย",
  ET: "เอธิโอเปีย",
  FJ: "ฟิจิ",
  FI: "ฟินแลนด์",
  FR: "ฝรั่งเศส",
  GA: "กาบอง",
  GM: "แกมเบีย",
  GE: "จอร์เจีย",
  DE: "เยอรมนี",
  GH: "กานา",
  GI: "ยิบรอลตาร์",
  GR: "กรีซ",
  GD: "เกรเนดา",
  GU: "กวม",
  GT: "กัวเตมาลา",
  GN: "กินี",
  GW: "กินี-บิสเซา",
  GY: "กายอานา",
  HT: "เฮติ",
  HN: "ฮอนดูรัส",
  HK: "เขตปกครองพิเศษฮ่องกงแห่งสาธารณรัฐประชาชนจีน",
  HU: "ฮังการี",
  IS: "ไอซ์แลนด์",
  IN: "อินเดีย",
  ID: "อินโดนีเซีย",
  IQ: "อิรัก",
  IE: "ไอร์แลนด์",
  IL: "อิสราเอล",
  IT: "อิตาลี",
  JM: "จาเมกา",
  JP: "ญี่ปุ่น",
  JE: "เจอร์ซีย์",
  JO: "จอร์แดน",
  KZ: "คาซัคสถาน",
  KE: "เคนยา",
  KI: "คิริบาส",
  XK: "โคโซโว",
  KW: "คูเวต",
  KG: "คีร์กีซสถาน",
  LA: "ลาว",
  LV: "ลัตเวีย",
  LB: "เลบานอน",
  LS: "เลโซโท",
  LR: "ไลบีเรีย",
  LY: "ลิเบีย",
  LI: "ลิกเตนสไตน์",
  LT: "ลิทัวเนีย",
  LU: "ลักเซมเบิร์ก",
  MO: "เขตปกครองพิเศษมาเก๊าแห่งสาธารณรัฐประชาชนจีน",
  MK: "มาซิโดเนียเหนือ",
  MG: "มาดากัสการ์",
  MW: "มาลาวี",
  MY: "มาเลเซีย",
  MV: "มัลดีฟส์",
  ML: "มาลี",
  MT: "มอลตา",
  MH: "หมู่เกาะมาร์แชลล์",
  MR: "มอริเตเนีย",
  MU: "มอริเชียส",
  MX: "เม็กซิโก",
  MD: "มอลโดวา",
  MN: "มองโกเลีย",
  ME: "มอนเตเนโกร",
  MS: "มอนต์เซอร์รัต",
  MA: "โมร็อกโก",
  MZ: "โมซัมบิก",
  MM: "เมียนมา (พม่า)",
  NA: "นามิเบีย",
  NP: "เนปาล",
  NL: "เนเธอร์แลนด์",
  NZ: "นิวซีแลนด์",
  NI: "นิการากัว",
  NE: "ไนเจอร์",
  NG: "ไนจีเรีย",
  NO: "นอร์เวย์",
  OM: "โอมาน",
  PK: "ปากีสถาน",
  PS: "ดินแดนปาเลสไตน์",
  PA: "ปานามา",
  PG: "ปาปัวนิวกินี",
  PY: "ปารากวัย",
  PE: "เปรู",
  PH: "ฟิลิปปินส์",
  PL: "โปแลนด์",
  PT: "โปรตุเกส",
  PR: "เปอร์โตริโก",
  QA: "กาตาร์",
  RO: "โรมาเนีย",
  RW: "รวันดา",
  KN: "เซนต์คิตส์และเนวิส",
  LC: "เซนต์ลูเซีย",
  WS: "ซามัว",
  SM: "ซานมาริโน",
  SA: "ซาอุดีอาระเบีย",
  SN: "เซเนกัล",
  RS: "เซอร์เบีย",
  SC: "เซเชลส์",
  SL: "เซียร์ราลีโอน",
  SG: "สิงคโปร์",
  SX: "ซินต์มาร์เทน",
  SK: "สโลวะเกีย",
  SI: "สโลวีเนีย",
  SB: "หมู่เกาะโซโลมอน",
  SO: "โซมาเลีย",
  ZA: "แอฟริกาใต้",
  KR: "เกาหลีใต้",
  SS: "ซูดานใต้",
  ES: "สเปน",
  LK: "ศรีลังกา",
  VC: "เซนต์วินเซนต์และเกรนาดีนส์",
  SR: "ซูรินาเม",
  SZ: "เอสวาตีนี",
  SE: "สวีเดน",
  CH: "สวิตเซอร์แลนด์",
  TW: "ไต้หวัน",
  TJ: "ทาจิกิสถาน",
  TZ: "แทนซาเนีย",
  TH: "ไทย",
  TG: "โตโก",
  TO: "ตองกา",
  TT: "ตรินิแดดและโตเบโก",
  TN: "ตูนิเซีย",
  TR: "ตุรกี",
  TM: "เติร์กเมนิสถาน",
  TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
  UG: "ยูกันดา",
  UA: "ยูเครน",
  AE: "สหรัฐอาหรับเอมิเรตส์",
  GB: "สหราชอาณาจักร",
  US: "สหรัฐอเมริกา",
  UY: "อุรุกวัย",
  UZ: "อุซเบกิสถาน",
  VU: "วานูอาตู",
  VE: "เวเนซุเอลา",
  VN: "เวียดนาม",
  VI: "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
  YE: "เยเมน",
  ZM: "แซมเบีย",
  ZW: "ซิมบับเว"
}, dt = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa Amerika",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua dan Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Belanda Caribbean",
  BA: "Bosnia dan Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kemboja",
  CM: "Cameroon",
  CA: "Kanada",
  CV: "Cape Verde",
  KY: "Kepulauan Cayman",
  CF: "Republik Afrika Tengah",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo - Brazzaville",
  CD: "Congo - Kinshasa",
  CK: "Kepulauan Cook",
  CR: "Costa Rica",
  CI: "Cote d’Ivoire",
  HR: "Croatia",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czechia",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Republik Dominica",
  EC: "Ecuador",
  EG: "Mesir",
  SV: "El Salvador",
  GQ: "Guinea Khatulistiwa",
  EE: "Estonia",
  ET: "Ethiopia",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Perancis",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Jerman",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hong Kong SAR China",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Itali",
  JM: "Jamaica",
  JP: "Jepun",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lubnan",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macau SAR China",
  MK: "Macedonia Utara",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Kepulauan Marshall",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Mexico",
  MD: "Moldova",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Maghribi",
  MZ: "Mozambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Belanda",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Wilayah Palestin",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipina",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RW: "Rwanda",
  KN: "Saint Kitts dan Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Arab Saudi",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapura",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Kepulauan Solomon",
  SO: "Somalia",
  ZA: "Afrika Selatan",
  KR: "Korea Selatan",
  SS: "Sudan Selatan",
  ES: "Sepanyol",
  LK: "Sri Lanka",
  VC: "Saint Vincent dan Grenadines",
  SR: "Surinam",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Switzerland",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad dan Tobago",
  TN: "Tunisia",
  TR: "Turki",
  TM: "Turkmenistan",
  TC: "Kepulauan Turks dan Caicos",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Emiriah Arab Bersatu",
  GB: "United Kingdom",
  US: "Amerika Syarikat",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Kepulauan Virgin A.S.",
  YE: "Yaman",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, mt = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algerie",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Østerrike",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviterussland",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Karibisk Nederland",
  BA: "Bosnia-Hercegovina",
  BW: "Botswana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodsja",
  CM: "Kamerun",
  CA: "Canada",
  CV: "Kapp Verde",
  KY: "Caymanøyene",
  CF: "Den sentralafrikanske republikk",
  TD: "Tsjad",
  CL: "Chile",
  CN: "Kina",
  CO: "Colombia",
  KM: "Komorene",
  CG: "Kongo-Brazzaville",
  CD: "Kongo",
  CK: "Cookøyene",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatia",
  CW: "Curaçao",
  CY: "Kypros",
  CZ: "Tsjekkia",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den dominikanske republikk",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Ekvatorial-Guinea",
  EE: "Estland",
  ET: "Etiopia",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Hellas",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkong SAR Kina",
  HU: "Ungarn",
  IS: "Island",
  IN: "India",
  ID: "Indonesia",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kasakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao SAR Kina",
  MK: "Nord-Makedonia",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldivene",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløyene",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Mexico",
  MD: "Moldova",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Nederland",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Det palestinske området",
  PA: "Panama",
  PG: "Papua Ny-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinene",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RW: "Rwanda",
  KN: "Saint Kitts og Nevis",
  LC: "St. Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychellene",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonøyene",
  SO: "Somalia",
  ZA: "Sør-Afrika",
  KR: "Sør-Korea",
  SS: "Sør-Sudan",
  ES: "Spania",
  LK: "Sri Lanka",
  VC: "St. Vincent og Grenadinene",
  SR: "Surinam",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Sveits",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunisia",
  TR: "Tyrkia",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøyene",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "De forente arabiske emirater",
  GB: "Storbritannia",
  US: "USA",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "De amerikanske jomfruøyene",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, St = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Algieria",
  AS: "Samoa Amerykańskie",
  AD: "Andora",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua i Barbuda",
  AR: "Argentyna",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbejdżan",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladesz",
  BB: "Barbados",
  BY: "Białoruś",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhutan",
  BO: "Boliwia",
  BQ: "Niderlandy Karaibskie",
  BA: "Bośnia i Hercegowina",
  BW: "Botswana",
  BR: "Brazylia",
  BN: "Brunei",
  BG: "Bułgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodża",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Republika Zielonego Przylądka",
  KY: "Kajmany",
  CF: "Republika Środkowoafrykańska",
  TD: "Czad",
  CL: "Chile",
  CN: "Chiny",
  CO: "Kolumbia",
  KM: "Komory",
  CG: "Kongo",
  CD: "Demokratyczna Republika Konga",
  CK: "Wyspy Cooka",
  CR: "Kostaryka",
  CI: "Côte d’Ivoire",
  HR: "Chorwacja",
  CW: "Curaçao",
  CY: "Cypr",
  CZ: "Czechy",
  DK: "Dania",
  DJ: "Dżibuti",
  DM: "Dominika",
  DO: "Dominikana",
  EC: "Ekwador",
  EG: "Egipt",
  SV: "Salwador",
  GQ: "Gwinea Równikowa",
  EE: "Estonia",
  ET: "Etiopia",
  FJ: "Fidżi",
  FI: "Finlandia",
  FR: "Francja",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gruzja",
  DE: "Niemcy",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecja",
  GD: "Grenada",
  GU: "Guam",
  GT: "Gwatemala",
  GN: "Gwinea",
  GW: "Gwinea Bissau",
  GY: "Gujana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "SRA Hongkong (Chiny)",
  HU: "Węgry",
  IS: "Islandia",
  IN: "Indie",
  ID: "Indonezja",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Izrael",
  IT: "Włochy",
  JM: "Jamajka",
  JP: "Japonia",
  JE: "Jersey",
  JO: "Jordania",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  XK: "Kosowo",
  KW: "Kuwejt",
  KG: "Kirgistan",
  LA: "Laos",
  LV: "Łotwa",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Litwa",
  LU: "Luksemburg",
  MO: "SRA Makau (Chiny)",
  MK: "Macedonia Północna",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malezja",
  MV: "Malediwy",
  ML: "Mali",
  MT: "Malta",
  MH: "Wyspy Marshalla",
  MR: "Mauretania",
  MU: "Mauritius",
  MX: "Meksyk",
  MD: "Mołdawia",
  MN: "Mongolia",
  ME: "Czarnogóra",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Mjanma (Birma)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Holandia",
  NZ: "Nowa Zelandia",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Terytoria Palestyńskie",
  PA: "Panama",
  PG: "Papua-Nowa Gwinea",
  PY: "Paragwaj",
  PE: "Peru",
  PH: "Filipiny",
  PL: "Polska",
  PT: "Portugalia",
  PR: "Portoryko",
  QA: "Katar",
  RO: "Rumunia",
  RW: "Rwanda",
  KN: "Saint Kitts i Nevis",
  LC: "Saint Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Arabia Saudyjska",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seszele",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Słowacja",
  SI: "Słowenia",
  SB: "Wyspy Salomona",
  SO: "Somalia",
  ZA: "Republika Południowej Afryki",
  KR: "Korea Południowa",
  SS: "Sudan Południowy",
  ES: "Hiszpania",
  LK: "Sri Lanka",
  VC: "Saint Vincent i Grenadyny",
  SR: "Surinam",
  SZ: "Eswatini",
  SE: "Szwecja",
  CH: "Szwajcaria",
  TW: "Tajwan",
  TJ: "Tadżykistan",
  TZ: "Tanzania",
  TH: "Tajlandia",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trynidad i Tobago",
  TN: "Tunezja",
  TR: "Turcja",
  TM: "Turkmenistan",
  TC: "Turks i Caicos",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Zjednoczone Emiraty Arabskie",
  GB: "Wielka Brytania",
  US: "Stany Zjednoczone",
  UY: "Urugwaj",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Wenezuela",
  VN: "Wietnam",
  VI: "Wyspy Dziewicze Stanów Zjednoczonych",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, gt = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa Americană",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua și Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaidjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Insulele Caraibe Olandeze",
  BA: "Bosnia și Herțegovina",
  BW: "Botswana",
  BR: "Brazilia",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodgia",
  CM: "Camerun",
  CA: "Canada",
  CV: "Capul Verde",
  KY: "Insulele Cayman",
  CF: "Republica Centrafricană",
  TD: "Ciad",
  CL: "Chile",
  CN: "China",
  CO: "Columbia",
  KM: "Comore",
  CG: "Congo - Brazzaville",
  CD: "Congo - Kinshasa",
  CK: "Insulele Cook",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Croația",
  CW: "Curaçao",
  CY: "Cipru",
  CZ: "Cehia",
  DK: "Danemarca",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Republica Dominicană",
  EC: "Ecuador",
  EG: "Egipt",
  SV: "El Salvador",
  GQ: "Guineea Ecuatorială",
  EE: "Estonia",
  ET: "Etiopia",
  FJ: "Fiji",
  FI: "Finlanda",
  FR: "Franța",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guineea",
  GW: "Guineea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "R.A.S. Hong Kong, China",
  HU: "Ungaria",
  IS: "Islanda",
  IN: "India",
  ID: "Indonezia",
  IQ: "Irak",
  IE: "Irlanda",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japonia",
  JE: "Jersey",
  JO: "Iordania",
  KZ: "Kazahstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuweit",
  KG: "Kârgâzstan",
  LA: "Laos",
  LV: "Letonia",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburg",
  MO: "R.A.S. Macao, China",
  MK: "Macedonia de Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldive",
  ML: "Mali",
  MT: "Malta",
  MH: "Insulele Marshall",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Mexic",
  MD: "Republica Moldova",
  MN: "Mongolia",
  ME: "Muntenegru",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambic",
  MM: "Myanmar (Birmania)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Țările de Jos",
  NZ: "Noua Zeelandă",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Norvegia",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Teritoriile Palestiniene",
  PA: "Panama",
  PG: "Papua-Noua Guinee",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipine",
  PL: "Polonia",
  PT: "Portugalia",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "România",
  RW: "Rwanda",
  KN: "Saint Kitts și Nevis",
  LC: "Sfânta Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Arabia Saudită",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint-Maarten",
  SK: "Slovacia",
  SI: "Slovenia",
  SB: "Insulele Solomon",
  SO: "Somalia",
  ZA: "Africa de Sud",
  KR: "Coreea de Sud",
  SS: "Sudanul de Sud",
  ES: "Spania",
  LK: "Sri Lanka",
  VC: "Saint Vincent și Grenadinele",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Suedia",
  CH: "Elveția",
  TW: "Taiwan",
  TJ: "Tadjikistan",
  TZ: "Tanzania",
  TH: "Thailanda",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad și Tobago",
  TN: "Tunisia",
  TR: "Turcia",
  TM: "Turkmenistan",
  TC: "Insulele Turks și Caicos",
  UG: "Uganda",
  UA: "Ucraina",
  AE: "Emiratele Arabe Unite",
  GB: "Regatul Unit",
  US: "Statele Unite ale Americii",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Insulele Virgine Americane",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, ct = {
  AF: "Авганистан",
  AL: "Албанија",
  DZ: "Алжир",
  AS: "Америчка Самоа",
  AD: "Андора",
  AO: "Ангола",
  AI: "Ангвила",
  AG: "Антигва и Барбуда",
  AR: "Аргентина",
  AM: "Јерменија",
  AW: "Аруба",
  AU: "Аустралија",
  AT: "Аустрија",
  AZ: "Азербејџан",
  BS: "Бахами",
  BH: "Бахреин",
  BD: "Бангладеш",
  BB: "Барбадос",
  BY: "Белорусија",
  BE: "Белгија",
  BZ: "Белизе",
  BJ: "Бенин",
  BM: "Бермуда",
  BT: "Бутан",
  BO: "Боливија",
  BQ: "Карипска Холандија",
  BA: "Босна и Херцеговина",
  BW: "Боцвана",
  BR: "Бразил",
  BN: "Брунеј",
  BG: "Бугарска",
  BF: "Буркина Фасо",
  BI: "Бурунди",
  KH: "Камбоџа",
  CM: "Камерун",
  CA: "Канада",
  CV: "Зеленортска Острва",
  KY: "Кајманска Острва",
  CF: "Централноафричка Република",
  TD: "Чад",
  CL: "Чиле",
  CN: "Кина",
  CO: "Колумбија",
  KM: "Коморска Острва",
  CG: "Конго - Бразавил",
  CD: "Конго - Киншаса",
  CK: "Кукова Острва",
  CR: "Костарика",
  CI: "Обала Слоноваче (Кот д’Ивоар)",
  HR: "Хрватска",
  CW: "Курасао",
  CY: "Кипар",
  CZ: "Чешка",
  DK: "Данска",
  DJ: "Џибути",
  DM: "Доминика",
  DO: "Доминиканска Република",
  EC: "Еквадор",
  EG: "Египат",
  SV: "Салвадор",
  GQ: "Екваторијална Гвинеја",
  EE: "Естонија",
  ET: "Етиопија",
  FJ: "Фиџи",
  FI: "Финска",
  FR: "Француска",
  GA: "Габон",
  GM: "Гамбија",
  GE: "Грузија",
  DE: "Немачка",
  GH: "Гана",
  GI: "Гибралтар",
  GR: "Грчка",
  GD: "Гренада",
  GU: "Гуам",
  GT: "Гватемала",
  GN: "Гвинеја",
  GW: "Гвинеја-Бисао",
  GY: "Гвајана",
  HT: "Хаити",
  HN: "Хондурас",
  HK: "САР Хонгконг (Кина)",
  HU: "Мађарска",
  IS: "Исланд",
  IN: "Индија",
  ID: "Индонезија",
  IQ: "Ирак",
  IE: "Ирска",
  IL: "Израел",
  IT: "Италија",
  JM: "Јамајка",
  JP: "Јапан",
  JE: "Џерзи",
  JO: "Јордан",
  KZ: "Казахстан",
  KE: "Кенија",
  KI: "Кирибати",
  XK: "Косово",
  KW: "Кувајт",
  KG: "Киргистан",
  LA: "Лаос",
  LV: "Летонија",
  LB: "Либан",
  LS: "Лесото",
  LR: "Либерија",
  LY: "Либија",
  LI: "Лихтенштајн",
  LT: "Литванија",
  LU: "Луксембург",
  MO: "САР Макао (Кина)",
  MK: "Северна Македонија",
  MG: "Мадагаскар",
  MW: "Малави",
  MY: "Малезија",
  MV: "Малдиви",
  ML: "Мали",
  MT: "Малта",
  MH: "Маршалска Острва",
  MR: "Мауританија",
  MU: "Маурицијус",
  MX: "Мексико",
  MD: "Молдавија",
  MN: "Монголија",
  ME: "Црна Гора",
  MS: "Монсерат",
  MA: "Мароко",
  MZ: "Мозамбик",
  MM: "Мијанмар (Бурма)",
  NA: "Намибија",
  NP: "Непал",
  NL: "Холандија",
  NZ: "Нови Зеланд",
  NI: "Никарагва",
  NE: "Нигер",
  NG: "Нигерија",
  NO: "Норвешка",
  OM: "Оман",
  PK: "Пакистан",
  PS: "Палестинске територије",
  PA: "Панама",
  PG: "Папуа Нова Гвинеја",
  PY: "Парагвај",
  PE: "Перу",
  PH: "Филипини",
  PL: "Пољска",
  PT: "Португалија",
  PR: "Порторико",
  QA: "Катар",
  RO: "Румунија",
  RW: "Руанда",
  KN: "Сент Китс и Невис",
  LC: "Света Луција",
  WS: "Самоа",
  SM: "Сан Марино",
  SA: "Саудијска Арабија",
  SN: "Сенегал",
  RS: "Србија",
  SC: "Сејшели",
  SL: "Сијера Леоне",
  SG: "Сингапур",
  SX: "Свети Мартин (Холандија)",
  SK: "Словачка",
  SI: "Словенија",
  SB: "Соломонска Острва",
  SO: "Сомалија",
  ZA: "Јужноафричка Република",
  KR: "Јужна Кореја",
  SS: "Јужни Судан",
  ES: "Шпанија",
  LK: "Шри Ланка",
  VC: "Сент Винсент и Гренадини",
  SR: "Суринам",
  SZ: "Свазиленд",
  SE: "Шведска",
  CH: "Швајцарска",
  TW: "Тајван",
  TJ: "Таџикистан",
  TZ: "Танзанија",
  TH: "Тајланд",
  TG: "Того",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TN: "Тунис",
  TR: "Турска",
  TM: "Туркменистан",
  TC: "Острва Туркс и Каикос",
  UG: "Уганда",
  UA: "Украјина",
  AE: "Уједињени Арапски Емирати",
  GB: "Уједињено Краљевство",
  US: "Сједињене Државе",
  UY: "Уругвај",
  UZ: "Узбекистан",
  VU: "Вануату",
  VE: "Венецуела",
  VN: "Вијетнам",
  VI: "Америчка Девичанска Острва",
  YE: "Јемен",
  ZM: "Замбија",
  ZW: "Зимбабве"
}, Mt = {
  AF: "Afganistan",
  AL: "Albánsko",
  DZ: "Alžírsko",
  AS: "Americká Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua a Barbuda",
  AR: "Argentína",
  AM: "Arménsko",
  AW: "Aruba",
  AU: "Austrália",
  AT: "Rakúsko",
  AZ: "Azerbajdžan",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladéš",
  BB: "Barbados",
  BY: "Bielorusko",
  BE: "Belgicko",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhután",
  BO: "Bolívia",
  BQ: "Karibské Holandsko",
  BA: "Bosna a Hercegovina",
  BW: "Botswana",
  BR: "Brazília",
  BN: "Brunej",
  BG: "Bulharsko",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kapverdy",
  KY: "Kajmanie ostrovy",
  CF: "Stredoafrická republika",
  TD: "Čad",
  CL: "Čile",
  CN: "Čína",
  CO: "Kolumbia",
  KM: "Komory",
  CG: "Konžská republika",
  CD: "Konžská demokratická republika",
  CK: "Cookove ostrovy",
  CR: "Kostarika",
  CI: "Pobrežie Slonoviny",
  HR: "Chorvátsko",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Česko",
  DK: "Dánsko",
  DJ: "Džibutsko",
  DM: "Dominika",
  DO: "Dominikánska republika",
  EC: "Ekvádor",
  EG: "Egypt",
  SV: "Salvádor",
  GQ: "Rovníková Guinea",
  EE: "Estónsko",
  ET: "Etiópia",
  FJ: "Fidži",
  FI: "Fínsko",
  FR: "Francúzsko",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gruzínsko",
  DE: "Nemecko",
  GH: "Ghana",
  GI: "Gibraltár",
  GR: "Grécko",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkong – OAO Číny",
  HU: "Maďarsko",
  IS: "Island",
  IN: "India",
  ID: "Indonézia",
  IQ: "Irak",
  IE: "Írsko",
  IL: "Izrael",
  IT: "Taliansko",
  JM: "Jamajka",
  JP: "Japonsko",
  JE: "Jersey",
  JO: "Jordánsko",
  KZ: "Kazachstan",
  KE: "Keňa",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuvajt",
  KG: "Kirgizsko",
  LA: "Laos",
  LV: "Lotyšsko",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Líbya",
  LI: "Lichtenštajnsko",
  LT: "Litva",
  LU: "Luxembursko",
  MO: "Macao – OAO Číny",
  MK: "Severné Macedónsko",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malajzia",
  MV: "Maldivy",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshallove ostrovy",
  MR: "Mauritánia",
  MU: "Maurícius",
  MX: "Mexiko",
  MD: "Moldavsko",
  MN: "Mongolsko",
  ME: "Čierna Hora",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Mjanmarsko",
  NA: "Namíbia",
  NP: "Nepál",
  NL: "Holandsko",
  NZ: "Nový Zéland",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigéria",
  NO: "Nórsko",
  OM: "Omán",
  PK: "Pakistan",
  PS: "Palestínske územia",
  PA: "Panama",
  PG: "Papua-Nová Guinea",
  PY: "Paraguaj",
  PE: "Peru",
  PH: "Filipíny",
  PL: "Poľsko",
  PT: "Portugalsko",
  PR: "Portoriko",
  QA: "Katar",
  RO: "Rumunsko",
  RW: "Rwanda",
  KN: "Svätý Krištof a Nevis",
  LC: "Svätá Lucia",
  WS: "Samoa",
  SM: "San Maríno",
  SA: "Saudská Arábia",
  SN: "Senegal",
  RS: "Srbsko",
  SC: "Seychely",
  SL: "Sierra Leone",
  SG: "Singapur",
  SX: "Svätý Martin (hol.)",
  SK: "Slovensko",
  SI: "Slovinsko",
  SB: "Šalamúnove ostrovy",
  SO: "Somálsko",
  ZA: "Južná Afrika",
  KR: "Južná Kórea",
  SS: "Južný Sudán",
  ES: "Španielsko",
  LK: "Srí Lanka",
  VC: "Svätý Vincent a Grenadíny",
  SR: "Surinam",
  SZ: "Eswatini",
  SE: "Švédsko",
  CH: "Švajčiarsko",
  TW: "Taiwan",
  TJ: "Tadžikistan",
  TZ: "Tanzánia",
  TH: "Thajsko",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad a Tobago",
  TN: "Tunisko",
  TR: "Turecko",
  TM: "Turkménsko",
  TC: "Turks a Caicos",
  UG: "Uganda",
  UA: "Ukrajina",
  AE: "Spojené arabské emiráty",
  GB: "Spojené kráľovstvo",
  US: "Spojené štáty",
  UY: "Uruguaj",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VI: "Americké Panenské ostrovy",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, Lt = {
  AF: "Афганістан",
  AL: "Албанія",
  DZ: "Алжир",
  AS: "Американське Самоа",
  AD: "Андорра",
  AO: "Ангола",
  AI: "Ангілья",
  AG: "Антигуа і Барбуда",
  AR: "Аргентина",
  AM: "Вірменія",
  AW: "Аруба",
  AU: "Австралія",
  AT: "Австрія",
  AZ: "Азербайджан",
  BS: "Багамські Острови",
  BH: "Бахрейн",
  BD: "Бангладеш",
  BB: "Барбадос",
  BY: "Білорусь",
  BE: "Бельгія",
  BZ: "Беліз",
  BJ: "Бенін",
  BM: "Бермудські Острови",
  BT: "Бутан",
  BO: "Болівія",
  BQ: "Карибські Нідерланди",
  BA: "Боснія і Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилія",
  BN: "Бруней",
  BG: "Болгарія",
  BF: "Буркіна-Фасо",
  BI: "Бурунді",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  CV: "Кабо-Верде",
  KY: "Кайманові Острови",
  CF: "Центральноафриканська Республіка",
  TD: "Чад",
  CL: "Чилі",
  CN: "Китай",
  CO: "Колумбія",
  KM: "Комори",
  CG: "Конго – Браззавіль",
  CD: "Конго – Кіншаса",
  CK: "Острови Кука",
  CR: "Коста-Рика",
  CI: "Кот-дʼІвуар",
  HR: "Хорватія",
  CW: "Кюрасао",
  CY: "Кіпр",
  CZ: "Чехія",
  DK: "Данія",
  DJ: "Джибуті",
  DM: "Домініка",
  DO: "Домініканська Республіка",
  EC: "Еквадор",
  EG: "Єгипет",
  SV: "Сальвадор",
  GQ: "Екваторіальна Гвінея",
  EE: "Естонія",
  ET: "Ефіопія",
  FJ: "Фіджі",
  FI: "Фінляндія",
  FR: "Франція",
  GA: "Габон",
  GM: "Гамбія",
  GE: "Грузія",
  DE: "Німеччина",
  GH: "Гана",
  GI: "Гібралтар",
  GR: "Греція",
  GD: "Гренада",
  GU: "Гуам",
  GT: "Гватемала",
  GN: "Гвінея",
  GW: "Гвінея-Бісау",
  GY: "Гаяна",
  HT: "Гаїті",
  HN: "Гондурас",
  HK: "Гонконг, ОАР Китаю",
  HU: "Угорщина",
  IS: "Ісландія",
  IN: "Індія",
  ID: "Індонезія",
  IQ: "Ірак",
  IE: "Ірландія",
  IL: "Ізраїль",
  IT: "Італія",
  JM: "Ямайка",
  JP: "Японія",
  JE: "Джерсі",
  JO: "Йорданія",
  KZ: "Казахстан",
  KE: "Кенія",
  KI: "Кірибаті",
  XK: "Косово",
  KW: "Кувейт",
  KG: "Киргизстан",
  LA: "Лаос",
  LV: "Латвія",
  LB: "Ліван",
  LS: "Лесото",
  LR: "Ліберія",
  LY: "Лівія",
  LI: "Ліхтенштейн",
  LT: "Литва",
  LU: "Люксембург",
  MO: "Макао, ОАР Китаю",
  MK: "Північна Македонія",
  MG: "Мадагаскар",
  MW: "Малаві",
  MY: "Малайзія",
  MV: "Мальдіви",
  ML: "Малі",
  MT: "Мальта",
  MH: "Маршаллові Острови",
  MR: "Мавританія",
  MU: "Маврикій",
  MX: "Мексика",
  MD: "Молдова",
  MN: "Монголія",
  ME: "Чорногорія",
  MS: "Монтсеррат",
  MA: "Марокко",
  MZ: "Мозамбік",
  MM: "Мʼянма (Бірма)",
  NA: "Намібія",
  NP: "Непал",
  NL: "Нідерланди",
  NZ: "Нова Зеландія",
  NI: "Нікарагуа",
  NE: "Нігер",
  NG: "Нігерія",
  NO: "Норвегія",
  OM: "Оман",
  PK: "Пакистан",
  PS: "Палестинські території",
  PA: "Панама",
  PG: "Папуа-Нова Гвінея",
  PY: "Парагвай",
  PE: "Перу",
  PH: "Філіппіни",
  PL: "Польща",
  PT: "Португалія",
  PR: "Пуерто-Рико",
  QA: "Катар",
  RO: "Румунія",
  RW: "Руанда",
  KN: "Сент-Кітс і Невіс",
  LC: "Сент-Люсія",
  WS: "Самоа",
  SM: "Сан-Марино",
  SA: "Саудівська Аравія",
  SN: "Сенегал",
  RS: "Сербія",
  SC: "Сейшельські Острови",
  SL: "Сьєрра-Леоне",
  SG: "Сінгапур",
  SX: "Сінт-Мартен",
  SK: "Словаччина",
  SI: "Словенія",
  SB: "Соломонові Острови",
  SO: "Сомалі",
  ZA: "Південно-Африканська Республіка",
  KR: "Південна Корея",
  SS: "Південний Судан",
  ES: "Іспанія",
  LK: "Шрі-Ланка",
  VC: "Сент-Вінсент і Гренадіни",
  SR: "Суринам",
  SZ: "Есватіні",
  SE: "Швеція",
  CH: "Швейцарія",
  TW: "Тайвань",
  TJ: "Таджикистан",
  TZ: "Танзанія",
  TH: "Таїланд",
  TG: "Того",
  TO: "Тонга",
  TT: "Тринідад і Тобаго",
  TN: "Туніс",
  TR: "Туреччина",
  TM: "Туркменістан",
  TC: "Острови Теркс і Кайкос",
  UG: "Уганда",
  UA: "Україна",
  AE: "Обʼєднані Арабські Емірати",
  GB: "Велика Британія",
  US: "Сполучені Штати",
  UY: "Уругвай",
  UZ: "Узбекистан",
  VU: "Вануату",
  VE: "Венесуела",
  VN: "Вʼєтнам",
  VI: "Віргінські Острови (США)",
  YE: "Ємен",
  ZM: "Замбія",
  ZW: "Зімбабве"
}, At = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa thuộc Mỹ",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AG: "Antigua và Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Áo",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Bỉ",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Ca-ri-bê Hà Lan",
  BA: "Bosnia và Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Campuchia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Quần đảo Cayman",
  CF: "Cộng hòa Trung Phi",
  TD: "Chad",
  CL: "Chile",
  CN: "Trung Quốc",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo - Brazzaville",
  CD: "Congo - Kinshasa",
  CK: "Quần đảo Cook",
  CR: "Costa Rica",
  CI: "Côte d’Ivoire",
  HR: "Croatia",
  CW: "Curaçao",
  CY: "Síp",
  CZ: "Séc",
  DK: "Đan Mạch",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Cộng hòa Dominica",
  EC: "Ecuador",
  EG: "Ai Cập",
  SV: "El Salvador",
  GQ: "Guinea Xích Đạo",
  EE: "Estonia",
  ET: "Ethiopia",
  FJ: "Fiji",
  FI: "Phần Lan",
  FR: "Pháp",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Đức",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Hy Lạp",
  GD: "Grenada",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Đặc khu Hành chính Hồng Kông, Trung Quốc",
  HU: "Hungary",
  IS: "Iceland",
  IN: "Ấn Độ",
  ID: "Indonesia",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Nhật Bản",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lào",
  LV: "Latvia",
  LB: "Li-băng",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litva",
  LU: "Luxembourg",
  MO: "Đặc khu Hành chính Macao, Trung Quốc",
  MK: "Bắc Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Quần đảo Marshall",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Mexico",
  MD: "Moldova",
  MN: "Mông Cổ",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Ma-rốc",
  MZ: "Mozambique",
  MM: "Myanmar (Miến Điện)",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Hà Lan",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NO: "Na Uy",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Lãnh thổ Palestine",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PL: "Ba Lan",
  PT: "Bồ Đào Nha",
  PR: "Puerto Rico",
  QA: "Qatar",
  RO: "Romania",
  RW: "Rwanda",
  KN: "St. Kitts và Nevis",
  LC: "St. Lucia",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Ả Rập Xê-út",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Quần đảo Solomon",
  SO: "Somalia",
  ZA: "Nam Phi",
  KR: "Hàn Quốc",
  SS: "Nam Sudan",
  ES: "Tây Ban Nha",
  LK: "Sri Lanka",
  VC: "St. Vincent và Grenadines",
  SR: "Suriname",
  SZ: "Eswatini",
  SE: "Thụy Điển",
  CH: "Thụy Sĩ",
  TW: "Đài Loan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thái Lan",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad và Tobago",
  TN: "Tunisia",
  TR: "Thổ Nhĩ Kỳ",
  TM: "Turkmenistan",
  TC: "Quần đảo Turks và Caicos",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Các Tiểu Vương quốc Ả Rập Thống nhất",
  GB: "Vương quốc Anh",
  US: "Hoa Kỳ",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Việt Nam",
  VI: "Quần đảo Virgin thuộc Hoa Kỳ",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, Ct = {
  en: Fs,
  es: Vs,
  de: js,
  fr: ws,
  nl: Js,
  bg: Ws,
  pt: Ys,
  it: xs,
  cs: _s,
  da: qs,
  et: Qs,
  fi: Xs,
  sv: $s,
  ka: at,
  el: et,
  "zh-HK": {
    AF: "阿富汗",
    AL: "阿爾巴尼亞",
    DZ: "阿爾及利亞",
    AS: "美屬薩摩亞",
    AD: "安道爾",
    AO: "安哥拉",
    AI: "安奎拉",
    AG: "安提瓜和巴布達",
    AR: "阿根廷",
    AM: "亞美尼亞",
    AW: "阿魯巴",
    AU: "澳洲",
    AT: "奧地利",
    AZ: "亞塞拜疆",
    BS: "巴哈馬",
    BH: "巴林",
    BD: "孟加拉",
    BB: "巴巴多斯",
    BY: "白俄羅斯",
    BE: "比利時",
    BZ: "伯利茲",
    BJ: "貝寧",
    BM: "百慕達",
    BT: "不丹",
    BO: "玻利維亞",
    BQ: "荷蘭加勒比區",
    BA: "波斯尼亞和黑塞哥維那",
    BW: "博茨瓦納",
    BR: "巴西",
    BN: "汶萊",
    BG: "保加利亞",
    BF: "布基納法索",
    BI: "布隆迪",
    KH: "柬埔寨",
    CM: "喀麥隆",
    CA: "加拿大",
    CV: "佛得角",
    KY: "開曼群島",
    CF: "中非共和國",
    TD: "乍得",
    CL: "智利",
    CN: "中國",
    CO: "哥倫比亞",
    KM: "科摩羅",
    CG: "剛果（布拉薩）",
    CD: "剛果（金夏沙）",
    CK: "庫克群島",
    CR: "哥斯達黎加",
    CI: "科特迪瓦",
    HR: "克羅地亞",
    CW: "庫拉索",
    CY: "塞浦路斯",
    CZ: "捷克",
    DK: "丹麥",
    DJ: "吉布提",
    DM: "多米尼克",
    DO: "多米尼加共和國",
    EC: "厄瓜多爾",
    EG: "埃及",
    SV: "薩爾瓦多",
    GQ: "赤道幾內亞",
    EE: "愛沙尼亞",
    ET: "埃塞俄比亞",
    FJ: "斐濟",
    FI: "芬蘭",
    FR: "法國",
    GA: "加蓬",
    GM: "岡比亞",
    GE: "格魯吉亞",
    DE: "德國",
    GH: "加納",
    GI: "直布羅陀",
    GR: "希臘",
    GD: "格林納達",
    GU: "關島",
    GT: "危地馬拉",
    GN: "幾內亞",
    GW: "幾內亞比紹",
    GY: "圭亞那",
    HT: "海地",
    HN: "洪都拉斯",
    HK: "中國香港特別行政區",
    HU: "匈牙利",
    IS: "冰島",
    IN: "印度",
    ID: "印尼",
    IQ: "伊拉克",
    IE: "愛爾蘭",
    IL: "以色列",
    IT: "意大利",
    JM: "牙買加",
    JP: "日本",
    JE: "澤西島",
    JO: "約旦",
    KZ: "哈薩克",
    KE: "肯尼亞",
    KI: "吉里巴斯",
    XK: "科索沃",
    KW: "科威特",
    KG: "吉爾吉斯",
    LA: "老撾",
    LV: "拉脫維亞",
    LB: "黎巴嫩",
    LS: "萊索托",
    LR: "利比里亞",
    LY: "利比亞",
    LI: "列支敦士登",
    LT: "立陶宛",
    LU: "盧森堡",
    MO: "中國澳門特別行政區",
    MK: "北馬其頓",
    MG: "馬達加斯加",
    MW: "馬拉維",
    MY: "馬來西亞",
    MV: "馬爾代夫",
    ML: "馬里",
    MT: "馬耳他",
    MH: "馬紹爾群島",
    MR: "毛里塔尼亞",
    MU: "毛里裘斯",
    MX: "墨西哥",
    MD: "摩爾多瓦",
    MN: "蒙古",
    ME: "黑山",
    MS: "蒙特塞拉特",
    MA: "摩洛哥",
    MZ: "莫桑比克",
    MM: "緬甸",
    NA: "納米比亞",
    NP: "尼泊爾",
    NL: "荷蘭",
    NZ: "紐西蘭",
    NI: "尼加拉瓜",
    NE: "尼日爾",
    NG: "尼日利亞",
    NO: "挪威",
    OM: "阿曼",
    PK: "巴基斯坦",
    PS: "巴勒斯坦領土",
    PA: "巴拿馬",
    PG: "巴布亞新畿內亞",
    PY: "巴拉圭",
    PE: "秘魯",
    PH: "菲律賓",
    PL: "波蘭",
    PT: "葡萄牙",
    PR: "波多黎各",
    QA: "卡塔爾",
    RO: "羅馬尼亞",
    RW: "盧旺達",
    KN: "聖基茨和尼維斯",
    LC: "聖盧西亞",
    WS: "薩摩亞",
    SM: "聖馬力諾",
    SA: "沙地阿拉伯",
    SN: "塞內加爾",
    RS: "塞爾維亞",
    SC: "塞舌爾",
    SL: "塞拉利昂",
    SG: "新加坡",
    SX: "荷屬聖馬丁",
    SK: "斯洛伐克",
    SI: "斯洛文尼亞",
    SB: "所羅門群島",
    SO: "索馬里",
    ZA: "南非",
    KR: "南韓",
    SS: "南蘇丹",
    ES: "西班牙",
    LK: "斯里蘭卡",
    VC: "聖文森特和格林納丁斯",
    SR: "蘇里南",
    SZ: "斯威士蘭",
    SE: "瑞典",
    CH: "瑞士",
    TW: "台灣",
    TJ: "塔吉克",
    TZ: "坦桑尼亞",
    TH: "泰國",
    TG: "多哥",
    TO: "湯加",
    TT: "千里達和多巴哥",
    TN: "突尼西亞",
    TR: "土耳其",
    TM: "土庫曼",
    TC: "特克斯和凱科斯群島",
    UG: "烏干達",
    UA: "烏克蘭",
    AE: "阿拉伯聯合酋長國",
    GB: "英國",
    US: "美國",
    UY: "烏拉圭",
    UZ: "烏茲別克",
    VU: "瓦努阿圖",
    VE: "委內瑞拉",
    VN: "越南",
    VI: "美屬維爾京群島",
    YE: "也門",
    ZM: "贊比亞",
    ZW: "津巴布韋"
  },
  zh: nt,
  hr: it,
  hu: rt,
  id: ot,
  hi: st,
  lt: tt,
  lv: ut,
  th: lt,
  ms: dt,
  nb: mt,
  pl: St,
  ro: gt,
  sr: ct,
  sk: Mt,
  uk: Lt,
  vi: At
}, ht = {
  en: "English",
  es: "Spanish",
  de: "German",
  fr: "French",
  nl: "Dutch",
  bg: "Bulgarian",
  pt: "Portuguese",
  it: "Italian",
  cs: "Czech",
  da: "Danish",
  et: "Estonian",
  fi: "Finnish",
  sv: "Swedish",
  ka: "Georgian",
  el: "Greek",
  zh: "Chinese",
  hr: "Croatian",
  hu: "Hungarian",
  id: "Indonesian",
  hi: "Hindi",
  lt: "Lithuanian",
  lv: "Latvian",
  th: "Thai",
  ms: "Malay",
  nb: "Norwegian Bokmål",
  pl: "Polish",
  ro: "Romanian",
  sr: "Serbian",
  sk: "Slovak",
  uk: "Ukrainian",
  vi: "Vietnamese"
}, Bt = {
  en: "Inglés",
  es: "Español",
  de: "Alemán",
  fr: "Francés",
  nl: "Neerlandés",
  bg: "Búlgaro",
  pt: "Portugués",
  it: "Italiano",
  cs: "Checo",
  da: "Danés",
  et: "Estonio",
  fi: "Finés",
  sv: "Sueco",
  ka: "Georgiano",
  el: "Griego",
  zh: "Chino",
  hr: "Croata",
  hu: "Húngaro",
  id: "Indonesio",
  hi: "Hindi",
  lt: "Lituano",
  lv: "Letón",
  th: "Tailandés",
  ms: "Malayo",
  nb: "Noruego Bokmal",
  pl: "Polaco",
  ro: "Rumano",
  sr: "Serbio",
  sk: "Eslovaco",
  uk: "Ucraniano",
  vi: "Vietnamita"
}, Tt = {
  en: "Englisch",
  es: "Spanisch",
  de: "Deutsch",
  fr: "Französisch",
  nl: "Niederländisch",
  bg: "Bulgarisch",
  pt: "Portugiesisch",
  it: "Italienisch",
  cs: "Tschechisch",
  da: "Dänisch",
  et: "Estnisch",
  fi: "Finnisch",
  sv: "Schwedisch",
  ka: "Georgisch",
  el: "Griechisch",
  zh: "Chinesisch",
  hr: "Kroatisch",
  hu: "Ungarisch",
  id: "Indonesisch",
  hi: "Hindi",
  lt: "Litauisch",
  lv: "Lettisch",
  th: "Thailändisch",
  ms: "Malaiisch",
  nb: "Norwegisch (Bokmål)",
  pl: "Polnisch",
  ro: "Rumänisch",
  sr: "Serbisch",
  sk: "Slowakisch",
  uk: "Ukrainisch",
  vi: "Vietnamesisch"
}, pt = {
  en: "Anglais",
  es: "Espagnol",
  de: "Allemand",
  fr: "Français",
  nl: "Néerlandais",
  bg: "Bulgare",
  pt: "Portugais",
  it: "Italien",
  cs: "Tchèque",
  da: "Danois",
  et: "Estonien",
  fi: "Finnois",
  sv: "Suédois",
  ka: "Géorgien",
  el: "Grec",
  zh: "Chinois",
  hr: "Croate",
  hu: "Hongrois",
  id: "Indonésien",
  hi: "Hindi",
  lt: "Lituanien",
  lv: "Letton",
  th: "Thaï",
  ms: "Malais",
  nb: "Norvégien Bokmål",
  pl: "Polonais",
  ro: "Roumain",
  sr: "Serbe",
  sk: "Slovaque",
  uk: "Ukrainien",
  vi: "Vietnamien"
}, Gt = {
  en: "Engels",
  es: "Spaans",
  de: "Duits",
  fr: "Frans",
  nl: "Nederlands",
  bg: "Bulgaars",
  pt: "Portugees",
  it: "Italiaans",
  cs: "Tsjechisch",
  da: "Deens",
  et: "Estisch",
  fi: "Fins",
  sv: "Zweeds",
  ka: "Georgisch",
  el: "Grieks",
  zh: "Chinees",
  hr: "Kroatisch",
  hu: "Hongaars",
  id: "Indonesisch",
  hi: "Hindi",
  lt: "Litouws",
  lv: "Lets",
  th: "Thai",
  ms: "Maleis",
  nb: "Noors - Bokmål",
  pl: "Pools",
  ro: "Roemeens",
  sr: "Servisch",
  sk: "Slowaaks",
  uk: "Oekraïens",
  vi: "Vietnamees"
}, Nt = {
  en: "Английски",
  es: "Испански",
  de: "Немски",
  fr: "Френски",
  nl: "Нидерландски",
  bg: "Български",
  pt: "Португалски",
  it: "Италиански",
  cs: "Чешки",
  da: "Датски",
  et: "Естонски",
  fi: "Фински",
  sv: "Шведски",
  ka: "Грузински",
  el: "Гръцки",
  zh: "Китайски",
  hr: "Хърватски",
  hu: "Унгарски",
  id: "Индонезийски",
  hi: "Хинди",
  lt: "Литовски",
  lv: "Латвийски",
  th: "Тайски",
  ms: "Малайски",
  nb: "Норвежки (букмол)",
  pl: "Полски",
  ro: "Румънски",
  sr: "Сръбски",
  sk: "Словашки",
  uk: "Украински",
  vi: "Виетнамски"
}, Et = {
  en: "Inglês",
  es: "Espanhol",
  de: "Alemão",
  fr: "Francês",
  nl: "Holandês",
  bg: "Búlgaro",
  pt: "Português",
  it: "Italiano",
  cs: "Tcheco",
  da: "Dinamarquês",
  et: "Estoniano",
  fi: "Finlandês",
  sv: "Sueco",
  ka: "Georgiano",
  el: "Grego",
  zh: "Chinês",
  hr: "Croata",
  hu: "Húngaro",
  id: "Indonésio",
  hi: "Híndi",
  lt: "Lituano",
  lv: "Letão",
  th: "Tailandês",
  ms: "Malaio",
  nb: "Bokmål Norueguês",
  pl: "Polonês",
  ro: "Romeno",
  sr: "Sérvio",
  sk: "Eslovaco",
  uk: "Ucraniano",
  vi: "Vietnamita"
}, bt = {
  en: "Inglese",
  es: "Spagnolo",
  de: "Tedesco",
  fr: "Francese",
  nl: "Olandese",
  bg: "Bulgaro",
  pt: "Portoghese",
  it: "Italiano",
  cs: "Ceco",
  da: "Danese",
  et: "Estone",
  fi: "Finlandese",
  sv: "Svedese",
  ka: "Georgiano",
  el: "Greco",
  zh: "Cinese",
  hr: "Croato",
  hu: "Ungherese",
  id: "Indonesiano",
  hi: "Hindi",
  lt: "Lituano",
  lv: "Lettone",
  th: "Thailandese",
  ms: "Malese",
  nb: "Norvegese Bokmål",
  pl: "Polacco",
  ro: "Rumeno",
  sr: "Serbo",
  sk: "Slovacco",
  uk: "Ucraino",
  vi: "Vietnamita"
}, kt = {
  en: "Angličtina",
  es: "Španělština",
  de: "Němčina",
  fr: "Francouzština",
  nl: "Nizozemština",
  bg: "Bulharština",
  pt: "Portugalština",
  it: "Italština",
  cs: "Čeština",
  da: "Dánština",
  et: "Estonština",
  fi: "Finština",
  sv: "Švédština",
  ka: "Gruzínština",
  el: "Řečtina",
  zh: "Čínština",
  hr: "Chorvatština",
  hu: "Maďarština",
  id: "Indonéština",
  hi: "Hindština",
  lt: "Litevština",
  lv: "Lotyština",
  th: "Thajština",
  ms: "Malajština",
  nb: "Norština (bokmål)",
  pl: "Polština",
  ro: "Rumunština",
  sr: "Srbština",
  sk: "Slovenština",
  uk: "Ukrajinština",
  vi: "Vietnamština"
}, Kt = {
  en: "Engelsk",
  es: "Spansk",
  de: "Tysk",
  fr: "Fransk",
  nl: "Nederlandsk",
  bg: "Bulgarsk",
  pt: "Portugisisk",
  it: "Italiensk",
  cs: "Tjekkisk",
  da: "Dansk",
  et: "Estisk",
  fi: "Finsk",
  sv: "Svensk",
  ka: "Georgisk",
  el: "Græsk",
  zh: "Kinesisk",
  hr: "Kroatisk",
  hu: "Ungarsk",
  id: "Indonesisk",
  hi: "Hindi",
  lt: "Litauisk",
  lv: "Lettisk",
  th: "Thai",
  ms: "Malajisk",
  nb: "Bokmål",
  pl: "Polsk",
  ro: "Rumænsk",
  sr: "Serbisk",
  sk: "Slovakisk",
  uk: "Ukrainsk",
  vi: "Vietnamesisk"
}, It = {
  en: "Inglise",
  es: "Hispaania",
  de: "Saksa",
  fr: "Prantsuse",
  nl: "Hollandi",
  bg: "Bulgaaria",
  pt: "Portugali",
  it: "Itaalia",
  cs: "Tšehhi",
  da: "Taani",
  et: "Eesti",
  fi: "Soome",
  sv: "Rootsi",
  ka: "Gruusia",
  el: "Kreeka",
  zh: "Hiina",
  hr: "Horvaadi",
  hu: "Ungari",
  id: "Indoneesia",
  hi: "Hindi",
  lt: "Leedu",
  lv: "Läti",
  th: "Tai",
  ms: "Malai",
  nb: "Norra Bokmål",
  pl: "Poola",
  ro: "Rumeenia",
  sr: "Serbia",
  sk: "Slovaki",
  uk: "Ukraina",
  vi: "Vietnami"
}, Pt = {
  en: "Englanti",
  es: "Espanja",
  de: "Saksa",
  fr: "Ranska",
  nl: "Hollanti",
  bg: "Bulgaria",
  pt: "Portugali",
  it: "Italia",
  cs: "Tšekki",
  da: "Tanska",
  et: "Viro",
  fi: "Suomi",
  sv: "Ruotsi",
  ka: "Georgia",
  el: "Kreikka",
  zh: "Kiina",
  hr: "Kroatia",
  hu: "Unkari",
  id: "Indonesia",
  hi: "Hindi",
  lt: "Liettua",
  lv: "Latvia",
  th: "Thai",
  ms: "Malaiji",
  nb: "Norjan Bokmål",
  pl: "Puola",
  ro: "Romania",
  sr: "Serbia",
  sk: "Slovakki",
  uk: "Ukraina",
  vi: "Vietnam"
}, Rt = {
  en: "Engelska",
  es: "Spanska",
  de: "Tyska",
  fr: "Franska",
  nl: "Nederländska",
  bg: "Bulgariska",
  pt: "Portugisiska",
  it: "Italienska",
  cs: "Tjeckiska",
  da: "Danska",
  et: "Estniska",
  fi: "Finska",
  sv: "Svenska",
  ka: "Georgiska",
  el: "Grekiska",
  zh: "Kinesiska",
  hr: "Kroatiska",
  hu: "Ungerska",
  id: "Indonesiska",
  hi: "Hindi",
  lt: "Litauiska",
  lv: "Lettiska",
  th: "Thailändska",
  ms: "Malajiska",
  nb: "Norskt Bokmål",
  pl: "Polska",
  ro: "Rumänska",
  sr: "Serbiska",
  sk: "Slovakiska",
  uk: "Ukrainska",
  vi: "Vietnamesiska"
}, Dt = {
  en: "Ინგლისური",
  es: "Ესპანური",
  de: "Გერმანული",
  fr: "Ფრანგული",
  nl: "Ნიდერლანდური",
  bg: "Ბულგარული",
  pt: "Პორტუგალიური",
  it: "Იტალიური",
  cs: "Ჩეხური",
  da: "Დანიური",
  et: "Ესტონური",
  fi: "Ფინური",
  sv: "Შვედური",
  ka: "Ქართული",
  el: "Ბერძნული",
  zh: "Ჩინური",
  hr: "Ხორვატული",
  hu: "Უნგრული",
  id: "Ინდონეზიური",
  hi: "Ჰინდი",
  lt: "Ლიეტუვური",
  lv: "Ლატვიური",
  th: "Ტაილანდური",
  ms: "Მალაიური",
  nb: "Ნორვეგიული Ბუკმოლი",
  pl: "Პოლონური",
  ro: "Რუმინული",
  sr: "Სერბული",
  sk: "Სლოვაკური",
  uk: "Უკრაინული",
  vi: "Ვიეტნამური"
}, ft = {
  en: "Αγγλικά",
  es: "Ισπανικά",
  de: "Γερμανικά",
  fr: "Γαλλικά",
  nl: "Ολλανδικά",
  bg: "Βουλγαρικά",
  pt: "Πορτογαλικά",
  it: "Ιταλικά",
  cs: "Τσεχικά",
  da: "Δανικά",
  et: "Εσθονικά",
  fi: "Φινλανδικά",
  sv: "Σουηδικά",
  ka: "Γεωργιανά",
  el: "Ελληνικά",
  zh: "Κινεζικά",
  hr: "Κροατικά",
  hu: "Ουγγρικά",
  id: "Ινδονησιακά",
  hi: "Χίντι",
  lt: "Λιθουανικά",
  lv: "Λετονικά",
  th: "Ταϊλανδικά",
  ms: "Μαλαισιανά",
  nb: "Νορβηγικά Μποκμάλ",
  pl: "Πολωνικά",
  ro: "Ρουμανικά",
  sr: "Σερβικά",
  sk: "Σλοβακικά",
  uk: "Ουκρανικά",
  vi: "Βιετναμικά"
}, vt = {
  en: "英语",
  es: "西班牙语",
  de: "德语",
  fr: "法语",
  nl: "荷兰语",
  bg: "保加利亚语",
  pt: "葡萄牙语",
  it: "意大利语",
  cs: "捷克语",
  da: "丹麦语",
  et: "爱沙尼亚语",
  fi: "芬兰语",
  sv: "瑞典语",
  ka: "格鲁吉亚语",
  el: "希腊语",
  zh: "中文",
  hr: "克罗地亚语",
  hu: "匈牙利语",
  id: "印度尼西亚语",
  hi: "印地语",
  lt: "立陶宛语",
  lv: "拉脱维亚语",
  th: "泰语",
  ms: "马来语",
  nb: "书面挪威语",
  pl: "波兰语",
  ro: "罗马尼亚语",
  sr: "塞尔维亚语",
  sk: "斯洛伐克语",
  uk: "乌克兰语",
  vi: "越南语"
}, yt = {
  en: "Engleski",
  es: "Španjolski",
  de: "Njemački",
  fr: "Francuski",
  nl: "Nizozemski",
  bg: "Bugarski",
  pt: "Portugalski",
  it: "Talijanski",
  cs: "Češki",
  da: "Danski",
  et: "Estonski",
  fi: "Finski",
  sv: "Švedski",
  ka: "Gruzijski",
  el: "Grčki",
  zh: "Kineski",
  hr: "Hrvatski",
  hu: "Mađarski",
  id: "Indonezijski",
  hi: "Hindski",
  lt: "Litavski",
  lv: "Latvijski",
  th: "Tajlandski",
  ms: "Malajski",
  nb: "Norveški Bokmål",
  pl: "Poljski",
  ro: "Rumunjski",
  sr: "Srpski",
  sk: "Slovački",
  uk: "Ukrajinski",
  vi: "Vijetnamski"
}, Ot = {
  en: "Angol",
  es: "Spanyol",
  de: "Német",
  fr: "Francia",
  nl: "Holland",
  bg: "Bolgár",
  pt: "Portugál",
  it: "Olasz",
  cs: "Cseh",
  da: "Dán",
  et: "Észt",
  fi: "Finn",
  sv: "Svéd",
  ka: "Grúz",
  el: "Görög",
  zh: "Kínai",
  hr: "Horvát",
  hu: "Magyar",
  id: "Indonéz",
  hi: "Hindi",
  lt: "Litván",
  lv: "Lett",
  th: "Thai",
  ms: "Maláj",
  nb: "Norvég (bokmål)",
  pl: "Lengyel",
  ro: "Román",
  sr: "Szerb",
  sk: "Szlovák",
  uk: "Ukrán",
  vi: "Vietnámi"
}, Ut = {
  en: "Inggris",
  es: "Spanyol",
  de: "Jerman",
  fr: "Prancis",
  nl: "Belanda",
  bg: "Bulgaria",
  pt: "Portugis",
  it: "Italia",
  cs: "Cheska",
  da: "Dansk",
  et: "Esti",
  fi: "Suomi",
  sv: "Swedia",
  ka: "Georgia",
  el: "Yunani",
  zh: "Tionghoa",
  hr: "Kroasia",
  hu: "Hungaria",
  id: "Indonesia",
  hi: "Hindi",
  lt: "Lituavi",
  lv: "Latvi",
  th: "Thai",
  ms: "Melayu",
  nb: "Bokmål Norwegia",
  pl: "Polski",
  ro: "Rumania",
  sr: "Serbia",
  sk: "Slovak",
  uk: "Ukraina",
  vi: "Vietnam"
}, Ht = {
  en: "अंग्रेज़ी",
  es: "स्पेनिश",
  de: "जर्मन",
  fr: "फ़्रेंच",
  nl: "डच",
  bg: "बुल्गारियाई",
  pt: "पुर्तगाली",
  it: "इतालवी",
  cs: "चेक",
  da: "डेनिश",
  et: "एस्टोनियाई",
  fi: "फ़िनिश",
  sv: "स्वीडिश",
  ka: "जॉर्जियाई",
  el: "यूनानी",
  zh: "चीनी",
  hr: "क्रोएशियाई",
  hu: "हंगेरियाई",
  id: "इंडोनेशियाई",
  hi: "हिन्दी",
  lt: "लिथुआनियाई",
  lv: "लातवियाई",
  th: "थाई",
  ms: "मलय",
  nb: "नॉर्वेजियाई बोकमाल",
  pl: "पोलिश",
  ro: "रोमानियाई",
  sr: "सर्बियाई",
  sk: "स्लोवाक",
  uk: "यूक्रेनियाई",
  vi: "वियतनामी"
}, Zt = {
  en: "Anglų",
  es: "Ispanų",
  de: "Vokiečių",
  fr: "Prancūzų",
  nl: "Olandų",
  bg: "Bulgarų",
  pt: "Portugalų",
  it: "Italų",
  cs: "Čekų",
  da: "Danų",
  et: "Estų",
  fi: "Suomių",
  sv: "Švedų",
  ka: "Gruzinų",
  el: "Graikų",
  zh: "Kinų",
  hr: "Kroatų",
  hu: "Vengrų",
  id: "Indoneziečių",
  hi: "Hindi",
  lt: "Lietuvių",
  lv: "Latvių",
  th: "Tajų",
  ms: "Malajiečių",
  nb: "Norvegų Bukmolas",
  pl: "Lenkų",
  ro: "Rumunų",
  sr: "Serbų",
  sk: "Slovakų",
  uk: "Ukrainiečių",
  vi: "Vietnamiečių"
}, zt = {
  en: "Angļu",
  es: "Spāņu",
  de: "Vācu",
  fr: "Franču",
  nl: "Holandiešu",
  bg: "Bulgāru",
  pt: "Portugāļu",
  it: "Itāļu",
  cs: "Čehu",
  da: "Dāņu",
  et: "Igauņu",
  fi: "Somu",
  sv: "Zviedru",
  ka: "Gruzīnu",
  el: "Grieķu",
  zh: "Ķīniešu",
  hr: "Horvātu",
  hu: "Ungāru",
  id: "Indonēziešu",
  hi: "Hindi",
  lt: "Lietuviešu",
  lv: "Latviešu",
  th: "Taju",
  ms: "Malajiešu",
  nb: "Norvēģu Bukmols",
  pl: "Poļu",
  ro: "Rumāņu",
  sr: "Serbu",
  sk: "Slovāku",
  uk: "Ukraiņu",
  vi: "Vjetnamiešu"
}, Ft = {
  en: "อังกฤษ",
  es: "สเปน",
  de: "เยอรมัน",
  fr: "ฝรั่งเศส",
  nl: "ดัตช์",
  bg: "บัลแกเรีย",
  pt: "โปรตุเกส",
  it: "อิตาลี",
  cs: "เช็ก",
  da: "เดนมาร์ก",
  et: "เอสโตเนีย",
  fi: "ฟินแลนด์",
  sv: "สวีเดน",
  ka: "จอร์เจีย",
  el: "กรีก",
  zh: "จีน",
  hr: "โครเอเชีย",
  hu: "ฮังการี",
  id: "อินโดนีเซีย",
  hi: "ฮินดี",
  lt: "ลิทัวเนีย",
  lv: "ลัตเวีย",
  th: "ไทย",
  ms: "มาเลย์",
  nb: "นอร์เวย์บุคมอล",
  pl: "โปแลนด์",
  ro: "โรมาเนีย",
  sr: "เซอร์เบีย",
  sk: "สโลวัก",
  uk: "ยูเครน",
  vi: "เวียดนาม"
}, Vt = {
  en: "Inggeris",
  es: "Sepanyol",
  de: "Jerman",
  fr: "Perancis",
  nl: "Belanda",
  bg: "Bulgaria",
  pt: "Portugis",
  it: "Itali",
  cs: "Czech",
  da: "Denmark",
  et: "Estonia",
  fi: "Finland",
  sv: "Sweden",
  ka: "Georgia",
  el: "Greek",
  zh: "Cina",
  hr: "Croatia",
  hu: "Hungary",
  id: "Indonesia",
  hi: "Hindi",
  lt: "Lithuania",
  lv: "Latvia",
  th: "Thai",
  ms: "Melayu",
  nb: "Bokmal Norway",
  pl: "Poland",
  ro: "Romania",
  sr: "Serbia",
  sk: "Slovak",
  uk: "Ukraine",
  vi: "Vietnam"
}, jt = {
  en: "Engelsk",
  es: "Spansk",
  de: "Tysk",
  fr: "Fransk",
  nl: "Nederlandsk",
  bg: "Bulgarsk",
  pt: "Portugisisk",
  it: "Italiensk",
  cs: "Tsjekkisk",
  da: "Dansk",
  et: "Estisk",
  fi: "Finsk",
  sv: "Svensk",
  ka: "Georgisk",
  el: "Gresk",
  zh: "Kinesisk",
  hr: "Kroatisk",
  hu: "Ungarsk",
  id: "Indonesisk",
  hi: "Hindi",
  lt: "Litauisk",
  lv: "Latvisk",
  th: "Thai",
  ms: "Malayisk",
  nb: "Norsk Bokmål",
  pl: "Polsk",
  ro: "Rumensk",
  sr: "Serbisk",
  sk: "Slovakisk",
  uk: "Ukrainsk",
  vi: "Vietnamesisk"
}, wt = {
  en: "Angielski",
  es: "Hiszpański",
  de: "Niemiecki",
  fr: "Francuski",
  nl: "Niderlandzki",
  bg: "Bułgarski",
  pt: "Portugalski",
  it: "Włoski",
  cs: "Czeski",
  da: "Duński",
  et: "Estoński",
  fi: "Fiński",
  sv: "Szwedzki",
  ka: "Gruziński",
  el: "Grecki",
  zh: "Chiński",
  hr: "Chorwacki",
  hu: "Węgierski",
  id: "Indonezyjski",
  hi: "Hindi",
  lt: "Litewski",
  lv: "Łotewski",
  th: "Tajski",
  ms: "Malajski",
  nb: "Norweski (bokmål)",
  pl: "Polski",
  ro: "Rumuński",
  sr: "Serbski",
  sk: "Słowacki",
  uk: "Ukraiński",
  vi: "Wietnamski"
}, Jt = {
  en: "Engleză",
  es: "Spaniolă",
  de: "Germană",
  fr: "Franceză",
  nl: "Neerlandeză",
  bg: "Bulgară",
  pt: "Portugheză",
  it: "Italiană",
  cs: "Cehă",
  da: "Daneză",
  et: "Estonă",
  fi: "Finlandeză",
  sv: "Suedeză",
  ka: "Georgiană",
  el: "Greacă",
  zh: "Chineză",
  hr: "Croată",
  hu: "Maghiară",
  id: "Indoneziană",
  hi: "Hindi",
  lt: "Lituaniană",
  lv: "Letonă",
  th: "Thailandeză",
  ms: "Malaeză",
  nb: "Norvegiană Bokmål",
  pl: "Poloneză",
  ro: "Română",
  sr: "Sârbă",
  sk: "Slovacă",
  uk: "Ucraineană",
  vi: "Vietnameză"
}, Wt = {
  en: "Енглески",
  es: "Шпански",
  de: "Немачки",
  fr: "Француски",
  nl: "Холандски",
  bg: "Бугарски",
  pt: "Португалски",
  it: "Италијански",
  cs: "Чешки",
  da: "Дански",
  et: "Естонски",
  fi: "Фински",
  sv: "Шведски",
  ka: "Грузијски",
  el: "Грчки",
  zh: "Кинески",
  hr: "Хрватски",
  hu: "Мађарски",
  id: "Индонежански",
  hi: "Хинди",
  lt: "Литвански",
  lv: "Летонски",
  th: "Тајски",
  ms: "Малајски",
  nb: "Норвешки Букмол",
  pl: "Пољски",
  ro: "Румунски",
  sr: "Српски",
  sk: "Словачки",
  uk: "Украјински",
  vi: "Вијетнамски"
}, Yt = {
  en: "Angličtina",
  es: "Španielčina",
  de: "Nemčina",
  fr: "Francúzština",
  nl: "Holandčina",
  bg: "Bulharčina",
  pt: "Portugalčina",
  it: "Taliančina",
  cs: "Čeština",
  da: "Dánčina",
  et: "Estónčina",
  fi: "Fínčina",
  sv: "Švédčina",
  ka: "Gruzínčina",
  el: "Gréčtina",
  zh: "Čínština",
  hr: "Chorvátčina",
  hu: "Maďarčina",
  id: "Indonézština",
  hi: "Hindčina",
  lt: "Litovčina",
  lv: "Lotyština",
  th: "Thajčina",
  ms: "Malajčina",
  nb: "Nórčina (bokmal)",
  pl: "Poľština",
  ro: "Rumunčina",
  sr: "Srbčina",
  sk: "Slovenčina",
  uk: "Ukrajinčina",
  vi: "Vietnamčina"
}, xt = {
  en: "Англійська",
  es: "Іспанська",
  de: "Німецька",
  fr: "Французька",
  nl: "Нідерландська",
  bg: "Болгарська",
  pt: "Португальська",
  it: "Італійська",
  cs: "Чеська",
  da: "Данська",
  et: "Естонська",
  fi: "Фінська",
  sv: "Шведська",
  ka: "Грузинська",
  el: "Грецька",
  zh: "Китайська",
  hr: "Хорватська",
  hu: "Угорська",
  id: "Індонезійська",
  hi: "Гінді",
  lt: "Литовська",
  lv: "Латиська",
  th: "Тайська",
  ms: "Малайська",
  nb: "Норвезька (букмол)",
  pl: "Польська",
  ro: "Румунська",
  sr: "Сербська",
  sk: "Словацька",
  uk: "Українська",
  vi: "Вʼєтнамська"
}, _t = {
  en: "Tiếng Anh",
  es: "Tiếng Tây Ban Nha",
  de: "Tiếng Đức",
  fr: "Tiếng Pháp",
  nl: "Tiếng Hà Lan",
  bg: "Tiếng Bulgaria",
  pt: "Tiếng Bồ Đào Nha",
  it: "Tiếng Italy",
  cs: "Tiếng Séc",
  da: "Tiếng Đan Mạch",
  et: "Tiếng Estonia",
  fi: "Tiếng Phần Lan",
  sv: "Tiếng Thụy Điển",
  ka: "Tiếng Georgia",
  el: "Tiếng Hy Lạp",
  zh: "Tiếng Trung",
  hr: "Tiếng Croatia",
  hu: "Tiếng Hungary",
  id: "Tiếng Indonesia",
  hi: "Tiếng Hindi",
  lt: "Tiếng Litva",
  lv: "Tiếng Latvia",
  th: "Tiếng Thái",
  ms: "Tiếng Mã Lai",
  nb: "Tiếng Na Uy (Bokmål)",
  pl: "Tiếng Ba Lan",
  ro: "Tiếng Romania",
  sr: "Tiếng Serbia",
  sk: "Tiếng Slovak",
  uk: "Tiếng Ukraina",
  vi: "Tiếng Việt"
}, qt = {
  en: ht,
  es: Bt,
  de: Tt,
  fr: pt,
  nl: Gt,
  bg: Nt,
  pt: Et,
  it: bt,
  cs: kt,
  da: Kt,
  et: It,
  fi: Pt,
  sv: Rt,
  ka: Dt,
  el: ft,
  "zh-HK": {
    en: "英文",
    es: "西班牙文",
    de: "德文",
    fr: "法文",
    nl: "荷蘭文",
    bg: "保加利亞文",
    pt: "葡萄牙文",
    it: "意大利文",
    cs: "捷克文",
    da: "丹麥文",
    et: "愛沙尼亞文",
    fi: "芬蘭文",
    sv: "瑞典文",
    ka: "格魯吉亞文",
    el: "希臘文",
    zh: "中文",
    hr: "克羅地亞文",
    hu: "匈牙利文",
    id: "印尼文",
    hi: "印地文",
    lt: "立陶宛文",
    lv: "拉脫維亞文",
    th: "泰文",
    ms: "馬來文",
    nb: "巴克摩挪威文",
    pl: "波蘭文",
    ro: "羅馬尼亞文",
    sr: "塞爾維亞文",
    sk: "斯洛伐克文",
    uk: "烏克蘭文",
    vi: "越南文"
  },
  zh: vt,
  hr: yt,
  hu: Ot,
  id: Ut,
  hi: Ht,
  lt: Zt,
  lv: zt,
  th: Ft,
  ms: Vt,
  nb: jt,
  pl: wt,
  ro: Jt,
  sr: Wt,
  sk: Yt,
  uk: xt,
  vi: _t
}, Fa = /[-_]/, Qt = "-", p = qt, b = Ct, Xt = Ds, Va = Zs, I = JSON.parse(JSON.stringify(Ps)), la = {};
let da = {}, U = null, ma = !1;
function P(i) {
  const { countryCode: r } = L(i);
  if (!r)
    return {};
  let o;
  return la.hasOwnProperty(r) ? o = la[r] : (o = zn({}, I.DEFAULT, I[r]), la[r] = o), o;
}
function $t(i) {
  var M;
  const { countryCode: r } = L(i), o = P(r);
  let { betaLanguages: t, supportedLanguages: u } = o;
  return ma || (u = u == null ? void 0 : u.filter((h) => !(t != null && t.includes(h)))), {
    defaultLanguage: H({ countryCode: r }, o.defaultLanguage),
    supportedLanguages: eu(u, r),
    addressFieldsSortOrder: o.addressFieldsSortOrder,
    promotionalMerchants: o.promotionalMerchants,
    customerSupportEmail: o.customerSupportEmail,
    customerSupportPhoneNumber: o.customerSupportPhoneNumber,
    consumer: o.rules.consumer,
    address: o.rules.address,
    billingAddressFormat: (M = o.genericSettings) == null ? void 0 : M.billingAddressFormat
  };
}
function au(i = []) {
  return i.map((r) => r.substring(0, 2));
}
function eu(i, r) {
  if (!i || !r)
    return [];
  const o = i.map((u) => H({ countryCode: r }, u)), t = new Set(o);
  return Array.from(t);
}
function H(i, r) {
  let { countryCode: o, languageCode: t, separator: u } = { ...L(r), ...i };
  u = u || Qt;
  const M = t == null ? void 0 : t.substring(0, 2).toLowerCase(), h = o == null ? void 0 : o.toUpperCase();
  return [M, h].filter(Boolean).join(u);
}
function L(i) {
  let r, o;
  return i && (i.length > 2 ? [r, o] = i.split(Fa) : i.toLowerCase() === i ? r = i : i.toUpperCase() === i && (o = i)), o && (o = o.toUpperCase()), { languageCode: r, countryCode: o };
}
function ja(i, r) {
  return i.sort((o, t) => o[r] > t[r] ? 1 : t[r] > o[r] ? -1 : 0);
}
function Sa(i) {
  ma = i;
}
function wa() {
  if (U)
    return U;
  U = {};
  for (const i in I) {
    const r = P(i);
    Array.isArray(r.features) && (U[i] = r.features);
  }
  return U;
}
function nu() {
  return Object.keys(I).sort().filter((r) => _(r));
}
function _(i) {
  const { beta: r, showInLocaleSelector: o } = P(i);
  return ma ? !!o : !!(o && !r);
}
function iu(i) {
  const { countryCode: r } = L(i);
  return !!r && Xt.hasOwnProperty(r);
}
function ga(i) {
  const { countryCode: r } = L(i);
  return !!r && Va.hasOwnProperty(r);
}
function ru(i) {
  const { countryCode: r } = L(i);
  return !!r && b.en.hasOwnProperty(r);
}
function ou(i, r) {
  const o = wa(), { countryCode: t } = L(r), u = t && o[t];
  return !!u && u.includes(i);
}
function su(i, r = !0) {
  const { languageCode: o, countryCode: t } = L(i);
  if (r && !_(t))
    return !1;
  const { supportedLanguages: u } = P(t);
  return !!o && au(u).includes(o);
}
function tu(i, r = !0) {
  const { countryCode: o } = L(i), t = r && !_(o);
  return !o || t ? void 0 : $t(o);
}
function q(i) {
  return i && p.hasOwnProperty(i) ? i : L(i).languageCode;
}
function uu(i, r) {
  const o = q(i);
  if (!o || !p.hasOwnProperty(o))
    return [];
  Array.isArray(r) || (r = Object.keys(p[o]));
  const t = [];
  for (const u of r) {
    const M = u.substring(0, 2);
    p[o][M] && t.push({
      value: u,
      label: p[o][M],
      // only add subtext if it differs from label
      ...o !== M && { subtext: p[M][M] }
    });
  }
  return ja(t, "label");
}
function lu(i, r = "en") {
  const { languageCode: o } = L(i), t = q(r);
  let u;
  return t && p.hasOwnProperty(t) && o && (u = p[t][o]), u;
}
function du(i = "en", r = "en") {
  const { countryCode: o } = L(i);
  if (!o)
    return;
  const t = q(r);
  let u;
  return ga(o) ? u = Va[o] : t && b.hasOwnProperty(t) && (u = b[t][o]), u;
}
function mu(i, r = []) {
  const o = q(i);
  if (!o || !b.hasOwnProperty(o))
    return [];
  Array.isArray(r) && (r = r.filter((u) => b[o][u])), (!Array.isArray(r) || r.length === 0) && (r = Object.keys(b[o]));
  const t = r.map((u) => ({
    value: u,
    label: b[o][u]
  }));
  return ja(t, "label");
}
function Su(i) {
  const r = i ? { default: [i] } : {};
  for (const o in I) {
    const { supportedLanguages: t } = P(o);
    t && t.forEach((u) => {
      if (u.length > 2) {
        const [M] = u.split(Fa), h = H({ countryCode: o, languageCode: M });
        h !== u && (r[h] = [u]);
      }
    });
  }
  return r;
}
function gu(i, r, o) {
  if (!i || i.length < 5)
    return null;
  let t = H({ separator: r }, i);
  return typeof o == "function" && (t = o.call(t, t)), t;
}
function ca() {
  if (Object.keys(da).length > 0)
    return da;
  const i = {};
  for (const r in I)
    r === "DEFAULT" || ga(r) || (i[r] = Ja(r));
  return da = i, i;
}
function Ja(i) {
  const { rules: r } = P(i), { phoneCode: o, phoneNumber: t } = r.consumer, u = {};
  if (o && (u.code = o), t) {
    const { mask: M, minimumLength: h, noLeadingNumber: R } = t;
    u.mask = M, u.min = h, R && (u.noLeadingNumber = R);
  }
  return u;
}
function Wa(i, r) {
  const { countryCode: o } = L(r), t = ca();
  if (i === "1")
    return o && t[o].code === "1" ? o : "US";
  for (const u in t)
    if (t[u].code === i)
      return u;
  return o;
}
function cu(i, r) {
  typeof i == "number" && (i = String(i));
  const { countryCode: o } = L(r), t = Wa(i, o), u = ca();
  return t && u[t] && u[t].mask || null;
}
function Mu({ transactionAmount: i, transactionCurrencyCode: r } = {
  transactionAmount: "",
  transactionCurrencyCode: ""
}, o) {
  const t = typeof i == "string" ? parseFloat(i) : i;
  if (t)
    try {
      const M = zs[r] || r;
      return t.toLocaleString(o, {
        style: "currency",
        currency: M
      });
    } catch {
      return t.toFixed(2);
    }
  return "";
}
const Ya = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  composeLocaleFromParts: H,
  enableBetaCountries: Sa,
  formatLocale: gu,
  getCountryConfig: tu,
  getCountryFeatures: wa,
  getCountryName: du,
  getCountryPhoneConfig: Ja,
  getFallbackConfig: Su,
  getLanguageName: lu,
  getLiveCountries: nu,
  getLocaleParts: L,
  getLocalizedAmount: Mu,
  getPhoneCountryISO: Wa,
  getPhoneMaskingRule: cu,
  getPhonesConfig: ca,
  getTranslatedCountries: mu,
  getTranslatedLanguages: uu,
  isCountryFeatureEnabled: ou,
  isCountryLive: _,
  isCountryRestricted: iu,
  isCountrySanctioned: ga,
  isCountrySupported: ru,
  isLocaleSupported: su
}, Symbol.toStringTag, { value: "Module" })), Lu = {
  bg: "bg-BG",
  cs: "cs-CZ",
  de: "de-DE",
  el: "el-GR",
  en: "en-US",
  // es-LA used to represent Latin American Spanish
  es: "es-LA",
  et: "et-EE",
  fi: "fi-FI",
  fr: "fr-FR",
  hr: "hr-HR",
  hu: "hu-HU",
  id: "id-ID",
  it: "it-IT",
  ka: "ka-GE",
  lt: "lt-LT",
  lv: "lv-LV",
  ms: "ms-MY",
  nb: "nb-NO",
  nl: "nl-NL",
  pl: "pl-PL",
  pt: "pt-BR",
  ro: "ro-RO",
  ru: "ru-BY",
  sk: "sk-SK",
  sr: "sr-RS",
  sv: "sv-SE",
  th: "th-TH",
  uk: "uk-UA",
  vn: "vi-VN",
  zh: "zh-HK"
}, Au = Symbol("i18nDataKey"), Cu = {
  install(i, { betaCountries: r } = {}) {
    typeof r == "boolean" && Sa(r), i.config.globalProperties.$i18nData = { ...Ya };
  }
}, hu = {
  install(i, { betaCountries: r } = {}) {
    typeof r == "boolean" && Sa(r), i.prototype.$i18nData || Object.defineProperty(i.prototype, "$i18nData", {
      value: { ...Ya }
    });
  }
};
export {
  H as composeLocaleFromParts,
  Sa as enableBetaCountries,
  gu as formatLocale,
  tu as getCountryConfig,
  wa as getCountryFeatures,
  du as getCountryName,
  Ja as getCountryPhoneConfig,
  Su as getFallbackConfig,
  lu as getLanguageName,
  nu as getLiveCountries,
  L as getLocaleParts,
  Mu as getLocalizedAmount,
  Wa as getPhoneCountryISO,
  cu as getPhoneMaskingRule,
  ca as getPhonesConfig,
  mu as getTranslatedCountries,
  uu as getTranslatedLanguages,
  Au as i18nDataKey,
  ou as isCountryFeatureEnabled,
  _ as isCountryLive,
  iu as isCountryRestricted,
  ga as isCountrySanctioned,
  ru as isCountrySupported,
  su as isLocaleSupported,
  Lu as languageDefaultLocales,
  Cu as plugin,
  hu as pluginVue2
};
//# sourceMappingURL=index.js.map
